export default {
  common: {
    noFace: 'কোনো মুখ নেই',
    noPermissionTip: 'এই বৈশিষ্ট্যটি ব্যবহার করতে আপনার অনুমতি নেই। অনুমতি কেনা বা পুনরায় করা আগে চালিয়ে যান।',
    selected: 'নির্বাচিত',
    continue: 'চালিয়ে যান',
    open1: 'খুলুন',
    doubleClick: 'ডাবল ক্লিক করুন',
    inputKeywordSearch: 'কীওয়ার্ড লিখে অনুসন্ধান করুন',
    inputKeywordStartSearch: 'অনুসন্ধান শুরু করতে কীওয়ার্ড লিখুন',
    searchHistory: 'অনুসন্ধানের ইতিহাস',
    clearHistory: 'ইতিহাস মুছুন',
    notFoundRelatedResults: 'সম্পর্কিত ফলাফল পাওয়া যায়নি',
    switch: 'পরিবর্তন করুন',
    searchProductionLine: 'উৎপাদন লাইন',
    selectProductionLine: 'উৎপাদন লাইন নির্বাচন করুন',
    rotateAngleTip: '{angle} ঘুরান',
    plankText: 'বোর্ড',
    sendToEzSort: 'EzSort এ পাঠান',
    downloadEzSort: 'EzSort ডাউনলোড করুন',
    notDownloadTip: 'EzSort স্বাভাবিকভাবে খুলতে না পারলে ডাউনলোড না করার কারণ হতে পারে। EzSort ডাউনলোড করতে নিচের বোতামে ক্লিক করুন',
    updateTip: 'সফটওয়্যার আপডেট পাওয়া গেছে, Guigui পুনরায় চালু করুন!',
    betaTest: 'বেটা পরীক্ষার সময় বিনামূল্যে',
    ersortSpecail: 'কালার লেবেলের জন্য একচেটিয়া',
    exclusiveFeature: 'এক্সক্লুসিভ ফিচার',
    elementCanBeDragTip: 'উপাদানটি টেনে নেওয়া যাবে',
    checkPlankIsConflict: 'বোর্ডের অবস্থা পরীক্ষা করা হচ্ছে',
    preferenceSaveErr: 'পছন্দ সংরক্ষণে ত্রুটি',
    guimen: 'আলমারির দরজা',
    preferenceLoadTip: 'আপনার পছন্দ লোড হচ্ছে',
    preferenceLoadErrTip: 'পছন্দ লোড ব্যর্থ হয়েছে, পুনরায় চেষ্টা করুন এবং পছন্দ সেটিং ভুল না হওয়ার জন্য রিফ্রেশ করুন!',
    localFileIsBeingWrite: 'স্থানীয় ফাইল লেখা হচ্ছে',
    taskMonitor: 'কাজ পর্যবেক্ষণ',
    downloadByType: '{type} ডাউনলোড করুন',
    slotKnifeErr: 'স্লটের নির্দিষ্ট প্রক্রিয়াকরণ সরঞ্জাম অনুপস্থিত, উৎপাদন লাইন সেটিংস পরীক্ষা করুন! 【{msg}】',
    anewChooseCatalog: 'ডিরেক্টরি পুনরায় নির্বাচন করুন',
    downloadSetting: 'ডাউনলোড সেটিংস',
    attention: 'মনোযোগ',
    unit: 'টুকরা',
    defaultUse: 'ডিফল্ট ব্যবহার',
    defaultChooseUse: 'ডিফল্ট নির্বাচন',
    requestFail: 'অনুরোধ ব্যর্থ হয়েছে',
    downloadDoneByType: '{type} ডাউনলোড সম্পন্ন হয়েছে',
    sysTip: 'সিস্টেম বিজ্ঞপ্তি',
    pleaseChoose: 'দয়া করে নির্বাচন করুন',
    confirmDelete: 'মুছে ফেলার বিষয়টি নিশ্চিত করুন',
    notDataTipByType: 'এখনো কোনো ডেটা নেই, প্রথমে {msg} করুন',
    paginationTotalTip: '{current}-{page} টি / মোট {total} টি',
    chooseAmountData: '{number} টি ডেটা নির্বাচিত',
    moreOperate: 'আরও',
    transferByType: '{type} স্থানান্তর করুন',
    clickCopy: '{type} কপি করতে ক্লিক করুন',
    currentLine: 'বর্তমান লাইন',
    remark: 'মন্তব্য',
    customFunction: 'কাস্টম ফাংশন',
    limitedTimeTrial: 'Limited Free',
    startDate: 'শুরুর তারিখ',
    endDate: 'শেষ তারিখ',
    startTime: 'শুরুর সময়',
    endTime: 'শেষ সময়',
    lastMonth: 'গত এক মাস',
    lastSixMonth: 'গত ছয় মাস',
    lastYear: 'গত এক বছর',
    searchByType: 'অনুসন্ধানের জন্য {type} লিখুন',
    addTime: 'সময় যোগ করুন',
    startArrange: 'টাইপসেটিং শুরু করুন',
    select: 'নির্বাচন করুন',
    search: 'অনুসন্ধান করুন',
    name: 'নাম',
    plankNo: 'বোর্ড নম্বর',
    plankName: 'বোর্ডের নাম',
    orderNo: 'অর্ডার নম্বর',
    order: 'অর্ডার',
    partNameWithoutRoomCabinet: 'বোর্ডের নাম (ঘর/ক্যাবিনেট ছাড়া)',
    plankRemark: 'বোর্ডের মন্তব্য',
    room: 'ঘর',
    orderAddress: 'প্রকল্পের ঠিকানা',
    matCode: 'উপকরণ কোড',
    matCode2: 'উপকরণ',
    plankMatCode: 'বোর্ডের উপকরণ',
    count: 'পরিমাণ',
    customer: 'গ্রাহক',
    customerInfo: 'গ্রাহকের তথ্য',
    factoryOrderNo: 'কারখানার অর্ডার নম্বর',
    roomName: 'ঘরের নাম',
    color: 'রঙ',
    plankColor: 'বোর্ডের রঙ',
    plankThick: 'বোর্ডের পুরুত্ব',
    plankHighGloss: 'হাইলাইট বৈশিষ্ট্য',
    thick: 'পুরুত্ব',
    front: 'সামনের দিক',
    back: 'পিছনের দিক',
    slot: 'স্লট',
    hole: 'গর্ত',
    hsInfo: '{hole} গর্ত {slot} স্লট',
    diameter: 'ব্যাস',
    finishedWidth: 'সম্পন্ন পণ্যের প্রস্থ',
    finishedHeight: 'সম্পন্ন পণ্যের দৈর্ঘ্য',
    finishedArea: 'সম্পন্ন পণ্যের ক্ষেত্রফল (㎡)',
    remarks: 'মন্তব্য',
    remark1: 'মন্তব্য 1',
    remark2: 'মন্তব্য 2',
    remark3: 'মন্তব্য 3',
    remark4: 'মন্তব্য 4',
    remark5: 'মন্তব্য 5',
    remark6: 'মন্তব্য 6',
    remark7: 'মন্তব্য 7',
    remark8: 'মন্তব্য 8',
    remark9: 'মন্তব্য 9',
    remark10: 'মন্তব্য 10',
    remark11: 'মন্তব্য 11',
    remark12: 'মন্তব্য 12',
    remark13: 'মন্তব্য 13',
    remark14: 'মন্তব্য 14',
    remark15: 'মন্তব্য 15',
    remark16: 'মন্তব্য 16',
    texture: 'টেক্সচার',
    normal: 'উল্লম্ব টেক্সচার',
    reverse: 'অনুভূমিক টেক্সচার',
    notCare: 'কোনো টেক্সচার নেই',
    holeSlotsStastic: 'গর্ত ও স্লটের পরিমাণ',
    edge: {
      title: 'প্রান্ত সিলিং',
      info: 'প্রান্ত সিলিং তথ্য',
      front: 'সামনের প্রান্ত সিলিং',
      back: 'পিছনের প্রান্ত সিলিং',
      left: 'বাম প্রান্ত সিলিং',
      right: 'ডান প্রান্ত সিলিং',
      up: 'উপরের প্রান্ত সিলিং',
      down: 'নিচের প্রান্ত সিলিং'
      },
    isSpecial: 'অনিয়মিত আকৃতি',
    notSpecial: 'সাধারণ আকৃতি',
    textOfDoorPlank: 'দরজার বোর্ড',
    textOfNotDoorPlank: 'নন-দরজা বোর্ড',
    isDoorPlank: 'দরজার বোর্ড',
    notDoorPlank: 'দরজার বোর্ড নয়',
    width: 'প্রস্থ',
    long: 'দৈর্ঘ্য',
    plankWidth: 'বোর্ডের প্রস্থ',
    plankHeight: 'বোর্ডের দৈর্ঘ্য',
    shortLong: 'ছোট দিকের দৈর্ঘ্য',
    shortWidth: 'ছোট দিকের প্রস্থ',
    plankShape: 'বোর্ডের আকৃতি',
    detail: 'বিস্তারিত',
    cancel: 'বাতিল করুন',
    confirm: 'নিশ্চিত করুন',
    alreadyKnow: 'আমি ইতিমধ্যে জানি',
    Noprompts: 'আর প্রম্পট নয়',
    deep: 'গভীরতা',
    other: 'অন্যান্য',
    heighGloss: 'হাই গ্লস',
    heighGlossPlank: 'হাই গ্লস বোর্ড',
    heighGlossSide: 'হাই গ্লস বোর্ড',
    notHeighGloss: 'হাই গ্লস নয়',
    notHeighGlossPlank: 'হাই গ্লস বোর্ড নয়',
    saveSuccess: 'সফলভাবে সংরক্ষিত',
    deleteSuccess: 'সফলভাবে মুছা হয়েছে',
    addSuccess: 'সফলভাবে যোগ করা হয়েছে',
    editSuccess: 'সফলভাবে সম্পাদনা করা হয়েছে',
    engraving: 'খোদাই মেশিন',
    electronicSaw: 'ইলেকট্রনিক করাত',
    glassEquip: 'কাচ কাটার মেশিন',
    labelingMachine: 'লেবেলিং মেশিন',
    copy: 'কপি করুন',
    paste: 'পেস্ট করুন',
    undo: 'পূর্বাবস্থায় ফেরান',
    move: 'সরান',
    PTP: 'PTP',
    dock56FDrill: 'পাঁচ/ছয় দিকের ড্রিল মেশিন',
    sideHoleDrill: 'পার্শ্ব গর্ত ড্রিল মেশিন',
    combination: 'সমন্বিত যন্ত্রপাতি',
    integration: 'অল-ইন-ওয়ান মেশিন',
    standardPlank: 'আদর্শ বড় বোর্ড',
    standardMaterial: 'আদর্শ উপকরণ',
    standardMaterialTip: 'নোট: বড় বোর্ডের তথ্য সমন্বয় সম্পন্ন করার পর, ক্যাবিনেট লেআউট উৎপাদন ব্যবহারকারীদের সর্বশেষ পরিবর্তন প্রয়োগ করতে ক্যাবিনেট ক্লায়েন্ট পুনরায় চালু করতে হবে!',
    specialMaterial: 'বিশেষ উপকরণ',
    specialPlank: 'বিশেষ বড় বোর্ড',
    singlePlank: 'একমুখী বোর্ড',
    previous: 'পূর্ববর্তী',
    plankInfo: 'বড় বোর্ডের বিস্তারিত',
    moreResult: 'আরও লেআউট সমাধান',
    moreResultTip: 'বড় বোর্ডে প্রান্ত প্রক্রিয়াকরণের স্লট আছে, তাই বড় বোর্ড পুনরায় লেআউটে অংশগ্রহণ করবে না',
    ok: 'নিশ্চিত করুন',
    dispersePaibanTip: 'কিছু বড় বোর্ড বিতরণ করে লেআউট করা সম্ভব নয়, আপনি ম্যানুয়ালি সামঞ্জস্য করতে বা লেআউট পরিকল্পনা পরিবর্তন করতে পারেন!',
    next: 'পরবর্তী',
    rate: 'ব্যবহারের হার',
    paibanBatch: 'লেআউট ব্যাচ',
    return: 'ফিরে যান',
    FGNo: 'চুক্তি নম্বর',
    refresh: 'রিফ্রেশ করুন',
    inde: 'ক্রমিক নম্বর',
    productionLine: 'উৎপাদন লাইন',
    operation: 'অপারেশন',
    colorPlaceHolder: 'রঙের কার্ড তৈরি করতে Enter চাপুন',
    saveAndContinue: 'সংরক্ষণ করুন এবং অব্যাহত রাখুন',
    reset: 'রিসেট করুন',
    check: 'অনুসন্ধান করুন',
    inputPlaceholder: 'দয়া করে লিখুন',
    filter: 'ফিল্টার করুন',
    all: 'সব',
    exportPDF: 'PDF রপ্তানি করুন',
    exportPic: 'ছবি রপ্তানি করুন',
    add: 'যোগ করুন',
    edit: 'সম্পাদনা করুন',
    delete: 'মুছুন',
    restore: 'পুনরুদ্ধার করুন',
    save: 'সংরক্ষণ করুন',
    saveSetting: 'সেটিংস সংরক্ষণ করুন',
    isHeightGloss: 'হাই গ্লস বোর্ড কিনা নির্বাচন করুন',
    noSync: 'সিঙ্ক নয়',
    sync: 'সিঙ্ক করুন',
    formatSuccess: '{type} সফল',
    dataLoading: 'ডেটা লোড হচ্ছে......',
    warmTip: 'বন্ধুত্বপূর্ণ অনুস্মারক',
    importantTip: 'গুরুত্বপূর্ণ অনুস্মারক',
    wellcome: 'ক্লাউড টাইপসেটিং-এ স্বাগতম',
    timeOut: 'লেআউট টাইমআউট হয়েছে, পুনরায় লেআউট করবেন কি?',
    notSawKnifeTip: 'সতর্কতা: করাত কাটার মেশিনে "ক্রস-কাট ব্লেড" সেট করা হয়নি যার ফলে লেআউট করা যাচ্ছে না, যোগ করতে যান!',
    doorFrameKnifeRadiusErr: 'আপনি "করাত কাটার খোদাই মেশিন-ডোর ফ্রেম কাটিং" ফিচার চালু করেছেন। কাটিং ব্লেডের ব্যাসার্ধ করাতের 두께보다 বড়, লেআউট করা যাচ্ছে না!',
    doorFrameIrregularPlankErr: 'আপনি "করাত কাটার খোদাই মেশিন-ডোর ফ্রেম কাটিং" ফিচার চালু করেছেন। এই ফিচারটি এখনও অ-reguler প্যানেল লেআউট সমর্থন করে না!',
    warning: 'সতর্কতা',
    export: 'রপ্তানি করুন',
    mark: 'চিহ্নিত করুন',
    noMark: 'চিহ্নিত করবেন না',
    sawArrange: 'করাত লেআউট',
    directArrange: 'সরাসরি লেআউট',
    area: 'এলাকা',
    plankNum: 'বোর্ড বারকোড',
    loc: 'ক্যাবিনেট',
    cutHeight: 'কাটার দৈর্ঘ্য',
    cutWidth: 'কাটার প্রস্থ',
    defaultProduction: 'ডিফল্ট উৎপাদন লাইন',
    surplusNum: 'উদ্বৃত্ত বারকোড',
    tip: 'টিপস',
    history: 'ইতিহাস রেকর্ড',
    hinge: 'কব্জার গর্ত',
    hingeScrew: 'কব্জার দরজার বোর্ডের পাইলট গর্ত',
    CCPXHole: 'তিন-ইন-ওয়ান এক্সেন্ট্রিক গর্ত',
    stretchHinge: 'স্ট্রেইটনার স্লট এবং কব্জার কাপ গর্ত',
    stretch: 'স্ট্রেইটনার',
    stretcher: 'স্ট্রেইটনার স্লট',
    eccHole: 'এক্সেন্ট্রিক গর্ত',
    preHole: 'পূর্ব-এমবেডেড গর্ত',
    clothole: 'পোশাক রড গর্ত',
    backPlank: 'ব্যাকবোর্ড স্লট',
    ALS: 'হিডেন পুল স্লট',
    doorSlot: 'দরজার মেটাল স্লট',
    drawerSlot: 'ড্রয়ারের মেটাল স্লট',
    lkSlot: 'লক স্লট',
    KC: 'ট্রাউজার ড্রয়ার গর্ত',
    stealth: 'অদৃশ্য উপাদান',
    lightSlot: 'লাইট স্লট',
    ConventionalHole: 'প্রচলিত গর্ত',
    Keyhole: 'চাবির গর্ত',
    allHole: 'বিশেষ আকৃতির বোর্ডের সমস্ত গর্ত',
    allSlot: 'বিশেষ আকৃতির বোর্ডের সমস্ত স্লট',
    freedomAllHoleSlot: 'বিশেষ আকৃতির বোর্ডের সমস্ত গর্ত এবং স্লট',
    freedomAllHoleSlotTip: 'বিশেষ আকৃতির বোর্ড: একটি বোর্ড যার কোণ সমকোণ নয়',
    millInfo: 'শিং আকৃতির হ্যান্ডেল',
    haiTang: 'বিগোনিয়া কোণ',
    FSDrill: 'পাঁচ/ছয় দিকের ড্রিল',
    engraving2: 'কাটার মেশিন',
    xyReverse: 'XY অক্ষ পরিবর্তন',
    autoXYReverse: 'বিশেষ আকৃতির বোর্ডের সমস্ত স্লট',
    autoXYReverseTip: 'পাঁচ/ছয় দিকের ড্রিলের প্রক্রিয়া ডেটা ও সাইড হোল মাইনের প্রক্রিয়া ডেটা স্বয়ংক্রিয়ভাবে XY অক্ষ পরিবর্তনের সাথে সামঞ্জস্যপূর্ণ হয়',
    autoXYReverseTip2: 'PTP সমর্থন না',
    xyReverseTip: 'XY অক্ষ পরিবর্তন ফাংশন এখনো L-আকৃতির উদ্বৃত্ত উপকরণের সাথে সামঞ্জস্যপূর্ণ নয়, সাবধানে ব্যবহার করুন',
    rect: 'আয়তক্ষেত্র',
    Ltype: 'L-আকৃতি',
    archive: 'আর্কাইভ',
    tellPlaceholder: 'মোবাইল নম্বর লিখুন',
    knivesStore: 'ছুরি স্টোরেজ',
    roll: 'বোর্ড উল্টানো',
    pause: 'বিরতি',
    editTrans: 'অনুবাদ সম্পাদনা',
    translateManager: 'অনুবাদ ব্যবস্থাপনা',
    grating: 'গ্রেটিং',
    addressEditErr: 'একাধিক অর্ডারে প্রকল্পের ঠিকানা সংশোধন সমর্থিত নয়',
    customerEditErr: 'একাধিক অর্ডারে গ্রাহকের তথ্য সংশোধন সমর্থিত নয়',
    factoryEditErr: 'একাধিক অর্ডারে কারখানার অর্ডার নম্বর সংশোধন সমর্থিত নয়',
    roomNameEditErr: 'একাধিক অর্ডারে ঘরের নাম সংশোধন সমর্থিত নয়',
    remarkEditErr: 'একাধিক অর্ডারে অর্ডারের মন্তব্য সংশোধন সমর্থিত নয়',
    toMaterialList: 'উপকরণ তালিকায় যান',
    deleteFail: 'মুছা ব্যর্থ হয়েছে, পরে আবার চেষ্টা করুন!',
    batchRestore: 'ব্যাচ পুনরুদ্ধার',
    batchDelete: 'ব্যাচ মুছুন',
    workShop: 'ওয়ার্কশপ উৎপাদন',
    FGAdrress: 'প্রকল্পের ঠিকানা/চুক্তি নম্বর',
    cuttingSize: 'কাটার আকার',
    finishedSize: 'সম্পন্ন পণ্যের আকার',
    labelImg: 'লেবেলের ছবি',
    layoutImg: 'লেআউট চিত্র',
    file: 'ফাইল',
    folder: 'ফোল্ডার',
    reName: 'নাম পরিবর্তন করুন',
    to: 'পর্যন্ত',
    plankUnit: 'শীট',
    tagTemp: 'লেবেল টেমপ্লেট',
    roomRemark: 'ঘরের মন্তব্য',
    noModificationPermission: 'সংশোধনের অনুমতি নেই',
    modificationRecord: 'সংশোধনের রেকর্ড',
    page: 'পৃষ্ঠা',
    strip: 'স্ট্রিপ',
    jump: 'ঝাঁপ দিন',
    freeAgreement: 'সফটওয়্যার দায়মুক্তি চুক্তি',
    preStep: 'পূর্ববর্তী ধাপ',
    nextStep: 'পরবর্তী ধাপ',
    upload: 'আপলোড করুন',
    uploading: 'আপলোড হচ্ছে',
    iAgree: 'আমি সম্মত',
    pleaseSelectPlank: 'অন্তত একটি বোর্ড নির্বাচন করুন',
    saveToStoreTip: 'অন্তত একটি না-কাটা বোর্ড নির্বাচন করুন',
    fileIsNotExist: 'ফাইলটি বিদ্যমান নেই',
    selectAll: 'সব নির্বাচন করুন',
    pdfTag: 'PDF লেবেল',
    tagImage: 'লেবেলের ছবি',
    guigui: 'Guigui',
    gratingSlot: 'গ্রেটিং স্লট',
    deleteTip: 'এই ডেটা মুছার পর পুনরুদ্ধার করা যাবে না, ডেটা মুছতে নিশ্চিত করবেন কি?',
    deleteError: 'অজানা ত্রুটি ঘটেছে এবং মুছা ব্যর্থ হয়েছে',
    cancelDelete: 'মুছা বাতিল করা হয়েছে',
    confirmDeleteTip: 'মুছার পর বোর্ড "বোর্ড অপেক্ষায়-সংরক্ষিত নয়" বিভাগে প্রবেশ করবে, ডেটা মুছতে নিশ্চিত করবেন কি?',
    confirmDeleteBujianTip: 'মুছার পর অংশটি "পার্টস লাইব্রেরি"তে প্রবেশ করবে, ডেটা মুছতে নিশ্চিত করবেন কি?',
    confirmSureDeleteTip: 'বর্তমান লেআউট লাইব্রেরিতে একই উপকরণের ছোট বোর্ড আছে, এই বড় বোর্ড মুছতে নিশ্চিত করবেন কি?',
    deleteEmptyTip: 'এই বড় বোর্ড মুছবেন কি?',
    notCanDelete: 'কাটা উদ্বৃত্ত উপকরণ স্টোরেজ সমর্থন করে না',
    new: 'New',
    innerBluneFailure: 'এমবেডেড ক্লাউড টাইপসেটিং এই ফাংশনে কার্যকর নয়',
    deleteBigPlankTip: 'শেষ বড় বোর্ডে ছোট বোর্ড আছে, মুছা যাবে না!',
    continueExport: 'উপেক্ষা করুন এবং ফাইল আউটপুট চালিয়ে যান',
    toCheck: 'যাচাই করুন',
    pleaseCheck: 'বর্তমান লেআউটে গর্ত-স্লট দ্বন্দ্ব/ছোট বোর্ড উড়ে যাওয়া/গভীরতা অসামঞ্জস্য আছে, পরীক্ষা করুন!',
    clampHandCheck: 'কিছু বোর্ডের গর্ত স্লট ক্ল্যাম্প পজিশন এড়াতে পারছে না, ম্যানুয়ালি সামঞ্জস্য করুন',
    conflictPartDetail: 'সংঘর্ষরত বোর্ডের বিস্তারিত',
    colorNotUndefined: 'রঙ খালি রাখা যাবে না',
    materialNotUndefined: 'উপকরণ খালি রাখা যাবে না',
    newSetting: 'নতুন ফিচার',
    downImageErrTip: 'ছবি রপ্তানি ব্যর্থ, লেবেলের ছবি বড় বোর্ড অনুযায়ী বিভিন্ন ফোল্ডারে বিভক্ত, ছোট বোর্ড লেবেলও নির্বাচন করুন',
    downNcErrTip: 'NC ডাউনলোড ব্যর্থ, লেবেলের ছবি বড় বোর্ড অনুযায়ী বিভিন্ন ফোল্ডারে বিভক্ত, ছোট বোর্ড লেবেলও নির্বাচন করুন',
    downNcErrTipForSurFolder: 'NC ডাউনলোড ব্যর্থ, লেবেলের ছবি বড় বোর্ড অনুযায়ী বিভিন্ন ফোল্ডারে বিভক্ত এবং উদ্বৃত্ত বড় বোর্ড ফাইল সেটিং একসাথে খোলা যাবে না',
    yes: 'হ্যাঁ',
    no: 'না',
    checkColorPrint: 'বর্তমানে রঙিন লেবেল চালু আছে, রঙিন প্রিন্টার দিয়ে প্রিন্ট করুন~',
    colorRules: 'রঙিন লেবেল তৈরি চালু করার পর, অর্ডার/ঘর/ক্যাবিনেট/দরজা রঙ অনুযায়ী আলাদা হবে, একই ধরনের ডেটার জন্য সর্বোচ্চ ১২টি রঙিন লেবেল সমর্থিত',
    greyPart: 'ডানদিকের লেবেলের ধূসর অংশ হলো',
    region: 'অঞ্চল',
    notSame: '{regionName} অঞ্চলের রঙ আলাদা',
    doorTip: 'ধূসর হলো দরজার বোর্ড, সাদা হলো দরজা নয় এমন বোর্ড',
    exist: 'বিদ্যমান',
    limitNotEffect: 'ডেটা ১২টির বেশি হলে রঙিন লেবেল কার্যকর হবে না',
    hoverTip: 'বর্তমানে bmp এক্সটেনশনের ছবি, এনকোডিং ফরম্যাট কালো-সাদা, রঙিন লেবেল ছবি আউটপুট করা যাবে না',
    lock: 'লক করুন',
    unlock: 'আনলক করুন',
    batchLock: 'ব্যাচ লক/আনলক',
    surplusLock: 'উদ্বৃত্ত উপকরণ লক',
    surplusUnlock: 'উদ্বৃত্ত উপকরণ আনলক',
    is: 'হ্যাঁ',
    not: 'না',
    savingHistory: 'ইতিহাস ফাইল সংরক্ষণ করা হচ্ছে',
    saveHistorySuccess: 'ইতিহাস ফাইল সফলভাবে সংরক্ষিত হয়েছে',
    saveHistoryFail: 'ইতিহাস ফাইল সংরক্ষণ ব্যর্থ হয়েছে',
    bw: 'কালো ও সাদা লেবেল রপ্তানি করবেন কি',
    modular: 'ইউনিট ক্যাবিনেট',
    autoAdjust: 'স্বয়ংক্রিয় সামঞ্জস্য',
    cutOrderTip: 'আপনার 【{errorCutOrdersString} নম্বর বড় বোর্ড】 কাটার ক্রমে ত্রুটি পাওয়া গেছে! NC ফাইল ডাউনলোডের আগে সামঞ্জস্য করুন',
    lockedCutOrderTip: '【{errorCutOrdersString} নম্বর বড় বোর্ড】 লক করা হয়েছে, ম্যানুয়ালি সংশোধন করতে যান',
    paibanImgCutOrderTip1: 'আপনার',
    paibanImgCutOrderTip: 'কাটার ক্রমে ত্রুটি আছে! লেআউট ফাইল রপ্তানির আগে লেআউট পেজে গিয়ে সামঞ্জস্য করুন',
    goAdjust: 'সামঞ্জস্য করতে যান',
    autoAdjustWarning: 'বর্তমান লেআউট ফলাফল স্বয়ংক্রিয় সামঞ্জস্য সমর্থন করে না',
    checkNetwork: 'নেটওয়ার্ক পরীক্ষা করুন',
    moreInfo: 'আরও তথ্য দেখুন',
    continueLayout: 'লেআউট চালিয়ে যান',
    adjustPosition: 'সেটিং সামঞ্জস্য করুন',
    specialAndFiveSix: 'পাঁচ/ছয় মুখ ড্রিল দিয়ে বিশেষ আকারের বোর্ড প্রক্রিয়া করার সময় বিশেষ আকার নেস্টিং চালু করলে বোর্ড কাটা যেতে পারে, লেআউট চালিয়ে যেতে নিশ্চিত করবেন কি?',
    plankPathErr: 'বোর্ডের অভ্যন্তরীণ বিশেষ আকার ডেটা ত্রুটি, টুল স্পেসিফিকেশনের সাথে মেলে কিনা পরীক্ষা করুন! বোর্ড নম্বর【{plankIDList}】',
    edgeCheck: 'সিস্টেম বড় বোর্ডের ট্রিমিং পরিবর্তন সনাক্ত করেছে, উৎপাদন নির্ভুলতা নিশ্চিত করতে পুনরায় লেআউট করুন',
    iKnow: 'বুঝলাম',
    versionErrTip: 'ক্যাবিনেট সফটওয়্যার সর্বশেষ সংস্করণে আপডেট করুন!',
    annualFeeExpired: 'আপনার বার্ষিক ফি মেয়াদ উত্তীর্ণ হয়েছে, অনুগ্রহ করে নবায়ন করুন!',
    holeEquipment: 'ড্রিলিং যন্ত্রপাতি {num}',
    customizedService: 'কাস্টমাইজড সেবা সমর্থন করে, আপনার বিশেষ উৎপাদন পরিকল্পনা তৈরি করুন',
    exampleCombination1: 'খোদাই মেশিন + পাঁচ/ছয় মুখ ড্রিল + সাইড হোল মেশিন সমন্বয়',
    exampleCombination2: 'ইলেকট্রনিক করাত + পাঁচ/ছয় মুখ ড্রিল + সাইড হোল মেশিন সমন্বয়',
    exampleCombination3: 'সম্পূর্ণ স্বয়ংক্রিয় সমন্বিত উৎপাদন লাইন + পাঁচ/ছয় মুখ ড্রিল সমন্বয়',
    feedback: 'আপনার প্রয়োজনীয়তা সরাসরি Guigui সফটওয়্যার বিক্রয় বা বিক্রয়োত্তর সেবা কর্মীদের কাছে জানাতে পারেন',
    markModifiedBoards: 'পরিবর্তিত ছোট বোর্ড চিহ্নিত করুন',
    showMoveStep: 'কীবোর্ড চালিয়ে যাওয়া ধাপ নির্দিষ্ট করুন',
    moveStep: 'কীবোর্ড চালিয়ে যাওয়া ধাপ',
    existChangeBoards: 'পরিবর্তিত ছোট বোর্ড আছে',
    crossMaterialBoard: 'ক্রস-ম্যাটেরিয়াল রঙ বোর্ড',
    skipCrossMaterialTip: 'এই বিন্যাসে আর দেখাবেন না',
    crossMaterialConfirmTip: 'আপনি বর্তমানে ভিন্ন উপাদান বা রঙের মধ্য দিয়ে ছোট বোর্ড সরাচ্ছেন। {highlight} চালিয়ে যাবেন?',
    crossMaterialConfirmTipHighlight: 'উৎপাদিত বোর্ড বিভক্ত অর্ডারের সাথে অসঙ্গতিপূর্ণ হতে পারে',
    exportHoleSlotPDF: 'গর্ত-স্লট চিত্র রপ্তানি করুন',
    pdfFormat: 'PDF ফরম্যাট',
    dxfFormat: 'DXF ফরম্যাট',
    specialShapeKnivesInfo: 'বিশেষ আকারের কাটিং টুল সেটিং',
    specialShapeKnivesInfoTips: '{stockNum} নম্বর বোর্ড:',
    specialShapeKnivesInfoTips2: 'বিশেষ আকারের স্বয়ংক্রিয় কাটিং টুল নির্বাচন চালু আছে, লেআউট ডেটা অস্বাভাবিক, কাটার তালিকা থেকে পুনরায় লেআউট করুন বা স্বয়ংক্রিয় টুল নির্বাচন বন্ধ করুন',
    default: 'ডিফল্ট',
    exportLanguage: 'রপ্তানি ভাষা',
    exportLanguageTip: 'নোট: PDF রপ্তানিতে কিছু টেক্সট অনুবাদ করা যাবে না',
    highGlossNameTip: 'ক্যাবিনেট থেকে সিঙ্ক করা হাই-গ্লস বোর্ড অন্য টেক্সট দিয়ে বর্ণনা করা যেতে পারে, হাই-গ্লস বৈশিষ্ট্য প্রভাবিত হবে না',
    mixPaibanPlanSetting: 'মিশ্র লেআউট পরিকল্পনা সেটিং',
    mixPaibanPlanSettingTip: 'সিস্টেম মিশ্র লেআউট পরিকল্পনা সেটিং পরিবর্তন সনাক্ত করেছে, এই মিশ্র লেআউট পরিকল্পনা পুনরায় নির্বাচন করুন!',
    mixPaibanPlanSettingOk: 'মিশ্র লেআউট পরিকল্পনা সেট করুন',
    mixPaibanPlanSettingCancel: 'না, সরাসরি লেআউট করুন',
    noMixPaibanPlan: 'ব্যবহারযোগ্য মিশ্র লেআউট পরিকল্পনা নেই',
    mixColors: 'মিশ্র রঙ লেআউট',
    mixPai: 'মিশ্র লেআউট',
    plan: 'পরিকল্পনা',
    mixPaibanTitle: 'বিভিন্ন রঙের ছোট বোর্ড একসাথে সাজান',
    mixColorsTip: 'কোন রঙের বোর্ড একই রঙ হিসেবে একটি বড় বোর্ডে উৎপাদন করা যাবে তা নির্ধারণ করা যায়, বোর্ডের মূল রঙ তথ্য পরিবর্তন না করে',
    mixColorsTip2: 'পরিকল্পনা যোগ করার পর কাটার তালিকায় সক্রিয় করতে হবে',
    mixColorsTip3: 'ভিন্ন রঙের এজ সিলিং ফাংশনে দ্বন্দ্ব আছে, একসাথে কার্যকর করা যাবে না',
    mixErrTip: 'মিশ্র লেআউট পরিকল্পনায় প্রয়োজনীয় ফিল্ড নেই, পরীক্ষা করুন',
    addPlan: 'পরিকল্পনা যোগ করুন',
    chooseMatcode: 'উপকরণ নির্বাচন করুন',
    chooseColor: 'রঙ নির্বাচন করুন',
    defineColor: 'নির্বাচিত রঙকে হিসেবে সংজ্ঞায়িত করুন',
    confirmDeletePlan: 'এই পরিকল্পনা মুছতে নিশ্চিত করবেন কি',
    trimmingMethod: 'ট্রিমিং পদ্ধতি',
    followStandardTrim: 'মূল বোর্ডে স্ট্যান্ডার্ড বোর্ডের ট্রিমিং মান অনুসরণ করুন',
    trimToast: 'নোট: আপনি উদ্বৃত্ত উপকরণের কাস্টম ট্রিমিং ফিচার ব্যবহার করছেন, শুধুমাত্র করাত কাটার লেআউট নির্বাচন করা যাবে',
    individualTrimValue: 'ট্রিমিং মান পৃথকভাবে সেট করুন',
    topTrimEmptyToast: 'উপরের ট্রিমিং মান খালি রাখা যাবে না!',
    bottomTrimEmptyToast: 'নিচের ট্রিমিং মান খালি রাখা যাবে না!',
    leftTrimEmptyToast: 'বাম ট্রিমিং মান খালি রাখা যাবে না!',
    rightTrimEmptyToast: 'ডান ট্রিমিং মান খালি রাখা যাবে না!',
    topTrimBlurToast: 'উপরের ট্রিমিং মান লিখুন',
    bottomTrimBlurToast: 'নিচের ট্রিমিং মান লিখুন',
    leftTrimBlurToast: 'বাম ট্রিমিং মান লিখুন',
    rightTrimBlurToast: 'ডান ট্রিমিং মান লিখুন',
    effectToast: '১. কাস্টম ট্রিমিং ফিচার শুধুমাত্র ওয়েল্ডেড বোর্ডে কার্যকর',
    defaultTrimSetting: 'উদ্বৃত্ত উপকরণের ডিফল্ট ট্রিমিং সেটিং',
    enterHere: 'এখানে লিখুন',
    permissionTipExportDxf: 'DXF হোল স্লট ডায়াগ্রাম রপ্তানি',
    permissionTipSurplusRecycleBin: 'অবশিষ্ট উপাদান পুনর্ব্যবহার কেন্দ্র',
    permissionTipAdvancedNesting: 'উন্নত অনিয়মিত নেস্টিং',
    permissionTipPanelGrainAlign: 'প্যানেল দানা সারিবদ্ধকরণ',
    permissionSeparator: ', ',
    missingPermissionTip: 'নিম্নলিখিত অনুমতিগুলি অনুপস্থিত: {permissions}'
    },
  home: {
    head: {
      production: 'পণ্য পরিচিতি',
      resolve: 'সমাধান',
      about: 'আমাদের সম্পর্কে',
      equipment: 'যন্ত্রপাতি ও সরঞ্জাম',
      tell: 'অভিযোগ হটলাইন',
      enter: 'ক্লাউড টাইপসেটিং-এ প্রবেশ করুন'
      },
    swiper: {
      case1: {
        tag: 'নতুন আপগ্রেড সংস্করণ',
        subTitle: 'মেশিনের বুদ্ধিমান মস্তিষ্ক',
        description: 'শিল্পকে বিপ্লব করা ক্লাউড অনলাইন টাইপসেটিং অপ্টিমাইজেশন সফটওয়্যার'
        },
      case2: {
        title: 'ক্যাবিনেট উৎপাদন',
        subTitle: 'প্রযুক্তি উদ্ভাবন',
        description: 'বিভিন্ন লেবেলিং মেশিন, কাটিং মেশিন, সাইড হোল মেশিন, পাঁচ মুখ PTP, পাঁচ/ছয় মুখ ড্রিল সংযোগ সমর্থন করে'
        },
      case3: {
        title: 'শিল্প মস্তিষ্ক',
        subTitle: 'সমাধান',
        description: 'বুদ্ধিমান টাইপসেটিং অ্যালগরিদম দিয়ে বোর্ড উপকরণের উচ্চতর ব্যবহার হার অর্জন'
        }
      },
    statistics: {
      today: 'আজকের শিডিউলিং পরিমাণ',
      toMounth: 'এই মাসের লেআউট পরিমাণ',
      outturn: 'উপকরণ ফলন হার',
      cumulative: 'সঞ্চিত ব্যবহারকারী'
      },
    intro: {
      title: 'এন্টারপ্রাইজ-গ্রেড বিগ ডেটা ক্লাউড অনলাইন টাইপসেটিং সফটওয়্যার',
      subTitle: 'শিল্পের গতিপ্রকৃতি বিশ্লেষণ করে, গ্রাহকের চাহিদায় মনোযোগ দিয়ে, কোম্পানির ডিজিটাল রূপান্তরকে শক্তিশালী করে AI সহায়তা অ্যালগরিদম দিয়ে কোম্পানির নতুন বৃদ্ধি নিশ্চিত করে',
      menue: {
        case1: {
          title: 'অনলাইন টাইপসেটিং',
          subTitle: 'যেকোনো সময় টাইপসেটিং করা যাবে',
          description: 'সফটওয়্যার ডাউনলোড ছাড়াই যেকোনো সময় টাইপসেটিং করা যায়, রিমোট কন্ট্রোলে কম্পিউটারের উপর নির্ভর করতে হয় না'
          },
        case2: {
          title: 'মাল্টি-লাইন উৎপাদন',
          subTitle: 'উৎপাদন লাইন দ্রুত পরিবর্তন',
          description: 'একসাথে একাধিক উৎপাদন লাইন সমর্থন করে, উৎপাদন লাইনের মধ্যে দ্রুত স্যুইচ করা যায়'
          },
        case3: {
          title: 'নির্ভুল উৎপাদন',
          subTitle: 'নির্ভুল লেআউট, নির্ভুল প্যারামিটার সেটিং',
          description: 'নির্ভুল টাইপসেটিং এবং নির্ভুল প্যারামিটার সেটিং দিয়ে বোর্ড উৎপাদন আরও নির্ভুল করুন'
          },
        case4: {
          title: 'কাস্টম উৎপাদন',
          subTitle: 'কাস্টম লেবেল, পাঁচ/ছয় মুখ ড্রিল, উদ্বৃত্ত আকৃতি',
          description: 'কাস্টম লেবেল, কাস্টম পাঁচ/ছয় মুখ ড্রিল, কাস্টম উদ্বৃত্ত আকৃতি, সম্মিলিত সরঞ্জাম প্রক্রিয়াকরণ'
          }
        }
      },
    fangan: {
      title: 'শিল্প পেশাদার সমাধান',
      subTitle: 'কম খরচ, উচ্চ উৎপাদন মূল্য, বুদ্ধিমান অ্যালগরিদম বোর্ড ব্যবহার বাড়ায়, বিভিন্ন ডিজাইন সফটওয়্যারের সাথে সামঞ্জস্যপূর্ণ',
      menue: {
        case1: {
          title: 'অনলাইন অর্ডার রিসেপশন ও উৎপাদন একীভূত',
          description: 'রিমোট অনলাইন অপারেশন, যেকোনো সময় অর্ডার কারখানায় সিঙ্ক্রোনাইজ, ডিজাইন ও উৎপাদন একসাথে সম্পন্ন'
          },
        case2: {
          title: 'এক ক্লিকে উৎপাদন লাইন পরিবর্তন',
          description: 'কাস্টমাইজযোগ্য উৎপাদন লাইন, একাধিক উৎপাদন লাইন এবং একাধিক ধরনের সরঞ্জাম সংযোগ সমর্থন'
          },
        case3: {
          title: 'বুদ্ধিমান অ্যালগরিদমে বোর্ড উপকরণ ব্যবহার হার বৃদ্ধি',
          description: 'প্রচলিত অ্যালগরিদমে বোর্ড ব্যবহার হার কম, বুদ্ধিমান অ্যালগরিদমে নির্ভুল প্যারামিটার সেটিং, কাস্টমাইজড উৎপাদন পরিকল্পনা'
          },
        case4: {
          title: 'পেশাদার কাটিং সমাধান',
          description: 'কাটার ক্রম ও কাটার বিন্দু অপ্টিমাইজ করে পথ ছোট এবং কাটা আরও স্থিতিশীল করুন'
          }
        }
      },
    aboutUs: {
      title1: 'Xingeer মানব বসতি প্রযুক্তি',
      subTitle: 'আসবাবপত্র উৎপাদন শিল্পের রূপান্তর নেতা',
      description: 'Xingeer কোম্পানি, ঐতিহ্যবাহী আসবাবপত্র উৎপাদন শিল্পের ইন্টারনেট রূপান্তর বাস্তবায়নে মনোযোগী',
      culture: {
        case1: {
          title: 'কোম্পানির উদ্দেশ্য',
          subTitle: 'কারখানাকে সাহায্য করুন, তিনগুণ বৃদ্ধি'
          },
        case2: {
          title: 'সাংস্কৃতিক মূল্যবোধ',
          subTitle: 'গ্রাহককেন্দ্রিক, কর্মীদের প্রচেষ্টার উপর ভিত্তি করে, কঠোর পরিশ্রম, মানুষের উপকার করা'
          },
        case3: {
          title: 'গাইডিং আদর্শ',
          subTitle: 'গণ লাইন, বিক্রয় শক্তি, পণ্য শক্তি, সাংগঠনিক শক্তি সম্পন্ন এলিট টিম গড়ুন'
          }
        },
      feature: {
        case1: 'পেশাদার টিম রক্ষণাবেক্ষণ',
        case2: 'ক্রমাগত আপডেট ও পুনরাবৃত্তি',
        case3: 'এক-এক আফটার-সেলস সেবা',
        case4: 'কাস্টমাইজড ফাংশন সেবা'
        }
      },
    cooperation: {
      title: 'আন্তরিক সহযোগিতায় ভবিষ্যৎ গড়ি',
      subTitle: 'ডকিং সরঞ্জাম ব্র্যান্ড দেশীয় ৯০% সাধারণ সরঞ্জাম কভার করে, ১০৭,৫৫৪ জন ব্যবসায়ী আমাদের সাথে'
      },
    footer: {
      contact: {
        title: 'আমাদের সাথে যোগাযোগ করুন',
        adrres: 'ঠিকানা: জিয়াংসু প্রদেশ, উশি শহর, বিনহু জেলা, শিউশি নং ৫০',
        subAdrres: 'K-park সার্ভিস সেন্টার ১ নম্বর ভবন ১৬ তলা',
        tell: 'টেলিফোন'
        },
      business: {
        title: 'Xingeer মূল ব্যবসা',
        department1: 'দরজা ও জানালা সফটওয়্যার বিভাগ',
        department2: 'আসবাবপত্র সফটওয়্যার বিভাগ',
        department3: 'প্রিফেব্রিকেটেড নির্মাণ বিভাগ',
        department4: 'Xingeer সদর দপ্তরের অফিশিয়াল ওয়েবসাইট'
        },
      brand: {
        title: 'Xingeer সহযোগী ব্র্যান্ড',
        brand1: 'Cai Shen Jin Fu',
        brand2: 'Mentu.com',
        brand3: 'Ding Xin বিনিয়োগ',
        brand4: 'San Zhang Tu প্রযুক্তি',
        brand5: 'Shanghai Fen Mo প্রযুক্তি'
        },
      organization: {
        title: 'Xingeer বৈশ্বিক শাখা',
        organization1: 'Xingeer - দক্ষিণ চীন ব্যুরো (ফোশান শাখা)',
        organization2: 'Xingeer - উত্তর ব্যুরো (লিনি শাখা)',
        organization3: 'Xingeer - দক্ষিণ-পশ্চিম ব্যুরো (চেংদু শাখা)',
        organization4: 'Xingeer - GG পশ্চিম সার্ভিস সেন্টার',
        organization5: 'Xingeer - GG পূর্ব সার্ভিস সেন্টার',
        organization6: 'Xingeer - এজেন্ট ক্লাস্টার',
        organization7: 'Xingeer - আন্তর্জাতিক বাজার বিভাগ'
        },
      follow: {
        title: '"ক্যাবিনেট অনুসরণ করুন" স্ক্যান করুন'
        },
      friendLink: {
        link1: 'Xingeer সফটওয়্যার',
        link2: 'K Show কেনাকাটা সফটওয়্যার',
        link3: 'Mentu.com',
        link4: 'সম্পূর্ণ অ্যালুমিনিয়াম ক্যাবিনেট সফটওয়্যার',
        link5: 'ZOL সফটওয়্যার ডাউনলোড',
        link6: 'Hua Jun সফটওয়্যার পার্ক',
        link7: 'ডাউনলোড হোম',
        link8: 'ZOL সফটওয়্যার ডাউনলোড',
        link9: 'সবুজ রিসোর্স নেটওয়ার্ক',
        link10: 'পোশাক ক্যাবিনেট ফ্র্যাঞ্চাইজ',
        link11: 'হোম ফ্র্যাঞ্চাইজ',
        link12: 'আমেরিকান স্ট্যান্ডার্ড বাথরুম ফ্র্যাঞ্চাইজ'
        }
      }
    },
  login: {
    title: 'লগইন',
    tell: 'ফোন নম্বর',
    password: 'পাসওয়ার্ড',
    passwordPlaceholder: 'পাসওয়ার্ড লিখুন',
    forget: 'পাসওয়ার্ড ভুলে গেছেন?',
    registerAccount: 'অ্যাকাউন্ট নিবন্ধন করুন',
    backLog: 'লগইনে ফিরে যান',
    verifyCode: 'যাচাইকরণ কোড',
    getVerifyCode: 'যাচাইকরণ কোড পান',
    verifyCodeErr: 'যাচাইকরণ কোড ভুল',
    confimPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
    confimPasswordPlaceholder: 'পাসওয়ার্ড নিশ্চিত করুন',
    editPassword: 'পাসওয়ার্ড পরিবর্তন করুন',
    register: 'নিবন্ধন করুন',
    reSend: 'পরে পুনরায় নিন',
    loginLoadText: 'লগইন হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    loadingPageTextL: 'লগইন সফল, পেজ স্ট্রাকচার লোড হচ্ছে...',
    loginSuccess: 'লগইন সফল হয়েছে',
    tellErr: 'ফোন নম্বরের ফরম্যাট সঠিক নয়',
    passwordErr: 'পাসওয়ার্ড লিখুন'
    },
  main: {
    head: {
      title: 'Bluen',
      subTitle: 'Save time, materials, and effort',
      task: 'টাস্ক গ্রহণ করুন',
      arrange: 'টাইপসেটিং',
      surplus: 'উদ্বৃত্ত উপকরণ',
      setting: 'সেটিংস',
      find: 'আবিষ্কার করুন',
      upgrade: 'এখনই আপগ্রেড করুন',
      editNickName: 'ডাকনাম সম্পাদনা করুন',
      editPassword: 'পাসওয়ার্ড পরিবর্তন করুন',
      logout: 'লগআউট করুন',
      notice: 'ঘোষণা',
      enterOfficial: 'অফিশিয়াল ওয়েবসাইটে যান',
      equipment: 'যন্ত্রপাতি ও সরঞ্জাম',
      help: 'সাহায্য',
      importFunc: 'বিশেষ ফিচার দেখুন',
      enterThinkerOfficial: 'Xingeer অফিশিয়াল ওয়েবসাইটে প্রবেশ করুন',
      history: 'ইতিহাস সংরক্ষণ',
      plankManager: 'মূল বোর্ড ব্যবস্থাপনা',
      tagManager: 'লেবেল ব্যবস্থাপনা',
      suplumentManager: 'পরিপূরক ও অপেক্ষাধীন লেআউট লাইব্রেরি',
      fileManager: 'ফাইল ব্যবস্থাপনা',
      productionLine: 'সরঞ্জাম সংযোগ',
      workeShop: 'ক্লাউড উৎপাদন',
      useLesson: 'ব্যবহার টিউটোরিয়াল',
      videoLesson: 'ভিডিও টিউটোরিয়াল',
      prolineManager: 'উৎপাদন লাইন ব্যবস্থাপনা',
      materialManager: 'বোর্ড ব্যবস্থাপনা',
      productManual: 'পণ্য ম্যানুয়াল',
      medialRelated: 'গ্রেডিয়েন্ট রিলিজ'
      },
    sideBar: {
      title: 'উৎপাদন অপ্টিমাইজেশন',
      materialList: 'কাটার তালিকা',
      paibanTask: 'টাইপসেটিং কাজ',
      paibanResult: 'লেআউট পরিকল্পনা',
      printTag: 'লেবেল প্রিন্ট করুন',
      history: 'ইতিহাস সংরক্ষণ',
      limitDate: 'Limited Free',
      surplusManager: 'উদ্বৃত্ত ব্যবস্থাপনা',
      translateManager: 'অনুবাদ ব্যবস্থাপনা',
      moreSettings: 'আরও সেটিংস',
      deepSeekTitle: 'পরামর্শদাতা',
      paibanCommune: 'টাইপসেটিং আলোচনা গ্রুপ'
      },
    allRead: 'সব পঠিত',
    learnMore: 'বিস্তারিত জানুন',
    noticeEmpty: 'এখনো কোনো ঘোষণা নেই....',
    noticeErr: 'বিস্তারিত ঘোষণা নেওয়ায় ত্রুটি',
    feedBack: {
      tab1: 'মতামত জমা দিন',
      tab2: 'মতামতের রেকর্ড',
      type: 'মতামতের ধরন',
      typePlaceholder: 'ফাংশন নির্বাচন করুন',
      description: 'বিবরণ',
      descriptionPlaceholder: 'আমাদের আরও ভালোভাবে সাহায্য করতে সক্ষম হতে কমপক্ষে ১৫ শব্দের বিস্তারিত ব্যবহারের দৃশ্যকল্প বিবরণ দিন',
      uploadPic: 'ছবি যোগ করুন, সর্বোচ্চ ৬টি, প্রতিটি ছবির আকার ১০MB-এর বেশি নয়',
      tell: 'যোগাযোগের নম্বর',
      submit: 'জমা দিন',
      admin: 'ক্লাউড টাইপসেটিং প্রশাসক:',
      picTip: 'ছবি: (ছবির বিস্তারিত দেখতে ক্লিক করুন)',
      empty: 'এখনো কোনো মতামত ডেটা নেই',
      picErr: 'প্রতিটি ছবির আকার ১০MB-এর বেশি হওয়া উচিত নয়',
      contentErr: 'অক্ষর সংখ্যা ১৫ থেকে ৩০০ এর মধ্যে হতে হবে',
      necessary: 'এই ক্ষেত্রটি পূরণ করা বাধ্যতামূলক'
      }
    },
  taskPage: {
    tab1: 'উৎপাদন টাস্ক',
    tab2: 'ব্যাচ উৎপাদন কিউ',
    filter: {
      title: 'ফিল্টার',
      unArrange: 'লেআউট করা হয়নি',
      arranged: 'লেআউট করা হয়েছে',
      allArranged: 'সব লেআউট করা হয়েছে',
      preLayout: 'প্রি-লেআউট'
      },
    search: {
      placeholder: 'অনুসন্ধানের বিষয়বস্তু লিখুন',
      orderName: 'অর্ডারের নাম',
      sender: 'প্রেরক'
      },
    importTask: 'টাস্ক আমদানি করুন',
    refuseTask: 'টাস্ক প্রত্যাখ্যান করুন',
    refreshList: 'তালিকা রিফ্রেশ করুন',
    refuseRecord: 'প্রত্যাখ্যানের রেকর্ড',
    taskCard: {
      sender: 'আমদানি করা উপকরণ তালিকা',
      delivery: 'ডেলিভারি তারিখ',
      delete: 'মুছুন',
      addToBatch: 'ব্যাচে যোগ করুন',
      save: 'সংরক্ষণ করুন',
      arrange: 'সরাসরি লেআউট করুন',
      deleteTitle: 'টাস্ক মুছুন',
      checkDetail: 'বিস্তারিত দেখতে ক্লিক করুন',
      refuse: 'প্রত্যাখ্যান করুন',
      refuseTime: 'প্রত্যাখ্যানের সময়',
      refuseReason: 'প্রত্যাখ্যানের কারণ',
      refuseTask: 'টাস্ক গ্রহণ করতে অস্বীকার',
      refuseTaskPlaceholder: 'প্রত্যাখ্যানের কারণ লিখুন',
      addErr: 'যোগ করতে ব্যর্থ হয়েছে, পরে আবার চেষ্টা করুন!'
      },
    batchNo: 'ব্যাচ নম্বর',
    batchArrange: 'ব্যাচ লেআউট',
    clearBatch: 'কিউ পরিষ্কার করুন',
    taskCount: 'বর্তমান টাস্কের সংখ্যা:',
    checkAllTask: 'সমস্ত উপকরণ তালিকা দেখুন',
    clearSuccess: 'সাফ করা সফল হয়েছে',
    record: {
      batchNo: 'ব্যাচ',
      saveDate: 'সংরক্ষণের সময়',
      materialList: 'উপকরণ তালিকা',
      arrangedRecord: 'লেআউট পরিকল্পনা',
      searchPlaceholder: 'ব্যাচ নম্বর লিখুন',
      tipText: 'এই আর্কাইভটি মুছবেন কি?'
      },
    errTip: 'প্রক্রিয়াযোগ্য কোনো টাস্ক ডেটা নেই, টাস্ক তালিকায় যোগ করুন!',
    emptyErr: 'এই টাস্ক অর্ডারে কোনো বোর্ড ডেটা নেই, লেআউট উৎপাদন চালিয়ে যেতে পারছে না!',
    operationSuccess: 'অপারেশন সফল হয়েছে',
    operationFail: 'অপারেশন ব্যর্থ হয়েছে, পরে আবার চেষ্টা করুন!',
    saveSuccess: 'সংরক্ষণ সফল হয়েছে',
    plankMaxLimit: 'ছোট বোর্ডের সংখ্যা সর্বোচ্চ লেআউট সীমা অতিক্রম করেছে',
    batchWorning: 'অনুগ্রহ করে ব্যাচে উৎপাদন করুন',
    batchEmptyErr: 'অর্ডার তালিকায় কোনো বোর্ড ডেটা নেই, ব্যাচ উৎপাদন চালিয়ে যাওয়া যাচ্ছে না!',
    noRoomTip: 'কোনো রুম নেই, ব্যাচ উৎপাদন চালিয়ে যাওয়া যাচ্ছে না!',
    refuseHistory: 'প্রত্যাখ্যানের ইতিহাস'
    },
  materialPage: {
    specialProcess: 'বিশেষ প্রক্রিয়া',
    distanceFromTop: 'উপর থেকে দূরত্ব',
    distanceFromRight: 'ডান থেকে দূরত্ব',
    hingeData: 'কব্জার ডেটা',
    labelBackProcTip: 'এই আপডেটে বড় বোর্ডের পিছনে লেবেল করার পদ্ধতি অপ্টিমাইজ করা হয়েছে, এখন লেবেলের তথ্য অনুযায়ী সরাসরি এজ সিল করুন',
    openDir: 'দরজা খোলার দিক',
    edgeEmptyTip: 'ট্রিমিং মান খালি রাখা যাবে না',
    edgeNumberLimit: 'ট্রিমিং মান শুধুমাত্র সংখ্যা হতে পারে',
    chooseSurplusQuantity: 'ব্যবহারযোগ্য উদ্বৃত্ত উপকরণ মোট {total} ধরন, {quantity} ধরন নির্বাচিত',
    noCanSaveInfo: 'সংরক্ষণযোগ্য কোনো তথ্য নেই',
    chooseBujianStoreQuantity: 'মোট {total} টি পরিপূরক, {quantity} টি পরিপূরক বোর্ড যোগ করা যাবে, {chooseQuantity} টি নির্বাচিত',
    isConfirmPushToAwaitStore: 'নির্বাচিত বোর্ডগুলো অপেক্ষাধীন লেআউট ওয়্যারহাউসে যোগ করতে নিশ্চিত করবেন কি?',
    enterAutoCreateMatCode: 'Enter চাপলে স্বয়ংক্রিয়ভাবে উপকরণ তৈরি হবে',
    chooseAwaitStoreQuantity: 'অপেক্ষাধীন লেআউট ওয়্যারহাউসে {total} টি ছোট বোর্ড আছে, লেআউটে {quantity} টি অন্তর্ভুক্ত করা যাবে, {chooseQuantity} টি নির্বাচিত',
    defaultFold: 'বোর্ড ডেটা ডিফল্ট ভাঁজ করা',
    startArrange: 'লেআউট শুরু করুন',
    importMaterial: 'কাটার তালিকা আমদানি করুন',
    saveToHistory: 'ইতিহাসে সংরক্ষণ করুন',
    addPlank: 'বোর্ড যোগ করুন',
    addBujian: 'পরিপূরক যোগ করুন',
    deletePlank: 'বোর্ড মুছুন',
    batchEdit: 'ব্যাচ পরিবর্তন করুন',
    moreSetting: 'আরও সেটিংস',
    plankSize: 'বোর্ডের আকার',
    plankSize2: 'আকার (দৈর্ঘ্য * প্রস্থ * পুরুত্ব)',
    searchPlaceholder: 'বোর্ডের নাম/বোর্ড নম্বর অনুসন্ধান করুন',
    checkArranged: 'লেআউট দেখুন',
    checkErr: 'লেআউট করা হয়নি, দেখা যাচ্ছে না!',
    downloadSheet: 'টেমপ্লেট ডাউনলোড করুন',
    downloadSheetShowScientific: 'নমুনা টেবিল ডাউনলোড করুন (বৈজ্ঞানিক স্বরলিপি প্রদর্শন)',
    exportHoleSlotPDF: 'বোর্ডের গর্ত-স্লট চিত্র রপ্তানি করুন',
    style1: 'স্টাইল ১',
    style2: 'স্টাইল ২',
    style2PDF: 'স্টাইল ২ (PDF)',
    style2DXF: 'স্টাইল ২ (DXF)',
    style3: 'স্টাইল ৩',
    importNoCover: 'উপকরণ তালিকা আমদানিতে ওভাররাইট করা হবে না',
    openBujianPlankRecommend: 'পরিপূরক ছোট বোর্ডের পরামর্শ চালু করুন',
    openAwaitStorePlankRecommend: 'অপেক্ষাধীন লেআউট লাইব্রেরির ছোট বোর্ডের পরামর্শ চালু করুন',
    openSurplusPlankRecommend: 'উদ্বৃত্ত বড় বোর্ডের পরামর্শ চালু করুন',
    pushToAwaitStore: 'অপেক্ষাধীন লেআউট লাইব্রেরিতে সংরক্ষণ করুন',
    setTableHead: 'কাটার তালিকার শিরোনাম সেট করুন',
    syncConfirm: 'ক্যাবিনেট এবং ক্লাউড টাইপসেটিং মূল শীট ডেটা অসামঞ্জস্যপূর্ণ! ক্যাবিনেটের মূল শীট ডেটার সাথে সিঙ্ক্রোনাইজ করবেন কি?',
    handleSync: 'নোট: মূল শীট ব্যবস্থাপনায় ম্যানুয়াল সিঙ্ক্রোনাইজেশন করা যাবে',
    noMoreTip: 'আর প্রম্পট নেই',
    checkMore: 'আরও দেখুন',
    noHistory: 'সংরক্ষিত ইতিহাস নেই...',
    sameOrder: 'উৎপাদন ফাইল রপ্তানি করা অর্ডার আছে, অনুগ্রহ করে ডুপ্লিকেট উৎপাদনের সমস্যায় মনোযোগ দিন!',
    markOrder: 'অর্ডার পেজে উৎপাদিত হিসেবে চিহ্নিত করবেন কি?',
    editErrTip: 'একাধিক অর্ডারে তথ্য সংশোধন সমর্থিত নয়',
    autoSaveSuccess: 'ইতিহাসে স্বয়ংক্রিয়ভাবে সংরক্ষিত হয়েছে!',
    goAdd: 'যোগ করতে যান',
    noProductionLine: 'এই রেকর্ডের উৎপাদন লাইন মুছে দেওয়া হয়েছে, কাটার তালিকায় যেয়ে পুনরায় লেআউট করুন',
    fileErr: 'ফাইল বিষয়বস্তু পার্স ব্যর্থ, ফাইল বিষয়বস্তু নিশ্চিত করুন!',
    noCheckData: 'কোনো ডেটা পাওয়া যায়নি!',
    noArrangeTip: 'লেআউট পরিকল্পনা সরাসরি দেখা যাচ্ছে না, লেআউট শুরু করুন ক্লিক করুন!',
    tooOld: 'পাঁচ/ছয় মুখ ড্রিলের সেটিং খুব পুরনো',
    contactUs: 'অনুগ্রহ করে বিক্রয়োত্তর কর্মীদের সাথে যোগাযোগ করুন পুনরায় সংযোগ করতে',
    pathErr: 'বোর্ডের ভেতরে অস্বাভাবিক ডেটা আছে (বোর্ড নম্বর: {errorPathPlankID}), পরীক্ষা করুন!',
    sizeErr: 'অতিরিক্ত বড় বোর্ড আছে! ছোট বোর্ডের আকার: {width}-{height}',
    noKnife: 'কাটার ছুরির ব্যাস সেট করা হয়নি, খোদাই মেশিনে গিয়ে টুল সেট করুন!',
    noKnifeDiameter: 'উৎপাদন লাইনের কাটার ছুরি ({name}) ব্যাস খালি, সংশ্লিষ্ট ছুরির ব্যাস যোগ করতে যান',
    openDifferentMaterialCuttingKnives: 'বিভিন্ন উপকরণের কাটার ছুরি সক্রিয় করা হয়েছে',
    sendFactorySuccess: 'ওয়ার্কশপে সফলভাবে পাঠানো হয়েছে',
    sendFactoryErr: 'ওয়ার্কশপে পাঠাতে ব্যর্থ, বিক্রয়োত্তর কর্মীদের সাথে যোগাযোগ করুন',
    createTaskCard: 'সংশ্লিষ্ট টাস্ক কার্ড তৈরি করবেন কি?',
    surplusStatistics: 'ব্যবহারযোগ্য উদ্বৃত্ত উপকরণ মোট',
    surplusStatistics2: 'নির্বাচিত',
    suplementStatistic: 'টি পরিপূরক, পরিপূরক বোর্ড সহ মোট',
    expand: 'প্রসারিত করুন',
    packUp: 'সংকুচিত করুন',
    importErr: 'সঠিক ফাইল নির্বাচন করুন!',
    sendLoadingText: 'NC ফাইল প্রক্রিয়া করে পাঠানো হচ্ছে......',
    arrangeLoading: 'মোট',
    arrangeLoading2: 'টি ছোট বোর্ড লেআউট অপ্টিমাইজ করা হচ্ছে......',
    dealing: 'প্রক্রিয়াকরণ হচ্ছে...',
    deleteConfirm: 'মুছে ফেলার পর উদ্বৃত্ত উপকরণটি রিসাইকেল বিনে যাবে। আপনি কি এটি মুছে ফেলতে চান?',
    copyTip: 'নির্বাচিত উদ্বৃত্ত উপকরণ কপি করা হবে',
    copyTip2: 'কপি করার পরিমাণ নিশ্চিত করুন',
    surplusHead: {
      shape: 'আকৃতি',
      type: 'ধরন',
      remark: 'মন্তব্য',
      area: 'ক্ষেত্রফল(m²)',
      area1: 'ক্ষেত্রফল'
      },
    surplusTip: 'এখন ব্যবহারযোগ্য উদ্বৃত্ত উপকরণ নেই, আপনি প্রথমে যেতে পারেন',
    creatSurplus: 'নতুন উদ্বৃত্ত উপকরণ তৈরি করুন',
    orderInfo: 'অর্ডার তথ্য',
    suplement: {
      statistic: 'মোট {total} টি পরিপূরক, {useable} টি পরিপূরক বোর্ড সহ পাঠানো যাবে, {selected} টি নির্বাচিত',
      exportSuplement: 'পরিপূরক তালিকা রপ্তানি করুন',
      suplementLoading: 'পরিপূরক ডেটা লোড হচ্ছে',
      exportSuplementIng: 'পরিপূরক তালিকা রপ্তানি হচ্ছে',
      noMatchSup: 'ব্যবহারযোগ্য পরিপূরক ডেটা পাওয়া যায়নি',
      exportTip: 'রপ্তানির আগে অন্তত একটি পরিপূরক নির্বাচন করুন'
      },
    empty: 'কোনো বোর্ড ডেটা নেই',
    paibanSetting: {
      title: 'লেআউট সেটিংস',
      createTask: 'লেআউট কাজ সৃষ্টি',
      selectProduction: 'উৎপাদন লাইন নির্বাচন',
      arrangeWay: 'লেআউট পরিকল্পনা নির্বাচন',
      suitText: 'উপযুক্ত：',
      surplusTrimTip: 'নোট: আপনি উদ্বৃত্ত উপকরণের কাস্টম ট্রিমিং ফিচার ব্যবহার করছেন, শুধুমাত্র করাত কাটার লেআউট নির্বাচন করা যাবে',
      suitEquipmentNormal: 'সাধারণ খোদাই মেশিন',
      suitEquipmentSpecial: 'কাচ কাটার মেশিন, করাত মেশিন',
      lessRoll: 'কম উল্টানো',
      computedSpecial: 'বিশেষ আকৃতি গণনা করুন',
      specialTip: 'লেআউট গতিকে প্রভাবিত করে',
      irregularNesting: 'অনিয়মিত নেস্টিং',
      primaryNesting: 'প্রাথমিক নেস্টিং',
      specialShapedPanel: 'বিশেষ আকৃতির সাধারণ বোর্ড নেস্টিং',
      limitedTimeTrial: 'Limited Free',
      seniorShape: 'উন্নত নেস্টিং',
      heteromorphicInlay: 'বিশেষ আকৃতির ভেতরে বিশেষ আকৃতি নেস্টিং',
      autoCutSurplus: 'উদ্বৃত্ত উপকরণ স্বয়ংক্রিয় কাটা',
      cutWay: 'কাটার পদ্ধতি',
      maxRect: 'সর্বোচ্চ আয়তক্ষেত্রে কাটুন',
      fixedRect: 'নির্দিষ্ট আকারে কাটুন',
      minRectSetting: 'সর্বনিম্ন কাটার আকার',
      firstCutL: 'কাটায় L-আকারের উদ্বৃত্ত তৈরিকে অগ্রাধিকার দিন',
      firstCutLTip: 'চালু হলে শর্ত পূরণকারী আয়তক্ষেত্রাকার বোর্ডগুলোকে L-আকারের উদ্বৃত্তে কাটাকে অগ্রাধিকার দেওয়া হবে',
      shortLine: 'ছোট বাহু এর চেয়ে বড়',
      longLine: 'লম্বা বাহু এর চেয়ে বড়',
      setDifferentThickness: 'বিভিন্ন পুরুত্বের বোর্ডের সর্বনিম্ন কাটার আকার সেট করুন',
      defaultRuleTip: 'বোর্ডের পুরুত্ব নিয়মের সাথে না মিললে ডিফল্ট নিয়ম অনুযায়ী কাটুন',
      panelThickness: 'বড় বোর্ডের পুরুত্ব',
      duplicateMinCutSize: 'বর্তমান পুরুত্বে ইতিমধ্যে একই সর্বনিম্ন কাটার আকার আছে',
      templateEmpty: '"বিভিন্ন পুরুত্বের বোর্ডের সর্বনিম্ন কাটার আকার সেট করুন" টেমপ্লেট ডেটা খালি রাখা যাবে না!',
      duplicateThicknessData: '"বিভিন্ন পুরুত্বের বোর্ডের সর্বনিম্ন কাটার আকার সেট করুন" টেমপ্লেট ডেটায় পুনরাবৃত্ত পুরুত্ব ডেটা আছে!',
      atLeastOne: 'অন্তত একটি আইটেম রাখতে হবে!',
      maxAddFive: 'সর্বোচ্চ পাঁচটি যোগ করা যাবে!',
      surplusTemplate: 'উদ্বৃত্ত উপকরণের সাধারণ টেমপ্লেট',
      add: 'যোগ করুন',
      templateErr: 'সাধারণ আকারে কাটা নির্বাচন করার সময় কমপক্ষে একটি ডেটা টেমপ্লেট নির্বাচন করতে হবে',
      cutLong: 'কাটার দৈর্ঘ্য',
      cutWidth: 'কাটার প্রস্থ',
      baseInfo: 'মূল তথ্য',
      continue: 'নিশ্চিত করুন এবং চালিয়ে যান',
      standardSelect: 'স্ট্যান্ডার্ড বড় বোর্ড নির্বাচন',
      customPlankOrder: 'বড় বোর্ড লেআউট ক্রম কাস্টমাইজ করুন',
      customPlankOrderDetail: 'অসজ্জিত ছোট বোর্ডের তালিকা',
      customPlankOrderTip: 'এমবেডেড ক্লাউড লেআউট এই ফিচারে কার্যকর নয়',
      customPlankOrderBrandTip: 'লেআউটের অপেক্ষায় থাকা অর্ডারে ব্র্যান্ড কালার কার্ড বোর্ড রয়েছে, এই ফিচারটি ডিফল্টভাবে ব্যবহৃত হয়',
      surplusPlank: 'অবশিষ্ট ছোট বোর্ডের তালিকা',
      overSizePlank: 'অতিরিক্ত আকারের বোর্ডের তালিকা',
      plankOrder: 'লেআউট ক্রম',
      plankType: 'বোর্ডের ধরন',
      plankSize: 'বোর্ডের আকার',
      plankEdgeOff: 'ট্রিমিং মান',
      amount: 'কাটার পরিমাণ',
      amountMax: 'সর্বোচ্চ কাটার পরিমাণ',
      numAndOverSizeTip: 'ছোট বোর্ড আকার সীমা অতিক্রম করেছে এবং বড় বোর্ডের পরিমাণ অপর্যাপ্ত, লেআউট করা যাচ্ছে না',
      numErrorTip: 'বড় বোর্ডের ব্যবহার অপর্যাপ্ত, লেআউট করা যাচ্ছে না',
      overSizeTip: 'ছোট বোর্ড আকার সীমা অতিক্রম করেছে, লেআউট করা যাচ্ছে না',
      restPartList: 'অসজ্জিত ছোট বোর্ডের তালিকা',
      layoutOrder: 'লেআউট ক্রম',
      arrangeAmount: 'কাটার পরিমাণ',
      specialShapeTip: 'বিশেষ আকৃতির উদ্বৃত্ত উপকরণে করাত কাটার লেআউট ব্যবহার করা যাবে না',
      surplusConflictTip: 'উদ্বৃত্ত কাটা বোর্ডের কনটুরের সাথে দ্বন্দ্ব, পুনরায় কাটুন',
      stackingMethod: {
        title: 'লেআউট স্ট্যাকিং পদ্ধতি',
        long: 'দীর্ঘ বাহু অনুসারে লেআউট করুন',
        short: 'কর্মকার বাহু অনুসারে লেআউট করুন'
        },
      seniorShapeTip: '【উন্নত নেস্টিং】বিনামূল্যে ট্রায়ালের মেয়াদ শেষ হয়েছে, আপনি উন্নত নেস্টিং লেআউটের ফলাফল প্রিভিউ করতে পারেন (সাধারণ উৎপাদনের জন্য সাধারণ নেস্টিংয়েও স্যুইচ করতে পারেন); উন্নত নেস্টিং উৎপাদন ফাইল এক্সপোর্ট করতে চাইলে বিক্রয় কর্মীর সাথে যোগাযোগ করে কিনুন~'
      },
    filter: {
      title: 'বোর্ড ফিল্টার',
      search: 'অনুসন্ধান করুন',
      all: 'সব নির্বাচন করুন',
      diskSize: 'বোর্ড ফিল্টার বাতিল করুন',
      resetFilter: 'ফিল্টার বাতিল করুন'
      },
    edit: {
      title: 'ব্যাচ পরিবর্তন',
      target: 'পরিবর্তনের লক্ষ্য',
      onlineSelectRow: 'শুধুমাত্র নির্বাচিত সারি',
      allRow: 'সব সারি',
      editKey: 'পরিবর্তন করতে হবে এমন বিষয়বস্তু',
      editValue: 'এতে পরিবর্তন করুন',
      warningTip: 'সতর্কতা: পরিবর্তনের পর গর্ত-স্লট এবং বিশেষ আকৃতি স্বয়ংক্রিয়ভাবে সাফ হবে',
      allEdge: 'সব প্রান্ত বন্ধ করুন'
      },
    add: {
      title: 'বোর্ড যোগ করুন',
      continue: 'নিশ্চিত করুন এবং চালিয়ে যান',
      matCodeErr: 'উপকরণ খালি রাখা যাবে না',
      thickErr: 'পুরুত্ব খালি রাখা যাবে না',
      colorErr: 'রঙ খালি রাখা যাবে না',
      longErr: 'সম্পন্ন পণ্যের দৈর্ঘ্য খালি রাখা যাবে না',
      widthErr: 'সম্পন্ন পণ্যের প্রস্থ খালি রাখা যাবে না',
      countErr: 'পরিমাণ কমপক্ষে ১ হতে হবে'
      },
    delete: {
      tip: 'এই ডেটা মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন কি?',
      errTip: 'এই অপারেশন করার আগে অন্তত একটি বোর্ড নির্বাচন করুন!',
      errTip1: 'লেআউটের আগে অন্তত একটি বোর্ড নির্বাচন করুন',
      confirm: 'মুছা নিশ্চিত করুন'
      },
    restore: {
      confirm: 'পুনরুদ্ধার নিশ্চিত করুন'
      },
    restoreConfirm: 'পুনরুদ্ধারের পর উদ্বৃত্ত উপকরণটি উদ্বৃত্ত তালিকায় বা উদ্বৃত্ত গুদামে ফিরিয়ে নেওয়া হবে। আপনি কি এই উপকরণটি পুনরুদ্ধার করতে চান?',
    restoreBatchConfirm: 'নির্বাচিত উদ্বৃত্ত উপকরণগুলি পুনরুদ্ধার করতে চান?',
    save: {
      errTip: 'সংরক্ষণ করার কোনো তথ্য নেই!',
      title: 'পরিকল্পনা সংরক্ষণ করুন',
      subTitle: '(নোট: ইতিহাস শুধুমাত্র এক বছর সংরক্ষিত হয়)',
      name: 'পরিকল্পনার নাম',
      historyName: 'ঐতিহাসিক পরিকল্পনা',
      successTip: 'সংরক্ষণ সফল হয়েছে!',
      fieldTip: 'সংরক্ষণ ব্যর্থ হয়েছে!'
      },
    exportErr: 'কোনো বোর্ড নেই, রপ্তানি করা যাচ্ছে না',
    exportPicErr: 'বোর্ড গর্ত-স্লট চিত্র রপ্তানিকালে অজানা ত্রুটি ঘটেছে, আমাদের সাথে যোগাযোগ করুন',
    plankNotFound: 'সংশ্লিষ্ট বোর্ড পাওয়া যায়নি! বোর্ড আঁকা হয়েছে কিনা নিশ্চিত করুন!',
    noPlankName: 'বোর্ডের নাম পাওয়া যায়নি',
    plankDataErr: 'বোর্ড ডেটা ভুল, উৎপাদন ক্ষতি এড়াতে সাবধানে পরীক্ষা করুন',
    exportThreeViewErr: 'গর্ত-স্লট ত্রিভিউ রপ্তানি ব্যর্থ হয়েছে, বিক্রয়োত্তর সেবায় যোগাযোগ করুন',
    heighGlossWarning: 'নোট: উপকরণ হাই গ্লস বোর্ড হলে, উপকরণ পরিবর্তনের পরে বোর্ডটি হাই গ্লস বোর্ডে পুনরুদ্ধার করা যাবে না!',
    reset: 'ডিফল্ট পুনরুদ্ধার করুন',
    settingHead: {
      title: 'কাটার তালিকার শিরোনাম সেট করুন',
      head: 'সারণী শিরোনাম',
      customHeadName: 'কাস্টম শিরোনামের নাম',
      example: 'নমুনা',
      tip: 'পরিচালনা টিপস: সারণী শিরোনাম ডেটা লেবেলের অবস্থান বাম-ডানে টেনে পরিবর্তন করা যায়',
      headerNameEmpty: 'শিরোনাম খালি রাখা যাবে না',
      duplicateHeader: 'সারণী শিরোনামের সদৃশ আছে'
      },
    copyLine: 'ক্লিক করে নিচে বর্তমান সারি কপি করুন',
    copySuccess: '{name} ডেটা কপি সফল হয়েছে',
    arranging: 'মোট {count} টি ছোট বোর্ড লেআউট অপ্টিমাইজ করা হচ্ছে......',
    overSize: {
      title: 'বোর্ড অতিরিক্ত আকার',
      subTitle: 'অতিরিক্ত আকারের বোর্ড তালিকা',
      overSizeTip: 'বোর্ড অতিরিক্ত আকারের সতর্কবার্তা',
      nonWorkInfo: 'প্রক্রিয়া করা যাচ্ছে না এমন বোর্ডের বিস্তারিত',
      mergeFrameDoorWholeTip: 'দ্রষ্টব্য: এই প্যার্ট একটি মার্জ প্রসেসিং ফ্রেম ডোর সম্পূর্ণ',
      conflictWorkInfo: 'সাংঘর্ষিক বোর্ডের বিস্তারিত',
      warning: 'ছোট বোর্ডের আকার অত্যধিক দীর্ঘ হওয়ায় লেআউট করা যাচ্ছে না! ছোট বোর্ডের আকার ঠিক করুন বা সংশ্লিষ্ট আকারের মূল শীট যোগ করুন',
      checkInfo: 'বোর্ডের বিস্তারিত দেখুন',
      tipContent: 'সিস্টেম লেআউট ছোট বোর্ডে অতিরিক্ত আকারের বোর্ড শনাক্ত করেছে, বিশেষ বোর্ড যোগ করার পরামর্শ দেওয়া হচ্ছে',
      add: 'এক ক্লিকে যোগ করুন',
      addPlank: 'মূল শীট যোগ করুন',
      error: 'বোর্ড অতিরিক্ত আকার, লেআউট ব্যর্থ হয়েছে',
      successTip: 'বোর্ড সফলভাবে যোগ করা হয়েছে! পুনরায় লেআউট করা হচ্ছে',
      warningTip: 'বোর্ডের দৈর্ঘ্য ও প্রস্থ পূরণ করুন!'
      },
    arrangeErr: 'বোর্ডের অভ্যন্তরীণ ডেটায় অস্বাভাবিকতা আছে, লেআউট উৎপাদন করা সম্ভব নয়',
    nonDelete: 'মুছা যাবে না',
    addOverSizeTip: 'অতিরিক্ত আকার আছে, পুনরায় যোগ করুন',
    addPlankSuccess: 'বিশেষ বড় বোর্ড সফলভাবে যোগ করা হয়েছে',
    addPlankFail: 'বিশেষ বড় বোর্ড যোগ করা ব্যর্থ হয়েছে',
    paibanFeedback: 'লেআউট ফিডব্যাক',
    cuttingAndPaoban: 'কাটা এবং পাওবান',
    lowUtilizationRate: 'কম ব্যবহারের হার',
    unreasonableLayout: 'অযৌক্তিক লেআউট',
    feedbackSuccessTip: 'ফিডব্যাক সফল হয়েছে!',
    feedbackFailTip: 'ফিডব্যাক ব্যর্থ হয়েছে!',
    mixedLayoutScheme: 'এই মিশ্র লেআউট পরিকল্পনা'
    },
  arrangedPage: {
    subtleDownloadCheckTip: 'বোর্ড ডেটা পরিবর্তিত হয়েছে কিন্তু পরিকল্পনা সংরক্ষিত হয়নি, পরবর্তী অপারেশনের আগে পরিকল্পনা সংরক্ষণ নিশ্চিত করুন',
    paibanRequestFailed: 'লেআউট অনুরোধ ব্যর্থ হয়েছে, আবার চেষ্টা করুন',
    accordingPlankCountOrder: 'বড় বোর্ডের সংখ্যা অনুযায়ী উচ্চ থেকে নিম্নে সাজান',
    editOrder: 'ক্রম নম্বর সম্পাদনা করুন',
    dragOrder: 'টেনে সাজান',
    inputOrder: 'ক্রম ইনপুট করুন',
    editOrderTip: 'ক্রম সামঞ্জস্য করুন',
    range: 'পরিসর',
    unsupportRotateTip: 'কিছু বড় বোর্ড ঘোরানো হয়েছে এবং পুনরায় লেআউট এখন সমর্থিত নয়। ঘোরানো বড় বোর্ডের ক্রম নম্বর:',
    slotErrTip: 'বর্তমান বোর্ডে প্রান্ত প্রক্রিয়াকরণের খাঁজ আছে, পুনরায় লেআউট সমর্থিত নয়!',
    lockedPaibanTip: 'বড় বোর্ড লক করা আছে, পুনরায় লেআউট করা যাবে না',
    batchBujianErrTip: 'বর্তমান বোর্ড মূল উপকরণ তালিকায় নেই, পরিপূরক/লেআউট অপেক্ষায় লাইব্রেরি থেকে পুনরায় লেআউট নির্বাচন করুন',
    useFolderIsNot: 'ফাইল ডাউনলোড সংরক্ষণের অবস্থান "{type}" নেই বলে পাওয়া গেছে! ফোল্ডার মুছা হয়েছে কিনা পরীক্ষা করুন',
    useFolderIsNot1: 'ফাইল ডাউনলোড অবস্থান সেট করা হয়নি বলে পাওয়া গেছে, প্রথমে ডিরেক্টরি নির্বাচন করুন',
    downloadNC: 'NC ডাউনলোড করুন',
    downloadNC1: 'NC ফাইল ডাউনলোড করুন',
    reArrange: 'পুনরায় লেআউট করুন',
    reArrangeSpecifiedMaterialGroup: 'নির্দিষ্ট প্যানেল গ্রুপ পুনরায় সাজান',
    specifiedMaterialRelayoutMoreResultTip: 'নির্দিষ্ট প্যানেল গ্রুপ পুনরায় সাজানোর পরে আর কোনও অতিরিক্ত লেআউট ফলাফল দেওয়া হবে না',
    searchMaterialGroup: 'প্যানেল গ্রুপ অনুসন্ধান করুন',
    saveToHistory: 'ইতিহাসে সংরক্ষণ করুন',
    moreSetting: 'আরও',
    cutIndexRe: 'ctrl+z কী ব্যবহার করে পূর্ববর্তী কাজ বাতিল করুন',
    followExportTag: 'NC ডাউনলোডের সাথে লেবেল ফাইল রপ্তানি করুন',
    followExportPaibanImg: 'NC ডাউনলোডের সাথে লেআউট চিত্র ফাইল রপ্তানি করুন',
    followExportWorkerShop: 'NC ডাউনলোডের সাথে ক্রয় আদেশ রপ্তানি করুন',
    tagTemplateSelect: 'লেবেল টেমপ্লেট নির্বাচন',
    showCuttingSequence: 'কাটার ক্রম দেখান',
    showPlankSize: 'ছোট বোর্ডের আকার দেখান',
    sendToFactory: {
      title: 'কর্মশালায় পাঠান',
      fileType: 'লেবেল ফাইলের ধরন'
      },
    checkData: 'ডেটার অখণ্ডতা পরীক্ষা করা হচ্ছে...',
    dataLoading: 'লোড হচ্ছে......',
    addToBujianStore: 'সরবরাহ গুদামে যোগ করা হচ্ছে...',
    updateTaskStatus: 'কাজের অবস্থা আপডেট হচ্ছে...',
    sending: 'কর্মশালায় পাঠানো হচ্ছে',
    waitLoadding: 'অপেক্ষা করছে',
    loadding: 'চলছে',
    finish: 'সম্পন্ন',
    loadSetting: 'সেটিংস লোড করুন',
    loadPreference: 'পছন্দের সেটিংস লোড করুন',
    dealTemplate: 'টেমপ্লেট প্রক্রিয়া করুন',
    initTagData: 'ট্যাগ ডেটা আরম্ভ করুন',
    prepareDrawData: 'লেবেল ড্রইং ডেটা প্রস্তুত করুন',
    drawDataText: 'লেবেল ড্রইং ডেটা',
    genPdfTagFile: 'PDF লেবেল ফাইল তৈরি করুন',
    genPicTagFile: 'লেবেল ছবির ফাইল তৈরি করুন',
    uploadFile: 'ফাইল আপলোড করুন',
    dealNCFile: 'NC ফাইল প্রক্রিয়া করুন',
    zipFile: 'স্থানীয় সংকুচিত ফাইল তৈরি করুন',
    plankCount: 'বড় বোর্ডের সংখ্যা',
    rollCount: 'উল্টানোর সংখ্যা',
    totalRate: 'সার্বিক অপ্টিমাইজেশন হার',
    rate: 'অপ্টিমাইজেশন হার',
    useArea: 'অপ্টিমাইজ করা ক্ষেত্রফল',
    materialList: 'উপকরণ তালিকা',
    saveSurplus: 'উদ্বৃত্ত উপকরণ গুদামে রাখুন',
    workeShop: 'ক্রয় আদেশ',
    batchTagging: 'ব্যাচ লেবেল পরিপূরক',
    batchTaggingTip: 'নিচে থেকে অতিরিক্ত লেবেল প্রয়োজন এমন বোর্ড নির্বাচন করুন',
    holeSlotErr: 'বোর্ডে গর্ত-স্লটের গভীরতায় অস্বাভাবিকতা পাওয়া গেছে!',
    knivesErr: 'বোর্ড প্রক্রিয়াকরণের সরঞ্জাম পাওয়া যাচ্ছে না বলে পাওয়া গেছে!',
    checkDetail: 'বিস্তারিত দেখুন',
    deepErr: {
      title: 'বোর্ড গর্ত-স্লটের গভীরতায় অস্বাভাবিকতা',
      errStatistic: 'ছোট বোর্ডে {count} টি অস্বাভাবিকতা আছে',
      errText: 'অস্বাভাবিক অংশ',
      markErrPart: 'অস্বাভাবিক অংশ চিহ্নিত করুন'
      },
    warningTip: 'দ্বিপার্শ্বিক প্রক্রিয়াকরণ: প্রথমে গ্লসি পৃষ্ঠ প্রক্রিয়া করুন, তারপর ম্যাট পৃষ্ঠ; একপাশের প্রক্রিয়াকরণ: ম্যাট পৃষ্ঠ সরাসরি প্রক্রিয়া করুন',
    showDetail: {
      tip1: 'ক্লিক করে একটি বোর্ড নির্বাচন করুন',
      tip2: 'বোর্ডের লেবেল দেখুন'
      },
    arrangeTip: '(অনিয়মিত নেস্টেড লেআউট সমর্থিত হয়েছে)',
    plankOpration: 'বোর্ড অপারেশন',
    rotate: '৯০ ডিগ্রি ঘোরান',
    notCare: 'বোর্ডে কোনো টেক্সচার নেই',
    editRemark: 'মন্তব্য সম্পাদনা করুন',
    clearRemark: 'মন্তব্য মুছুন',
    recalcIndex: 'ছুরি পয়েন্ট এবং কাটার ক্রম পুনরায় গণনা করুন',
    recalcIndexSuccess: 'ছুরি পয়েন্ট এবং কাটার ক্রম পুনরায় গণনা সফল হয়েছে',
    storageArea: {
      title: 'বোর্ড অস্থায়ী সংরক্ষণ এলাকা',
      empty: 'কোনো বোর্ড অস্থায়ীভাবে সংরক্ষিত নেই',
      storageTip: 'বোর্ড এখানে টেনে অস্থায়ীভাবে সংরক্ষণ করুন'
      },
    subtleArrange: 'সূক্ষ্ম লেআউট',
    addPlank: 'বড় বোর্ড যোগ করুন',
    deletePlank: 'বড় বোর্ড মুছুন',
    deletePlankErr: 'বর্তমান বড় বোর্ডে ছোট বোর্ড আছে, বড় বোর্ড মুছা যাবে না!',
    useSurplus: {
      title: 'উদ্বৃত্ত উপকরণ ব্যবহার করুন'
      },
    dragWarning: 'বোর্ডকে বড় বোর্ডের উপরে টেনে নিয়ে যান!',
    areaWarning: 'বোর্ড স্থাপন করা যাচ্ছে না, খালি জায়গার আকার লক্ষ্য করুন',
    subtlePage: {
      cut: 'উদ্বৃত্ত উপকরণ কাটা',
      lineTip: 'বোর্ড লেআউটের অপেক্ষায় অঞ্চল',
      cancelCut: 'কাটা শেষ করুন',
      cutPoint: 'উদ্বৃত্ত কাটার শোষণ বিন্দু',
      storageArea: 'বোর্ড লেআউটের অপেক্ষায় অঞ্চল',
      cutErr: 'শুধুমাত্র বড় বোর্ডে কাটা যাবে, ছোট বোর্ড স্পর্শ করা যাবে না!',
      saveErr: 'প্রথমে একটি কাটার উদ্বৃত্ত উপকরণ নির্বাচন করুন',
      cutErr2: 'শুধুমাত্র বড় বোর্ডে কাটা যাবে, বড় বোর্ড অতিক্রম করা যাবে না!',
      selectTip: 'কাটার জন্য একটি উদ্বৃত্ত উপকরণ বোর্ড নির্বাচন করুন',
      noCutPath: 'অনিয়মিত অংশে আয়তক্ষেত্র কাটা যাবে না',
      cutOperate: 'উদ্বৃত্ত উপকরণ কাটার অপারেশন',
      line: 'ম্যানুয়াল স্ট্রোক',
      cutErrtip: 'কাটার বিন্দুতে ছেদ সমস্যা আছে, পুনরায় কাটুন',
      cutErrtip2: 'কাটার বিন্দু সীমা ৯ অতিক্রম করবে, পুনরায় কাটুন'
      },
    shortCut: 'কীবোর্ড শর্টকাট',
    updownRoll: 'উপরে নিচে স্ক্রল করুন',
    leftRightRoll: 'বাম ডানে স্ক্রল করুন',
    zoomScale: 'জুম ইন আউট করুন',
    dragCanvas: 'পেজ টেনে নিয়ে যান',
    mouseRoll: 'মাউস স্ক্রোল হুইল',
    mouseRight: 'মাউসের ডান বোতাম',
    doublePlank: 'বড় বোর্ডে ডাবল ক্লিক করুন',
    keyboard: 'কীবোর্ড',
    picSymble: 'কিংবদন্তি',
    funished: 'সম্পন্ন পণ্য',
    holeSlotConflict1: 'গর্ত-স্লট সংঘাত',
    plankErr: 'বোর্ড সংঘাত',
    frontSlot: 'সামনের স্লট',
    backSlot: 'পিছনের স্লট',
    frontHole: 'সামনের গর্ত',
    backHole: 'পিছনের গর্ত',
    resetScale: 'জুম রিসেট করুন',
    maxLong: 'সর্বোচ্চ দৈর্ঘ্য',
    tempErr: 'যোগ করতে ব্যর্থ, টেমপ্লেট অবস্থান সঠিক নয় বা টেমপ্লেট অনেক বড়!',
    sendErr: 'কর্মশালায় পাঠানো ব্যর্থ, লেবেল টেমপ্লেট ও বোর্ড ডেটা সঠিক কিনা যাচাই করে পুনরায় পাঠান',
    someTips: 'আপনি সীমিত সময়ের জন্য ক্লাউড লেআউটের অনিয়মিত স্ক্র্যাপ/নেস্টিং ফিচার ব্যবহার করছেন, উৎপাদন সমস্যা এড়াতে সতর্ক থাকুন!',
    nestingTips: '[Advanced Irregular Nesting Layout]-এর সীমিত সময়ের বিনামূল্যে ট্রায়াল শেষ হয়েছে। চালিয়ে যেতে সেলস টিমের সঙ্গে যোগাযোগ করে কিনুন!',
    frameDoorTip: 'ফ্রেম ডোর কাটার ক্রম সঠিক নয়, ছুরি পয়েন্ট এবং কাটার ক্রম পুনরায় গণনা করতে ক্লিক করুন!',
    cutOrderErr: 'কাটার ক্রম সঠিক নয়, ছুরি পয়েন্ট এবং কাটার ক্রম পুনরায় গণনা করতে ক্লিক করুন!',
    holeSlotConflict: 'বোর্ডে গর্ত-স্লট সংঘাত/ছোট বোর্ড উড়ে বের হওয়া পাওয়া গেছে',
    exportSetting: 'রপ্তানি সেটিংস',
    currentTagTemp: 'বর্তমান ট্যাগ টেমপ্লেট',
    specialPaibanErr: 'কিছু বোর্ডে বিশেষ প্রক্রিয়া আছে, এখন পুনরায় লেআউট সমর্থিত নয়!',
    moreResult: 'আরও ফলাফল',
    moreResultTip: 'বড় বোর্ডে প্রান্ত প্রক্রিয়াকরণের খাঁজ থাকলে, বড় বোর্ড পুনরায় লেআউটে অংশগ্রহণ করবে না',
    batchBujian: 'ব্যাচ পরিপূরক',
    batchOperation: 'ব্যাচ অপারেশন',
    batchEditPlankSize: 'বড় বোর্ডের আকার ব্যাচে পরিবর্তন করুন',
    editPlankSize: 'আকার পরিবর্তন করুন',
    editWay: 'পরিবর্তনের পদ্ধতি',
    editByType: 'ধরন অনুযায়ী পরিবর্তন করুন',
    editByPlankNumber: 'বোর্ড নম্বর অনুযায়ী পরিবর্তন করুন',
    editContent: 'পরিবর্তনের বিষয়বস্তু',
    editContentTip: 'পরিবর্তন করতে হবে এমন বড় বোর্ডের ধরন নির্বাচন করুন',
    editContentTip1: 'পরিবর্তন করতে হবে এমন বড় বোর্ডের নম্বর নির্বাচন করুন',
    editStart: 'শুরু',
    editEnd: 'শেষ',
    bigPlank: 'বড় বোর্ড',
    editSize: 'আকার পরিবর্তন করুন',
    bigPlankWidth: 'বড় বোর্ডের প্রস্থ',
    bigPlankHeight: 'বড় বোর্ডের দৈর্ঘ্য',
    bigPlankLengthMarking: 'বড় বোর্ডের দৈর্ঘ্য চিহ্নিতকরণ',
    markedAs: 'হিসেবে চিহ্নিত',
    maxAddTen: 'সর্বোচ্চ ১০টি যোগ করা যাবে',
    minValue: 'সর্বনিম্ন মান',
    differentKnifeErr: 'ভিন্ন কাটার ছুরি সহ বড় বোর্ড নির্বাচিত হয়েছে, আকার পরিবর্তন করা যাবে না',
    noEditablePlank: 'পরিবর্তন করার মতো যোগ্য বড় বোর্ড নেই',
    skipBrandPlankTip: 'নির্বাচিত পরিসরে {count}টি ব্র্যান্ড বড় বোর্ড আছে যা আকার পরিবর্তন সমর্থন করে না এবং বাদ দেওয়া হয়েছে',
    nonBrandToBrandTip: 'এই ছোট বোর্ডটি ব্র্যান্ড কালার কার্ড বড় বোর্ডে টেনে আনা যাবে না!',
    brandToNonBrandTip: 'এই ছোট বোর্ডটি নন-ব্র্যান্ড কালার কার্ড বড় বোর্ডে টেনে আনা যাবে না!',
    brandToOtherBrandTip: 'এই ছোট বোর্ডটি অন্য ব্র্যান্ড কালার কার্ড বড় বোর্ডে টেনে আনা যাবে না!',
    editNo: 'নম্বর',
    editAllPlank: 'সব বড় বোর্ড',
    editBigPartSize: 'বড় বোর্ডের আকার পরিবর্তন',
    disPlaySetting: 'প্রদর্শন সেটিংস',
    stored: 'গুদামে রাখা হয়েছে',
    onlySurplus: 'শুধুমাত্র উদ্বৃত্ত দেখুন',
    UnuseSurplus: 'উদ্বৃত্ত উপকরণ ব্যবহারের হার গণনায় অন্তর্ভুক্ত নয়',
    usePlankAdsorption: 'বোর্ড শোষণ ফিচার',
    dataDefaultCollapsed: 'ডিফল্টে ডেটা ভাঁজ করা',
    unit: 'টুকরো',
    cutSurplus: 'উদ্বৃত্ত কাটুন',
    frontWarningTip: 'দ্বিপার্শ্বিক প্রক্রিয়াকরণ: প্রথমে ম্যাট পৃষ্ঠ, তারপর গ্লসি পৃষ্ঠ; একপাশের: গ্লসি পৃষ্ঠ সরাসরি প্রক্রিয়া করুন',
    selectTip: 'নিচে থেকে পরিপূরক প্রয়োজন এমন ছোট বোর্ড নির্বাচন করুন!',
    plankKeyWordPlaceholder: 'বোর্ডের নাম বা নম্বর লিখুন',
    surplusStoreSuccess: 'গুদামে রাখা সফল হয়েছে',
    editCutOrder: 'কাটার ক্রম পরিবর্তন করুন',
    setCutPoint: 'ছুরি পয়েন্ট সেট করুন',
    specialPaibanChangeErr: 'বোর্ডে বিশেষ প্রক্রিয়া আছে, লেআউট স্কিম পরিবর্তন এখন সমর্থিত নয়!',
    storedSuccess: 'পরিপূরক সফল! নির্বাচিত বোর্ড পরিপূরক ব্যবস্থাপনায় রাখা হয়েছে!',
    noSurplus: 'ব্যবহারযোগ্য উদ্বৃত্ত পাওয়া যায়নি',
    selectErrTip: 'উদ্বৃত্ত বোর্ডে পরিপূরক করা যাবে না, প্রথমে স্বাভাবিক ছোট বোর্ড নির্বাচন করুন',
    noRoomIDTip: 'এই বোর্ডে রুম আইডি নেই, পরিপূরক গুদামে রাখা যাবে না, প্রথমে অন্য ছোট বোর্ড নির্বাচন করুন',
    noPlank: 'বোর্ড পাওয়া যায়নি',
    noPaibanData: 'কোনো লেআউট ডেটা নেই, এগিয়ে যাওয়া যাচ্ছে না',
    historyNameErr: 'পরিকল্পনার নাম লিখুন',
    tempErrTip: 'পাঁচ/ছয়-পার্শ্বিক ড্রিলিং টেমপ্লেট যোগ করা হয়নি, তাই ড্রিলিং ফাইল রপ্তানি করা যাচ্ছে না',
    changeDataTip: 'নোট: ডেটা পরিবর্তন পাওয়া গেছে, এই পরিবর্তন সংরক্ষণ করতে নতুন ইতিহাস ফাইল তৈরি করবেন?',
    upgrade: 'আপগ্রেড করুন',
    upgradeTip: ', নিচের বোতামে ক্লিক করে সংস্করণ আপগ্রেড করতে পারবেন',
    plankOverEdge: 'NC ডাউনলোড ব্যর্থ! বোর্ড ওভারল্যাপ বা বোর্ড বড় বোর্ডের বাইরে আছে কিনা পরীক্ষা করুন',
    useSurplusTip: 'উদ্বৃত্ত কাটা হবে কি',
    noDataExport: 'রপ্তানির জন্য কোনো লেআউট ডেটা নেই',
    noPlankExport: 'রপ্তানির জন্য কোনো ছোট বোর্ড ডেটা নেই',
    lockTip1: 'ক্লিক করে আনলক করুন, আনলকের পরে',
    lockTip2: 'ছোট বোর্ডের অবস্থান ও বৈশিষ্ট্য সম্পাদনা করা যাবে',
    unlockTip1: 'ক্লিক করে লক করুন, লকের পরে করা যাবে না',
    unlockTip2: 'ছোট বোর্ডের অবস্থান ও বৈশিষ্ট্যের সম্পাদনা',
    plankLockErr: 'এই বড় বোর্ড লক করা হয়েছে, স্থাপন করা যাবে না',
    lockPartEditTip: 'বোর্ড লক করা আছে, সম্পাদনা করা যাবে না',
    glassEquipmentTip: 'উৎপাদন লাইন কাচ কাটার মেশিন হলে বোর্ড সরানো যাবে না',
    expandedTip: 'বোর্ডে বিশেষ স্লটিং প্রক্রিয়া আছে, সম্পাদনা অপারেশন সমর্থিত নয়!',
    sameWidthPlankTip: 'করাত কাটার লেআউট চালু করা হয়েছে, বোর্ড সরানো যাবে না',
    expandedArrangeTip: 'বোর্ডে বিশেষ স্লটিং প্রক্রিয়া আছে, পুনরায় লেআউট প্রয়োজন!',
    dragErrTip: 'স্থাপন করা যাচ্ছে না, বোর্ডের উপকরণ, রঙ ও পুরুত্ব যাচাই করুন!',
    subtleSaveTip: 'বোর্ডে অপারেশন করা হয়েছে কিন্তু সংরক্ষণ হয়নি, বের হবেন?',
    rollTip: 'বড় বোর্ডে থ্রু হোল/স্লট আছে, উল্টানো সুপারিশ করা হয় না!',
    glossRollErr: 'গ্লসি বোর্ড উল্টানো নিষিদ্ধ',
    lockDeleteErr: 'বোর্ড লক করা আছে, মুছা যাবে না',
    deleteConfirmTip: 'মুছার অপারেশন পুনরুদ্ধার করা যাবে না',
    deleteContinueTip: 'চালিয়ে যেতে চান?',
    deleteConfirm: 'মুছা নিশ্চিত করুন',
    selectPlankTip: 'এই অপারেশনের আগে প্রথমে বোর্ড নির্বাচন করুন',
    storeFailTip: 'উদ্বৃত্ত গুদামে রাখা ব্যর্থ! বোর্ড ওভারল্যাপ বা বোর্ড বড় বোর্ডের বাইরে আছে কিনা পরীক্ষা করুন',
    repeatStoreErr: 'বর্তমানে কাটা উদ্বৃত্ত বোর্ড ইতিমধ্যে গুদামে রাখা হয়েছে',
    surplusStoreFail: 'গুদামে রাখা ব্যর্থ, বোর্ড আয়তক্ষেত্রাকার বা L-আকৃতির কিনা পরীক্ষা করুন!',
    plankConfilictErr: 'এখানে পয়েন্ট স্থাপন সমর্থিত নয়, অন্য বোর্ডের সাথে সংঘাত হবে',
    surplusErrTip: 'এখানে পয়েন্ট স্থাপন সমর্থিত নয়, একটি ভুল উদ্বৃত্ত তৈরি হবে',
    changeArrageSuccess: 'লেআউট পরিকল্পনা সফলভাবে পরিবর্তিত হয়েছে',
    trialProduction: {
      trialProductionSample: 'পরীক্ষামূলক উৎপাদন নমুনা ক্যাবিনেট',
      trialProduced: 'আমি পরীক্ষামূলক উৎপাদন করেছি',
      trialWarning: '{fontStyleStart}যদি{fontStyleEnd} আপনি নমুনা ক্যাবিনেটের উৎপাদন যাচাইকরণ না করার কারণে নিজের, অন্যদের এবং ক্লাউড টাইপসেটিং সফটওয়্যারের জন্য যেকোনো ক্ষতি ও প্রতিকূল পরিণতি ঘটে, তার সমস্ত দায়ভার আপনাকে ব্যক্তিগতভাবে বহন করতে হবে।',
      trialSlotTip: 'পরীক্ষামূলক উৎপাদনে সামনে ও পিছনের গর্ত-স্লটের আকার, গভীরতা, অবস্থান সঠিক কিনা যাচাই করুন',
      trialSlotTip1: 'ক্যাবিনেট মিরর ইমেজ এড়িয়ে চলুন',
      trialSlotTip2: 'সমস্যা',
      pleaseUploadTrial: 'একত্রিত নমুনা ক্যাবিনেটের ছবি আপলোড করুন',
      uploadTrial: 'নমুনা ক্যাবিনেট আপলোড করুন'
      },
    awaitPlankStore: {
      store: 'বোর্ড লেআউটের অপেক্ষায় গুদাম',
      notTip: 'গুদামে রাখা হয়নি বলে আর প্রম্পট করবে না',
      justLookCurrent: 'শুধুমাত্র বর্তমান অর্ডারের ছোট বোর্ড দেখুন',
      notInPushStorage: 'গুদামে রাখা হয়নি',
      beInStorage: 'গুদামে রাখা হয়েছে',
      searchPlaceholder: 'অর্ডার লিখে লেআউট অপেক্ষায় লাইব্রেরির ছোট বোর্ড অনুসন্ধান করুন',
      plankUploading: 'বোর্ড সংরক্ষণ হচ্ছে',
      oneClickStorage: 'এক ক্লিকে অপেক্ষামাণ লেআউট লাইব্রেরিতে সংরক্ষণ করুন',
      notUsePlank: 'ব্যবহারযোগ্য কোনো ছোট বোর্ড নেই',
      notPlank: 'কোনো বোর্ড অস্থায়ীভাবে সংরক্ষিত নেই',
      dragPlankInHere: 'বোর্ড এখানে টেনে এনে অস্থায়ীভাবে সংরক্ষণ করুন',
      surplusCannotBeStorage: 'উদ্বৃত্ত উপকরণ গুদামে রাখা যাবে না',
      plankHasBeenDeduction: 'ছোট বোর্ড হ্রাস করা হয়েছে বা মূল ডেটা নেই, গুদামে রাখা যাবে না',
      plankLoadErr: 'বোর্ড তথ্য লোড ব্যর্থ হয়েছে',
      taskTitle: 'লেআউট অপেক্ষায় লাইব্রেরির বোর্ড আপলোড করুন',
      dataGenErr: 'ডেটা তৈরির ত্রুটি',
      pushSuccess: 'গুদামে রাখা সফল হয়েছে',
      pushErr: 'অজানা ত্রুটি ঘটেছে, গুদামে রাখা ব্যর্থ',
      awaitBoxExistPlank: 'লেআউট অপেক্ষামাণ লাইব্রেরিতে গুদামে না রাখা ছোট বোর্ড আছে, গুদামে রাখার পরে অপারেশন করার পরামর্শ দেওয়া হচ্ছে',
      mergeFrameDoorWholeTip: 'এই প্যার্ট একটি সংযুক্ত ফ্রেম ডোর সম্পূর্ণ উপাদান, এবং সংরক্ষণ করার পরে, সিস্টেমটি স্বয়ংক্রিয়ভাবে এটিকে একটি একক ব্লকে বিভাজন করবে এবং ম্যানেজ করবে',
      checkPlankStatus: 'বোর্ডের অবস্থা যাচাই করা হচ্ছে...'
      },
    batchSetCut: 'ব্যাচে ছুরি পয়েন্ট সেট করুন',
    applyTo: 'প্রযোজ্য:',
    ncDownloadLifeText: {
      checkData: 'ডেটা পরীক্ষা করা হচ্ছে',
      checkDone: 'ডেটা পরীক্ষা সম্পন্ন',
      checkDataText: 'ডেটা সনাক্তকরণ',
      loadSetting: 'সেটিংস লোড হচ্ছে',
      settingLoadDone: 'সেটিংস লোড সম্পন্ন',
      loadSettingText: 'সেটিংস লোড',
      downloadNc: 'NC ডাউনলোড হচ্ছে',
      ncDownloadDone: 'NC ডাউনলোড সম্পন্ন',
      downloadText: 'NC ডাউনলোড',
      loadPreferenceSetting: 'পছন্দের সেটিংস লোড হচ্ছে',
      PreferenceSettingLoadDone: 'পছন্দের সেটিংস লোড সম্পন্ন',
      loadPreferenceText: 'পছন্দ লোড করুন',
      dealTemp: 'টেমপ্লেট প্রক্রিয়া হচ্ছে',
      TempDealDone: 'টেমপ্লেট প্রক্রিয়া সম্পন্ন',
      dealTempText: 'টেমপ্লেট প্রক্রিয়া',
      beBeingGenTagFile: '{fileType} ফাইল তৈরি হচ্ছে',
      genTagFileDone: '{fileType} ফাইল তৈরি সম্পন্ন',
      genTagFileText: '{fileType} ফাইল তৈরি করুন',
      zip: 'স্থানীয় সংকুচিত ফাইল তৈরি হচ্ছে',
      zipDone: 'স্থানীয় সংকুচিত ফাইল তৈরি সম্পন্ন',
      genZipText: 'সংকুচিত ফাইল তৈরি করুন',
      fileTypeText: 'ছবি'
      },
    surplusCommonTemp: 'উদ্বৃত্ত উপকরণের সাধারণ টেমপ্লেট',
    plankErrTip: 'বর্তমান উপকরণ পরিকল্পনায় ছোট বোর্ড আছে কিন্তু লেআউটের জন্য বড় বোর্ড নেই!',
    brandPlankErrTip: 'বর্তমান উপকরণ পরিকল্পনায় এমন ব্র্যান্ড অংশ আছে যার জন্য কোনো উপলব্ধ ব্র্যান্ড বোর্ড নেই!',
    overSizeTip: 'বড় বোর্ডের পরিমাণ অপর্যাপ্ত বা অতিরিক্ত আকার',
    uselessPart: 'বর্তমান বড় বোর্ডে ব্যবহারযোগ্য কোনো ছোট বোর্ড নেই, অনুগ্রহ করে পুনরায় লেআউট করুন',
    splitArranged: 'ছোট বোর্ডের পরিমাণ অনেক বেশি, পুনরায় লেআউট করুন বা ব্যাচে লেআউট করার পরামর্শ দেওয়া হচ্ছে',
    arrangedErrTip: 'লেআউট ব্যর্থ, বড় বোর্ডের অপর্যাপ্ততা বা ছোট বোর্ডের অতিরিক্ত আকার পাওয়া গেছে',
    knivesModalTitle: 'গর্ত/স্লটে টুল খুঁজে পাওয়া যাচ্ছে না',
    cannotDownloadByKnivesErr: 'NC ডাউনলোড করা যাচ্ছে না, সিস্টেম নিচের গর্ত/স্লটে টুল খুঁজে পাচ্ছে না',
    viewPart: 'সমস্যার বোর্ড দেখুন',
    deductionModalTitle: 'কর্তনের বস্তু নির্বাচন করুন',
    bujianDeduction: 'পরিপূরক ছোট বোর্ড কর্তন করুন',
    paibanDeduction: 'অস্থায়ী স্টোরেজ এলাকার ছোট বোর্ড কর্তন করুন',
    surplusDeduction: 'উদ্বৃত্ত উপকরণের বড় বোর্ড কর্তন করুন',
    unlockPaiban: 'লেআউটে অংশগ্রহণকারী উদ্বৃত্তের লক খুলুন',
    maintain: 'লেআউটে অংশগ্রহণকারী উদ্বৃত্তের লক বজায় রাখুন',
    lockModalText: 'ব্যবহৃত উদ্বৃত্ত বড় বোর্ড অন্য অর্ডার দখল করেছে, পুনরায় লেআউট করবেন?',
    lockNewSModalText: 'বর্তমান উদ্বৃত্ত বড় বোর্ড অন্য অর্ডার দখল করেছে, NC ডাউনলোড চালিয়ে যাবেন?',
    rePaibanWarn: 'উদ্বৃত্ত বড় বোর্ড অন্য অর্ডার দখল করেছে, বড় বোর্ড অপর্যাপ্ত, উপকরণ তালিকায় পুনরায় লেআউট করুন',
    sawRePaiban: 'মনোযোগ: করাত দিয়ে কাটা ব্যবহার করা হচ্ছে, অনিয়মিত বোর্ড লেআউট যোগ করা হয়েছে, NC ফাইল আউটপুট করতে পুনরায় লেআউট প্রয়োজন',
    togglePlankTip: 'বোর্ডে বিশেষ স্লটিং প্রক্রিয়া আছে, সামনে ও পিছনে বদলানো সমর্থিত নয়!',
    stepCuttingMsg: 'স্তরযুক্ত কাটার গভীরতা বোর্ডের পুরুত্বের চেয়ে কম হতে হবে',
    stepCuttingMsg2: 'স্তরযুক্ত কাটার গভীরতায় শুধুমাত্র 0-এর চেয়ে বড় সংখ্যা লেখা যাবে',
    flipPlankTip: 'গর্ত-স্লট বিভাজন কাটার মেশিনে এককলেখ বোর্ড প্রক্রিয়া চালু করা হয়েছে, উল্টানো অপারেশন অনুমোদিত নয়!',
    genNoCutTagNotSupportExportPic: 'নো-কাট ট্যাগ তৈরি চালু আছে, ছবি রপ্তানি সমর্থিত নয়',
    allSmallPlanksAreNoCutNotInLayout: 'সব ছোট বোর্ড নো-কাট বোর্ড, লেআউটে অংশগ্রহণ করে না',
    canStillExportHoleSlotOrPrintTag: 'আপনি এখনও গর্ত ও স্লট প্রক্রিয়াকরণ ফাইল রপ্তানি করতে বা ট্যাগ মুদ্রণ করতে পারবেন',
    desMaterialNoCutNotSupportSwitchLine: 'বর্তমান উৎপাদন লাইনে নির্দিষ্ট ছোট বোর্ড উপকরণ নো-কাট সক্ষম করা হয়েছে, সরাসরি লাইন পরিবর্তন সমর্থিত নয়',
    desMaterialNoCutSettingChanged: 'নির্দিষ্ট ছোট বোর্ড উপকরণ নো-কাট সেটিং পরিবর্তিত হয়েছে, উৎপাদন নির্ভুলতা নিশ্চিত করতে পুনরায় লেআউট করুন',
    continueDownload: 'ডাউনলোড চালিয়ে যান',
    desMaterialNoCutErrorTip: 'নির্দিষ্ট নো-কাট বোর্ডে খোদাই মেশিনে বরাদ্দ গর্ত/স্লট আছে, এবার ডাউনলোডে সব ৫/৬-পার্শ্বিক ড্রিলিংয়ে বরাদ্দ করা হচ্ছে, ফাইল ডাউনলোড চালিয়ে যাবেন?',
    clearReuseRelation: 'পুনরায় ব্যবহারের সম্পর্ক মুছতে ক্লিক করুন',
    layoutReuseTip: 'বড় বোর্ডের লেআউট দ্রুত অনুলিপি করুন, বোর্ড পরিবর্তন হলে পুনরায় ব্যবহারের সম্পর্ক স্বয়ংক্রিয়ভাবে মুছে যাবে',
    hasBeenReused: 'ইতিমধ্যে পুনরায় ব্যবহৃত',
    layoutReuse: 'লেআউট পুনরায় ব্যবহার',
    specialProcessNotSupported: 'বোর্ডে বিশেষ প্রক্রিয়া আছে, এই অপারেশন সমর্থিত নয়',
    conflictNotSupported: 'বোর্ডে দ্বন্দ্ব আছে, এই অপারেশন সমর্থিত নয়',
    noAvailablePlankForReuse: 'পুনরায় ব্যবহারের জন্য কোনো উপলব্ধ বোর্ড নেই',
    noMatchingPlankFound: 'মিলে যাওয়া বোর্ড পাওয়া যায়নি',
    reuseBoard: '{number} নং বোর্ড পুনরায় ব্যবহার',
    influenceTip: {
      title: 'অপ্টিমাইজেশন হারকে প্রভাবিত করে এমন বৈশিষ্ট্য',
      empty: 'নেই',
      groupParams: 'বিন্যাস প্যারামিটার',
      surplusNoRoll: 'অবশিষ্ট উপাদান উল্টানো হয় না',
      surplusCustomTrim: 'পৃথক ট্রিম মান',
      otherPlateCustomTrim: 'বিশেষ বোর্ডের পৃথক ট্রিম মান',
      knifeDiameter: 'কেসার ব্যাস',
      surplusNoFlip: 'অবশিষ্ট উপাদান উল্টানো হয় না',
      surplusNotLayout: 'অবশিষ্ট বোর্ড নির্দিষ্ট বোর্ড বিন্যাস করা হয় না',
      plankEdgeOff: 'ট্রিম',
      surplusCustomTrim2: 'অবশিষ্ট কাস্টম ট্রিম',
      other: 'অন্যান্য বৈশিষ্ট্য যা প্রভাবিত হতে পারে',
      enabled: 'সক্রিয় করা হয়েছে',
      plankThicknessStacking: 'প্লেটের পুরুত্ব স্ট্যাকিং',
      edgePreMilling: 'প্লেটের পুরুত্ব স্ট্যাকিং',
      multiMaterialCuttingBlade: 'প্লেটের পুরুত্ব স্ট্যাকিং',
      sawSpecialShapePart: 'করাত কাটা ও খোদাই মেশিনের জন্য বিশেষ আকৃতির খাঁজযুক্ত বোর্ড',
      longPlankCutting: 'দীর্ঘ প্লেটের দ্বিতীয় প্রক্রিয়া'
      }
    },
  paibanImg: {
    title: 'লেআউট ডায়াগ্রাম ব্যবস্থাপনা',
    exportCustomPaibanImg: 'কাস্টম লেআউট ডায়াগ্রাম রপ্তানি করুন',
    customPaibanImg: 'কাস্টম লেআউট ডায়াগ্রাম',
    isCustomName: 'কাস্টম লেআউট ডায়াগ্রাম নাম',
    template: 'লেআউট টেমপ্লেট',
    addTem: 'টেমপ্লেট যোগ করুন',
    canvasIndexSearch: 'বড় বোর্ড সিরিয়াল নম্বর অনুসন্ধান',
    symbol: 'লেআউট ডায়াগ্রাম আইকন',
    frontSlot: 'সামনের স্লট',
    backSlot: 'পিছনের স্লট',
    frontHole: 'সামনের গর্ত',
    backHole: 'পিছনের গর্ত',
    printNum: 'একটি কাগজ মুদ্রণে সর্বোচ্চ প্রদর্শন',
    printUnit: 'একটি লেআউট ডায়াগ্রাম',
    edit: 'লেআউট টেমপ্লেট সম্পাদনা',
    temName: 'টেমপ্লেটের নাম',
    rotate: 'লেআউট ডায়াগ্রাম ঘূর্ণন',
    showOverflow: 'টেক্সট বোর্ড থেকে উপচে পড়লে পরিচয় লাইন ছোট বোর্ডের ডেটা দেখায়',
    showHoleSlot: 'গর্ত স্লটের তথ্য দেখান',
    bigPartCss: 'বড় বোর্ড লেআউট ডায়াগ্রামের স্টাইল সামঞ্জস্য',
    partCss: 'ছোট বোর্ড লেআউট ডায়াগ্রামের স্টাইল সামঞ্জস্য',
    addTemTip: 'সর্বোচ্চ ১০টি লেআউট টেমপ্লেট যোগ করা যাবে!',
    exportTip: 'রপ্তানির জন্য কমপক্ষে একটি লেআউট টেমপ্লেট নির্বাচন করুন!',
    editSaveTip: 'সব আবশ্যক ক্ষেত্র পূরণ করার পরে সংরক্ষণ করুন!',
    exportDXF: 'DXF রপ্তানি করুন',
    exportDxfGeneral: '2D সাধারণ DXF',
    exportDxf3d: '3D বিশেষ DXF',
    exportDxfGeneralTip: 'হাতে প্রক্রিয়াকরণ, নকশা দেখে কাটা বা লেআউটের ফলাফল পরীক্ষা করার জন্য উপযুক্ত',
    exportDxf3dTip: 'উৎপাদনের জন্য তৃতীয় পক্ষের সিস্টেমে আমদানি করার উপযোগী; Huiya লেজার কাটিং ইন্টিগ্রেটেড মেশিন সমর্থিত'
    },
  historyPage: {
    matchErrBySpecialTip1: 'নিচের বিশেষ বড় বোর্ডগুলো আর মিলকারী আইটেম খুঁজে পাচ্ছে না, লেআউট পেজে পুনরায় লেআউটে সমস্যা হবে',
    specialPlankInfoErrTip2: 'বিশেষ বোর্ডের তথ্য পাওয়ায় ত্রুটি, লেআউট পেজের পুনরায় লেআউট ফিচারকে প্রভাবিত করবে',
    download: 'স্থানীয়ভাবে ডাউনলোড করুন',
    allType: 'সব সংরক্ষণ করুন',
    handleSave: 'ম্যানুয়াল সেভ',
    specialPlank: 'বিশেষ',
    surplusPlank: 'অতিরিক্ত',
    autoSave: 'স্বয়ংক্রিয় সেভ',
    allArrange: 'সব লেআউট',
    searchPlaceholder: 'অর্ডারের নাম / লেআউট ব্যাচ / অর্ডার নম্বর অনুসন্ধান করুন',
    saveHistoryName: 'সংরক্ষিত ইতিহাসের নাম',
    trailProduction: {
      title: 'পরীক্ষামূলক উৎপাদন নমুনা ক্যাবিনেট',
      lastTime: 'সর্বশেষ পরীক্ষামূলক উৎপাদনের তারিখ',
      recordList: 'পরীক্ষামূলক উৎপাদন রেকর্ড',
      start: 'পরীক্ষামূলক উৎপাদন শুরু করুন',
      date: 'সময়',
      outputFrom: 'আউটপুট অবস্থান',
      empty: 'কোনো ডেটা নেই',
      record: 'আপলোড করা পরীক্ষামূলক নমুনা ক্যাবিনেটের ছবি রেকর্ড',
      tip1: 'নোট: বর্তমান পরীক্ষামূলক উৎপাদন অর্ডার ডিফল্ট উৎপাদন ডেটা ব্যবহার করছে',
      tip2: 'নোট: বর্তমান পরীক্ষামূলক উৎপাদন অর্ডার সর্বশেষ প্রক্রিয়া সেটিং ব্যবহার করছে না, পরীক্ষামূলক রুমে গিয়ে পুনরায় সংরক্ষণ করুন!',
      download: 'প্রক্রিয়াকরণ ফাইল ডাউনলোড করুন'
      },
    deleteTip: 'নিম্নলিখিত ইতিহাস রেকর্ড মুছে ফেলতে নিশ্চিত করবেন?',
    startDate: 'শুরুর তারিখ',
    endDate: 'শেষ তারিখ',
    lastWeek: 'গত এক সপ্তাহ',
    lastMonth: 'গত এক মাস',
    lastSeason: 'গত তিন মাস',
    toArrangePage: 'লেআউট পেজে যাওয়া হচ্ছে',
    notArrangedTip: 'এই রেকর্ড এখনো লেআউট করা হয়নি, প্রথমে উপকরণ তালিকায় যান!',
    toMaterialPage: 'উপকরণ তালিকা পেজে যাওয়া হচ্ছে',
    lessSelectTip: 'এই অপারেশন করার আগে কমপক্ষে একটি রেকর্ড নির্বাচন করুন',
    downloadNc: 'প্রক্রিয়াকরণ ফাইল ডাউনলোড করুন'
    },
  workShopPage: {
    warningTip: 'এই ফিচার সীমিত সময়ের ট্রায়াল, আপনার অর্ডার উৎপাদন যুক্তিসঙ্গতভাবে সাজান!',
    fileManager: 'উৎপাদন ফাইল ব্যবস্থাপনা',
    selected: 'নির্বাচিত',
    suplement: 'পরিপূরক',
    size: 'আকার',
    saveToStore: 'পরিপূরক গুদামে যোগ করুন',
    enterArrange: 'লেআউটে প্রবেশ হচ্ছে...',
    deleteTip: 'ডেটা মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    arrangeTip: 'পরিপূরক ডেটা বিশ্লেষণ করা হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    store: 'পরিপূরক গুদাম',
    downloadFile: 'উৎপাদন ফাইল ডাউনলোড করুন',
    notBujianFile: 'পরিপূরক ফাইল পাওয়া যায়নি',
    productLineDelete: 'এই উৎপাদন লাইন মুছে ফেলা হয়েছে, NC ফাইল ডাউনলোড করা যাবে না!'
    },
  basePlankManager: {
    saveTip: 'নোট: সংরক্ষণ করতে Enter চাপুন',
    offsetSize: 'ট্রিমিং সাইজ',
    overSizeTip: 'আকার অনেক বড় হলে, স্বয়ংক্রিয়ভাবে বড় আকারের বড় বোর্ড নির্বাচন করে লেআউট করুন',
    addTip: 'লেআউটে বোর্ড বেশি বড় হলে, বিশেষ বড় বোর্ড স্বয়ংক্রিয়ভাবে যোগ করার পপআপ আসবে',
    defaultOversizePlankValue: 'অতিরিক্ত আকারের বড় বোর্ড শুধুমাত্র অতিরিক্ত আকারের ছোট বোর্ড সাজায়',
    onlyLayoutTooBig: 'অতিরিক্ত আকারের বড় বোর্ড শুধুমাত্র অতিরিক্ত আকারের ছোট বোর্ড সাজায়',
    settingRemark: 'নোট: মূল এখানকার ফিচার ডানদিকের সেটিংসে সামঞ্জস্য করা হয়েছে',
    searchPlaceholder: 'বোর্ডের উপকরণ/রঙ অনুসন্ধান করুন',
    syncData: 'ক্যাবিনেট ডেটা সিঙ্ক্রোনাইজ করুন',
    syncDataM: 'ক্যাবিনেট দরজার ডেটা সিঙ্ক্রোনাইজ করুন',
    deletePlank: 'বিশেষ বড় বোর্ড মুছুন',
    addPlank: 'নতুন বিশেষ বোর্ড তৈরি করুন',
    matCodePlaceholder: 'বোর্ডের উপকরণ নির্বাচন করুন',
    thickPlaceHolder: 'পুরুত্ব নির্বাচন করুন',
    widthErr: 'বোর্ডের প্রস্থ খালি রাখা যাবে না',
    heightErr: 'বোর্ডের দৈর্ঘ্য খালি রাখা যাবে না',
    matCodeErr: 'বোর্ডের উপকরণ খালি রাখা যাবে না',
    colorErr: 'বোর্ডের রং খালি রাখা যাবে না',
    editPlank: 'বোর্ড সম্পাদনা করুন',
    deleteTip: 'ডেটা মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    plankKnifeSelect: 'মূল তক্তার কাটার ছুরি নির্বাচন',
    plankKnifeSelectTip: 'বোর্ডের অংশ একাধিক নিয়মের সাথে মিললে, বোর্ডের পুরুত্বের অগ্রাধিকার উপকরণের চেয়ে বেশি',
    knifeSelectTip: 'নোট: এমবেডেড লেআউট এই ফিচার সমর্থন করে না',
    knife: 'কাটার ছুরি',
    matcodeInput: 'বোর্ডের উপকরণ লিখুন',
    thickInput: 'বোর্ডের পুরুত্ব লিখুন',
    default: 'সিস্টেম ডিফল্ট',
    unessential: 'এই কলামটি ঐচ্ছিক',
    emptyTip: 'নোট: এই আইটেম পূরণ না করলে মূল শীট মিলের সময় এই ডেটা আলাদা করা হবে না!',
    defaultUse: 'ডিফল্ট নির্বাচন',
    editMatcode: 'উপকরণ সম্পাদনা করুন',
    syncTip: '{fromMc} থেকে ডেটা নিয়ে বিদ্যমান ক্লাউড লেআউটের মূল শীট ম্যানেজমেন্ট ডেটা ওভাররাইট করবে, সিঙ্ক্রোনাইজ করবেন?',
    sameErr: 'একই ডেটা ইতিমধ্যে বিদ্যমান',
    cancelDelete: 'মুছে ফেলা বাতিল করা হয়েছে',
    syncErr: 'সিঙ্ক্রোনাইজেশন ব্যর্থ হয়েছে',
    syncSuccess: 'সিঙ্ক্রোনাইজেশন সফল হয়েছে',
    syncDataTip: '{fromMc} ডেটা সিঙ্ক্রোনাইজ করুন',
    editErrTip: 'পূরণ না করা তথ্য আছে, পরীক্ষা করুন!',
    numberCheck: '{type} শুধুমাত্র সংখ্যা লেখা যাবে!',
    deleteStandardPlate: 'মানক বোর্ড মুছুন',
    createStandardPlate: 'নতুন মানক বোর্ড',
    editStandardPlate: 'মানক বোর্ড সম্পাদনা করুন',
    trimmingDimension: 'ট্রিমিং আকার',
    front: 'উপরে',
    back: 'নিচে',
    left: 'বাম',
    right: 'ডান',
    frontTrim: 'উপরের ট্রিমিং',
    backTrim: 'নিচের ট্রিমিং',
    leftTrim: 'বাম ট্রিমিং',
    rightTrim: 'ডান ট্রিমিং',
    customTrim: 'কাস্টম ট্রিমিং মান',
    trimValue: 'ট্রিমিং মান',
    notEmpty: '{type} খালি রাখা যাবে না!',
    edgeDir: 'ট্রিমিং ({type})',
    brandPlank: 'ব্র্যান্ড বোর্ড',
    brandPlankTip: 'নোট: ব্র্যান্ড বোর্ডের মুছে ফেলা ও পরিবর্তন Cabinet ক্লায়েন্ট বোর্ড রিসোর্স লাইব্রেরিতে সম্পন্ন হয়',
    brand: 'ব্র্যান্ড',
    supplier: 'সরবরাহকারী',
    brandPlaceholder: 'ব্র্যান্ড নির্বাচন করুন',
    supplierPlaceholder: 'সরবরাহকারী নির্বাচন করুন',
    brandInput: 'ব্র্যান্ড লিখুন',
    supplierInput: 'সরবরাহকারী লিখুন',
    addBrandPlank: 'ব্র্যান্ড বোর্ড যোগ করুন',
    deleteBrandPlank: 'ব্র্যান্ড বোর্ড মুছুন',
    editBrandPlank: 'ব্র্যান্ড বোর্ড সম্পাদনা করুন',
    searchBrandPlaceholder: 'ব্র্যান্ড/সরবরাহকারী/উপাদান/রঙ খুঁজুন'
    },
  bujianAndStore: {
    bujianStore: 'পরিপূরক গুদাম',
    awaitStore: 'বোর্ড লেআউট অপেক্ষার গুদাম',
    depositAwaitStore: 'লেআউট অপেক্ষার গুদামে জমা দিন',
    pushToAwaitStore: 'লেআউট অপেক্ষার গুদামে রাখুন',
    useTwoTableArrange: 'দুটি ফর্ম দিয়ে লেআউট করুন',
    confirmUseTwoTableTip: 'বর্তমানে নির্বাচিত ছোট বোর্ডে পরিপূরক গুদাম এবং অপেক্ষার গুদামের বোর্ড অন্তর্ভুক্ত, লেআউট চালিয়ে যাবেন?',
    confirmAddPlankToAwaitStore: 'নির্বাচিত বোর্ডগুলো লেআউট অপেক্ষার গুদামে যোগ করতে নিশ্চিত করবেন?',
    pushStoreSuccess: 'গুদামে সফলভাবে যোগ করা হয়েছে',
    dataGenErr: 'ডেটা তৈরিতে ত্রুটি',
    unknownErr: 'অজানা ত্রুটি ঘটেছে, গুদামে যোগ করা ব্যর্থ হয়েছে'
    },
  surplusPage: {
    surplusMaterial: 'উদ্বৃত্ত উপকরণ তালিকা',
    surplusStore: 'উদ্বৃত্ত উপকরণ গুদাম',
    recycleBin: 'উদ্বৃত্ত উপকরণ গুদাম',
    recycleBinTip: 'অতিরিক্ত উপকরণের ডেটা ৯০ দিন ধরে রিসাইকেল বিনে থাকলে স্বয়ংক্রিয়ভাবে মুছে ফেলা হবে',
    "deleteReason-0": 'ম্যানুয়ালি মুছে ফেলা',
    "deleteReason-1": 'টাইপসেটিং কাটছাঁট',
    "deleteReason-2": 'Guigui মোবাইল অপারেশনের মাধ্যমে আউটবাউন্ড',
    surplusShape: 'উদ্বৃত্তের আকৃতি',
    batchTransfer: 'ব্যাচ ট্রান্সফার',
    createNewSurplusStore: 'নতুন উদ্বৃত্ত গুদাম তৈরি করুন',
    pushStoreSetting: 'উদ্বৃত্ত স্টোরেজ সেটিংস',
    surplusStoreName: 'উদ্বৃত্ত গুদামের নাম',
    surplusStoreName2: 'উদ্বৃত্ত গুদামের নাম',
    addSurplusStore: 'উদ্বৃত্ত গুদাম যোগ করুন',
    inventoryCeiling: 'স্টক সর্বোচ্চ সীমা',
    autoTransferTip: 'মুছার পরে, গুদামের উদ্বৃত্ত স্বয়ংক্রিয়ভাবে উদ্বৃত্ত উপকরণ তালিকায় স্থানান্তরিত হবে',
    asIndexPushStore: 'গুদামে সংরক্ষণের ক্রম অনুযায়ী সংরক্ষণ করুন',
    pushToSurplusMaterial: 'উদ্বৃত্ত উপকরণ তালিকায় সংরক্ষণ করুন',
    surplusStoreTable: {
      number: 'নম্বর',
      name: 'উদ্বৃত্ত গুদামের নাম',
      quantity: 'সংরক্ষিত উদ্বৃত্তের পরিমাণ (পিস)',
      capacity: 'উদ্বৃত্ত গুদামের স্টক সর্বোচ্চ সীমা (পিস)',
      rules: 'উদ্বৃত্ত স্টোরেজের নিয়মাবলী',
      remark: 'মন্তব্য',
      operation: 'অপারেশন'
      },
    editSurplusStore: 'উদ্বৃত্ত গুদাম সম্পাদনা করুন',
    addSurplus: 'উদ্বৃত্ত যোগ করুন',
    importSurplus: 'উদ্বৃত্ত আমদানি করুন',
    downloadSurplusTemplate: 'উদ্বৃত্ত আমদানি টেমপ্লেট ডাউনলোড করুন',
    batchExportSurplus: 'বর্তমান উদ্বৃত্ত তালিকা রপ্তানি করুন',
    surplusBatchImportExport: 'উদ্বৃত্ত ব্যাচ আমদানি রপ্তানি',
    surplusMaterialStorageCode: 'উদ্বৃত্ত উপকরণ স্টোরেজ কোড',
    generateQRCodeSuccess: 'QR কোড সফলভাবে তৈরি হয়েছে',
    generateQRCodeFailed: 'QR কোড তৈরি করতে ব্যর্থ হয়েছে',
    refreshQRCode: 'QR কোড রিফ্রেশ করুন',
    refreshQRCodeFailed: 'QR কোড রিফ্রেশ করতে ব্যর্থ হয়েছে',
    cancelRefresh: 'রিফ্রেশ বাতিল করা হয়েছে',
    refreshQRCodeTip: 'QR কোড রিফ্রেশ করবেন? রিফ্রেশের পরে বর্তমান QR কোড অকার্যকর হয়ে যাবে।',
    refreshQRCodeConfirm: 'নিশ্চিত করুন',
    refreshQRCodeCancel: 'বাতিল করুন',
    wechatScanTip: 'WeChat খুলে QR কোড স্ক্যান করে ম্যানুয়ালি উদ্বৃত্ত উপকরণ গুদামে যোগ করতে পারবেন',
    deletSurplus: 'উদ্বৃত্ত মুছুন',
    editSurplus: 'উদ্বৃত্ত সম্পাদনা করুন',
    surplusNoRoll: 'উদ্বৃত্ত পুনর্মুদ্রণ ছাড়া প্রক্রিয়াকরণ সক্ষম করুন',
    type: {
      all: 'সব আকৃতি'
      },
    allMatcode: 'সব উপকরণ',
    allThick: 'সব পুরুত্ব',
    surplusName: 'উদ্বৃত্তের নাম',
    rectSurplus: 'আয়তাকার উদ্বৃত্ত',
    LTypeSurplus: 'L আকৃতির উদ্বৃত্ত',
    noMatchSup: 'সংশ্লিষ্ট ডেটা পাওয়া যায়নি',
    jumpTo: 'যান',
    page: 'পৃষ্ঠা',
    newMatcode: 'নতুন উপকরণ তৈরি করুন',
    newColor: 'নতুন রঙ তৈরি করুন',
    autoCreateColor: 'Enter চাপলে স্বয়ংক্রিয়ভাবে রঙ কার্ড তৈরি হবে',
    nameLimit: 'উদ্বৃত্তের নামে সর্বোচ্চ ১০ অক্ষর লেখা যাবে',
    nameLimitNameErr: 'উদ্বৃত্তের নাম খালি রাখা যাবে না',
    tempLongTip: 'বোর্ডের দৈর্ঘ্যে শুধুমাত্র সংখ্যা লেখা যাবে',
    minLongLimit: 'ছোট বাহুর দৈর্ঘ্যে শুধুমাত্র সংখ্যা লেখা যাবে',
    minLongEmptyTip: 'ছোট বাহুর দৈর্ঘ্য খালি রাখা যাবে না',
    minLongLimitMax: 'ছোট বাহুর দৈর্ঘ্য বোর্ডের দৈর্ঘ্য অতিক্রম করতে পারবে না',
    widthLimit: 'বোর্ডের প্রস্থে শুধুমাত্র সংখ্যা লেখা যাবে',
    minWidthLimit: 'ছোট বাহুর প্রস্থে শুধুমাত্র সংখ্যা লেখা যাবে',
    minWidthEmptyLimit: 'ছোট বাহুর প্রস্থ খালি রাখা যাবে না',
    minWidthLimitMax: 'ছোট বাহুর প্রস্থ বোর্ডের প্রস্থ অতিক্রম করতে পারবে না',
    thickLimit: 'বোর্ডের পুরুত্বে শুধুমাত্র সংখ্যা লেখা যাবে',
    thickEmptyLimit: 'বোর্ডের পুরুত্ব খালি রাখা যাবে না',
    countInputLimit: 'পরিমাণ অবশ্যই ধনাত্মক পূর্ণসংখ্যা হতে হবে',
    countEmptyLimit: 'পরিমাণ খালি রাখা যাবে না',
    remarkMaxlimit: 'মন্তব্যে সর্বোচ্চ ৫০ অক্ষর লেখা যাবে',
    orderAddressMaxlimit: 'উৎস অর্ডারের ঠিকানায় সর্বোচ্চ ১০০ অক্ষর লেখা যাবে',
    orderIdMaxlimit: 'উৎস অর্ডার নম্বরে সর্বোচ্চ ১০০ অক্ষর লেখা যাবে',
    createTime: 'যোগ করার সময়',
    deleteTime: 'মুছে ফেলার সময়',
    deleteReason: 'মুছে ফেলার কারণ',
    branchName: 'যে উদ্বৃত্ত গুদামে আছে',
    orderAddress: 'উৎস অর্ডারের ঠিকানা',
    orderId: 'উৎস অর্ডার নম্বর',
    lockStatus: 'লক অবস্থা',
    lockOrder: 'লক করা অর্ডার',
    enableSurplusLock: 'উদ্বৃত্ত উপকরণ লকিং ফিচার সক্ষম করুন',
    isCloseSurplusLock: 'ফিচার বন্ধ করলে সব উদ্বৃত্ত আনলক হবে, চালিয়ে যাবেন?',
    confirm: 'বন্ধ করতে নিশ্চিত করুন',
    surplusTransfer: 'উদ্বৃত্ত স্থানান্তর',
    targetSurplusStore: 'লক্ষ্য উদ্বৃত্ত গুদাম',
    enableSurLockTip: 'সক্ষম করলে প্রতিটি লেআউটে ব্যবহৃত উদ্বৃত্ত লক হবে, অন্য অর্ডার ব্যবহার করা থেকে বিরত রাখবে',
    addMainRule: 'প্রধান নিয়ম যোগ করুন',
    surplusRules: 'উদ্বৃত্ত স্টোরেজ নিয়মাবলী',
    mainRulesTip: 'প্রধান নিয়মগুলির মধ্যে অথবা সম্পর্ক, অর্থাৎ যেকোনো একটি প্রধান নিয়ম পূরণ হলেই উদ্বৃত্ত গুদামে যাবে',
    mainRulesTip1: 'নিয়ম যোগের পরে, নিয়ম মেনে চলা উদ্বৃত্ত প্রথমে সেই গুদামে সংরক্ষিত হবে',
    rule: 'নিয়ম',
    addSubRule: 'উপ-নিয়ম যোগ করুন',
    subRuleTip: 'উপ-নিয়মগুলির মধ্যে এবং সম্পর্ক, প্রধান নিয়মের অধীনে সব উপ-নিয়ম একই সাথে পূরণ হলেই গুদামে যাবে',
    bigPlankMatCode: 'বড় বোর্ডের উপকরণ',
    bigPlankThick: 'বড় বোর্ডের পুরুত্ব',
    bigPlankColor: 'বড় বোর্ডের রঙ',
    greaterEqual: 'বড় বা সমান',
    lessEqual: 'ছোট বা সমান',
    capNumberCheck: 'স্টক সর্বোচ্চ সীমায় শুধুমাত্র পূর্ণসংখ্যা লেখা যাবে!',
    capEmptyCheck: 'স্টক সর্বোচ্চ সীমা খালি রাখা যাবে না!',
    surNameEmptyCheck: 'উদ্বৃত্ত গুদামের নাম খালি রাখা যাবে না!',
    mainRuleLimit: 'প্রধান নিয়ম সর্বোচ্চ সীমায় পৌঁছেছে',
    delMainRuleTip: 'এই প্রধান নিয়ম মুছতে চান?',
    matCodeEmptyCheck: 'বড় বোর্ডের উপকরণ খালি রাখা যাবে না!',
    thickEmptyCheck: 'বড় বোর্ডের পুরুত্ব খালি রাখা যাবে না!',
    textureEmptyCheck: 'বড় বোর্ডের রঙ খালি রাখা যাবে না!',
    enableWarehouseSecondCon: 'উদ্বৃত্ত গুদামে সংরক্ষণের দ্বিতীয় নিশ্চিতকরণ সক্ষম করুন',
    surplusWarehouseConfirm: 'উদ্বৃত্ত গুদামে সংরক্ষণ নিশ্চিতকরণ',
    surplusWarehouseConfirm1: 'গুদামে যোগ করার নিশ্চিতকরণ',
    closeSurplusConfirm: 'গুদামে যোগ নিশ্চিতকরণ বন্ধ করুন (উদ্বৃত্ত ব্যবস্থাপনা পেজে পুনরায় চালু করা যাবে)',
    position: 'সংরক্ষণের স্থান',
    nameRepeatTip: 'বর্তমান উদ্বৃত্তের নাম ইতিমধ্যে বিদ্যমান, সংশোধন করে পুনরায় গুদামে যোগ করুন',
    surLimitTip: 'বর্তমান উদ্বৃত্ত গুদাম সর্বোচ্চ সীমায় পৌঁছেছে বা স্টোরেজ নিয়ম পূরণ করে না',
    surFailTip: 'গুদামে যোগ ব্যর্থ, উদ্বৃত্ত নাম ডুপ্লিকেট বা গুদাম সীমায় পৌঁছেছে বা স্টোরেজ নিয়ম পূরণ করে না',
    surplusExistTip: 'কিছু উদ্বৃত্ত ইতিমধ্যে গুদামে আছে, এই অপারেশন ব্যর্থ হয়েছে',
    surplusExistTip2: 'বর্তমান উদ্বৃত্ত ইতিমধ্যে গুদামে আছে, গুদামে যোগ করা যাবে না',
    currentPage: 'বর্তমান পৃষ্ঠা',
    totalPage: 'সব নির্বাচন করুন'
    },
  printPage: {
    goto: 'এখনই যান',
    surplusSizeTittle: 'উদ্বৃত্তের আকার অনেক ছোট সতর্কবার্তা',
    surplusSizeErrTip: 'উদ্বৃত্তের আকার অনেক ছোট, সংশ্লিষ্ট উৎপাদন লাইনে ন্যূনতম আকার সেট করুন!',
    opacityTip: 'EZsort দ্বারা প্রযুক্তিগত সহায়তা প্রদত্ত',
    opacityTip2: 'বর্তমান অ্যাকাউন্ট Smart Color Labels কেনেনি; কিনলে Color Label সফটওয়্যারে ক্যাবিনেট অ্যাকাউন্ট বাঁধুন',
    loadFontTip: 'প্রয়োজনীয় ফন্ট রিসোর্স ফাইল লোড হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন',
    leftAlign: 'বাম সারিবদ্ধ',
    rightAlign: 'ডান সারিবদ্ধ',
    topAlign: 'উপরে সারিবদ্ধ',
    bottomAlign: 'নিচে সারিবদ্ধ',
    horizontalAlign: 'অনুভূমিক কেন্দ্র সারিবদ্ধ',
    verticalAlign: 'উল্লম্ব কেন্দ্র সারিবদ্ধ',
    horizontalSplit: 'অনুভূমিক সমান বিভাজন',
    verticalSplit: 'উল্লম্ব সমান বিভাজন',
    norTag: 'সাধারণ মূল শীট লেবেল',
    surTag: 'উদ্বৃত্ত বড় বোর্ড লেবেল',
    genTag: 'ট্যাগ তৈরি করুন',
    all: 'সব নির্বাচন করুন',
    deleteWarning: 'বিজ্ঞপ্তি',
    print: 'মুদ্রণ করুন',
    defaultTemplate: 'ডিফল্ট টেমপ্লেট（60 x 40）',
    editTemplate: 'টেমপ্লেট সম্পাদনা করুন',
    deleteTip: 'টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tagSetting: 'লেবেল সেটিংস',
    rememberSetting: 'সংশোধনের পরে সেটিং মনে রাখা হবে',
    genCutingTag: 'কাটা বোর্ডের লেবেল তৈরি করুন',
    genSurplusTag: 'উদ্বৃত্ত বোর্ডের লেবেল তৈরি করুন',
    genPlankTag: 'বড় বোর্ডের লেবেল তৈরি করুন',
    genPartTag: 'ছোট বোর্ডের লেবেল তৈরি করুন',
    genNoCutTag: 'নো-কাট বোর্ডের লেবেল তৈরি করুন',
    tagPosition: 'লেবেল অবস্থান',
    tagPositionTip: '(শুধুমাত্র লেবেলিং মেশিনের জন্য নিচের X/Y স্থানাঙ্ক পূরণ করতে হবে)',
    Xposition: 'X স্থানাঙ্ক',
    Yposition: 'Y স্থানাঙ্ক',
    genPlankSuffix: 'বড় বোর্ড লেবেল জেনারেট করার ফাইলের নামের সাফিক্স',
    arrangeMirror: 'লেবেল ইমেজ মিরর',
    drillPlankBase: 'পাঁচ বা ছয় ড্রিল-এন্ড-প্লেস প্লেট বেঞ্চমার্ক',
    drillPlankBaseTip: 'প্ল্যাঙ্ক প্লেসমেন্টের বেস ডেটা পেতে ব্যর্থ, পরে আবার চেষ্টা করুন!',
    suitAuto: 'লেবেল সর্টিং অটো লোড/আনলোডের সাথে মানানসই:',
    colorLabel: 'রঙিন লেবেল তৈরি করুন',
    colorRevert: 'ছোট বোর্ডের জন্য উল্টো রঙের লেবেল তৈরি করুন',
    displayEnAndZh: 'রুম/ক্যাবিনেট/প্যানেল নাম ইংরেজি ও চীনে দেখান',
    displayEnAndZhTip: 'শুধুমাত্র ডিফল্ট রুম/ক্যাবিনেট/প্যানেল নাম সমর্থন, কাস্টম নামে পরিবর্তনের পর এই ফিচার কাজ করবে না',
    up: 'উপরে',
    down: 'নিচে',
    default: 'ডিফল্ট',
    printSetting: 'প্রিন্ট সেটিংস',
    oneToMore: 'এক পৃষ্ঠায় একাধিক পৃষ্ঠা',
    perPage: 'প্রতি',
    coloumn: 'কলাম',
    tagMargin: 'লেবেল ফাঁক',
    coloumnMargin: 'কলামের মধ্যে ফাঁক',
    specialMark: 'বিশেষ চিহ্ন',
    opacity: 'স্বচ্ছতা',
    opacityTip3: 'BMP ফরম্যাট ইমেজে স্বচ্ছতার জন্য ট্রু কালার সিলেক্ট করতে হবে',
    suite: 'অ্যাডাপ্টিভ',
    svgListTip: 'ছোট বোর্ড লেবেল জেনারেশন চালু নেই, বামে চেকবক্সে টিক দিন',
    size: 'আকার',
    lightSide: 'আলোর দিক দেখা',
    locFrontSide: 'ক্যাবিনেটের সামনের দিক',
    openSide: 'দরজা খোলার দিক',
    extraTip: 'প্রথমবার ডাইরেক্ট প্রিন্ট ব্যবহার করলে প্রিন্টার সেটিংসে একই সাইজ ও লম্বা-চওড়া উলটানো কাগজ যোগ করুন, তারপর নতুন কাগজে প্রিন্ট করুন',
    noMore: 'আর নেই',
    prepareData: 'ডেটা প্রস্তুত করা হচ্ছে...',
    genTagFile: 'ট্যাগ জেনারেট হচ্ছে, পেজ সুইচ, ব্রাউজার মিনিমাইজ বা ট্যাগ উপরে-নিচে স্ক্রল করবেন না!',
    waitGen: 'ট্যাগ সম্পূর্ণ লোড হওয়ার পর ডাউনলোড করুন',
    tempLoading: 'ট্যাগ টেমপ্লেট লোড হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন',
    front: 'সামনে',
    open: 'খুলুন',
    toEdit: 'এডিটে যান',
    simplifyOneCodeTip: 'এই ট্যাগ টেমপ্লেটের বারকোড প্রপার্টি সিম্পল বারকোড সাপোর্ট করে না, বারকোড প্রপার্টি পরিবর্তন করুন (প্রস্তাবিত: CODE128)',
    plankTemp: 'ছোট বোর্ড ট্যাগ টেমপ্লেট',
    surplusTemp: 'উদ্বৃত্ত উপকরণ ট্যাগ টেমপ্লেট',
    enableSubTag: 'সাব লেবেল চালু করুন',
    enableSubTagTip: 'আরও সেটিংস > ছোট প্যানেলের সাব লেবেল সেটিং > সাব লেবেল তৈরির কার্যকর ডেটা সোর্স সেট করুন থেকে সেট করা যায়। চালু করার পর শুধুমাত্র সেট করা ডেটা সোর্সের সাব লেবেলে মান থাকলেই সাব লেবেল তৈরি হবে, অন্যথায় তৈরি হবে না।',
    goSet: 'সেটিংসে যান',
    mainTag: 'ছোট প্যানেলের মূল লেবেল',
    subTag: 'ছোট প্যানেলের সাব লেবেল',
    downloadSubTagTip: 'রপ্তানি করা লেবেলে সাব লেবেল আছে। স্বয়ংক্রিয় লেবেলিং প্রোডাকশন লাইন আপাতত সাব লেবেল তৈরি করতে পারে না। আউটপুট চালিয়ে যেতে চান?',
    embeddedSubTagTip: 'সাব লেবেল ফাংশন সমর্থিত নয়। সাব লেবেল ফাংশন সমর্থিত নয়। সাব লেবেল ফাংশন সমর্থিত নয়।',
    subTagPerSaveTip: 'সাব লেবেল অনুমতি শেষ হয়েছে। সাব লেবেল বন্ধ করে এবং পুনরায় সংরক্ষণ করুন',
    subTagPerexportTip: 'রপ্তানি করা প্রোডাকশন ফাইলে প্যায়াবলী সাব লেবেল অনুমতি রয়েছে। এই ফাংশনটি শেষ হয়েছে এবং পুনরায় বন্ধ করে এবং সংরক্ষণ করুন',
    tempNamePlaceHolder: 'টেমপ্লেটের নাম লিখুন',
    editTip: 'বামের বাটন ডান দিকের লেবেল পেপারে টেনে এনে চাহিদা অনুযায়ী লেবেল টেমপ্লেট এডিট করুন',
    oneCode: 'বারকোড',
    image: 'ইমেজ',
    arrow: 'তীর',
    editPage: {
      digitLimitation: 'অঙ্কের সীমা',
      title: 'লেবেল টেমপ্লেট এডিটিং',
      reset: 'ডিফল্ট পুনরুদ্ধার করুন',
      exit: 'এডিটিং থেকে বেরুন',
      tagInfo: 'ট্যাগ তথ্য',
      tagName: 'ট্যাগের নাম',
      tagSize: 'ট্যাগ সাইজ',
      tagData: 'ট্যাগ ডেটা',
      dragTip: 'ডেটা ট্যাগ তৈরি করতে বাম মাউস বাটন চেপে টানুন',
      dataTip: 'ডান প্রপার্টি প্যানেল থেকে ডেটা তথ্য নির্বাচন করুন',
      text: 'টেক্সট',
      dataSource: 'ডেটা সোর্স',
      graph: 'গ্রাফিক',
      typograpyPic: 'টাইপসেটিং ডায়াগ্রাম',
      barCode: 'বারকোড',
      QRCode: 'QR কোড',
      plankMark: 'প্লেট মার্ক',
      holeSlotPic: 'হোল ও স্লট ডায়াগ্রাম',
      edgeBandPic: 'এজ ব্যান্ডিং ডায়াগ্রাম',
      visibleEdgePic: 'দৃশ্যমান এজ',
      holeSlotPicZoom: 'হোল স্লট পিকচার জুম',
      rotateDeg: 'রোটেশন অ্যাঙ্গেল',
      colorDeep: 'রঙের গভীরতা',
      surplusMark: 'উদ্বৃত্ত উপকরণ মার্ক',
      surplusSizePic: 'উদ্বৃত্ত উপকরণ সাইজ ছবি',
      dataSize: 'ডেটা সাইজ',
      extraList: 'অতিরিক্ত তালিকা',
      QRCodeFormat: 'QR কোড ফরম্যাট',
      formatQR: 'QR ফরম্যাট',
      formatDM: 'DM ফরম্যাট',
      locIndex: 'ক্যাবিনেট সূচক',
      plankFrontSign: 'প্যানেল মার্ক',
      genNCSuffix: 'NC সাফিক্স জেনারেট করুন',
      table: 'টেবিল',
      inputPlaceholder: 'টেক্সট লিখতে ডাবল-ক্লিক করুন',
      attribute: 'অ্যাট্রিবিউট',
      fontFamily: 'ফন্ট ফ্যামিলি',
      fontSize: 'ফন্ট সাইজ',
      fontWeight: 'ফন্ট ওয়েট',
      flipOverProcessing: 'ফ্লিপ ওভার প্রসেসিং',
      showSideMachiningSequenceDiagramBorder: 'ফ্লিপ ওভার প্রসেসিং এবং একই মতো ফ্লিপ ওভার প্রসেসিং',
      showSideMachiningSequenceNumber: 'ফ্লিপ ওভার প্রসেসিং এবং একই মতো ফ্লিপ ওভার প্রসেসিং',
      autoRow: 'অটো র্যাপ টেক্সট',
      rowMargin: 'রো স্পেসিং',
      autoFontSize: 'ওভারফ্লোতে ফন্ট সাইজ স্বয়ংক্রিয় সমন্বয়',
      statisticsDimension: 'স্ট্যাটিস্টিক্যাল ডাইমেনশন',
      noLimit: 'সীমাহীন',
      sameOrderNo: 'একই অর্ডার',
      sameRoom: 'একই রুম',
      sameWardrobe: 'একই ওয়ারড্রোব',
      alignWay: 'অ্যালাইনমেন্ট',
      JustifyLeft: 'বাম-সারিবদ্ধ',
      JustifyRight: 'ডান-সারিবদ্ধ',
      JustifyCenter: 'কেন্দ্র-সারিবদ্ধ',
      otherOpration: 'অন্যান্য অপারেশন',
      attributeReset: 'অ্যাট্রিবিউট রিসেট',
      barCodeSize: 'বারকোড সাইজ',
      installPic: 'ইনস্টলেশন ডায়াগ্রাম',
      plankCode2: 'প্লেট বারকোড (noMark)',
      frontCode: 'সামনের বারকোড',
      backCode: 'পিছনের বারকোড',
      orderRemark: 'অর্ডার মন্তব্য',
      NCFileName: 'কাটিং ফাইলের নাম',
      NCFileNameTip: 'NC ফাইলের নামে চীনা অক্ষর থাকবে না এবং দৈর্ঘ্য ১০ অক্ষরের বেশি হবে না',
      showOpenSide: 'দরজা খোলার দিক দেখান',
      limitFixed: 'দশমিক স্থান সীমিত করুন',
      showFrontHS: 'সামনের হোল স্লট দেখান',
      showBackHS: 'পিছনের হোল স্লট দেখান',
      showPartEdge: 'প্যানেল এজ ব্যান্ডিং দেখান',
      showPlankSize: 'প্ল্যাঙ্ক সাইজ দেখান',
      tempNamePlaceholder: 'লেবেলের নাম লিখুন',
      deleteAreaTip: 'মুছতে চাওয়া অঞ্চল নির্বাচন করুন',
      suitShunt: 'প্যানেল এজ ব্যান্ডিং দেখান',
      suitShuntTip: 'পিছনের কাজ না থাকলে, হোল স্লট প্যানেল বারকোড তৈরি করা হবে না',
      noHoleSlot: 'হোল ও স্লট না থাকলেও বারকোড দেখান',
      rotate: 'বারকোড ঘোরান',
      barcodeAtrribute: 'বারকোড অ্যাট্রিবিউট',
      imgSize: 'ইমেজ সাইজ',
      graphStyle: 'গ্রাফ স্টাইল',
      noEdgeDisplay: 'এজ ০ হলে দেখাবেন না',
      allEdgeNoDisplay: 'এজ ব্যান্ডিং দেখানো হয় না',
      isShowDiffEdgeColor: 'বিভিন্ন এজ রঙ দেখান',
      hideSameEdgeColorAsPlank: 'প্লেট রঙ সমান হলে এজ রঙ দেখাবেন না',
      hideSameEdgeColorAsPlankTip: 'এমবেডেড ক্লাউড লেআউট এখনও সমর্থিত নয়',
      imgRotate: 'ইমেজ রোটেশন',
      circleD: 'বৃত্ত ফ্রেমের ব্যাস',
      roomNo: 'রুম নম্বর',
      roomOrder: 'ক্যাবিনেট অর্ডার (রুম অনুযায়ী সর্ট)',
      alphabetically: 'বর্ণানুক্রমে সর্ট করুন',
      numberOrder: 'সংখ্যা অনুযায়ী সর্ট করুন',
      specialMarkup: 'বিশেষ মার্কিং চিহ্ন',
      smallPlateMarking: 'ছোট প্লেট মার্কিং',
      arrow: 'তীর',
      triangle: 'ত্রিভুজ',
      sixSideDrillPlankBase: 'ছয় পাশ ড্রিলিং প্লেসমেন্ট বেস',
      boldSettingTip: 'PDF বোল্ড ফন্ট সাপোর্ট করা হয় না',
      frontEdge: 'ক্যাবিনেটের সামনের দিক দেখান',
      visibleEdge: 'দৃশ্যমান এজ দেখান',
      lineCount: 'প্রতি লাইনে অক্ষরের সংখ্যা'
      },
    autoSaveToHistory: 'ইতিহাসে স্বয়ংক্রিয়ভাবে সংরক্ষিত হয়েছে!',
    firstPrintTip: 'প্রথমবার ডাইরেক্ট প্রিন্ট ব্যবহার করলে প্রিন্টার সেটিংসে লম্বা-চওড়া উলটানো নতুন কাগজ যোগ করুন, তারপর সেই কাগজে প্রিন্ট করুন',
    tagDownloading: 'লেবেল ডাউনলোড হচ্ছে...',
    cutLaveEnd: 'কাট-অফ লেবেল প্রতিটি বড় স্ল্যাবের পিছনে তৈরি হয়',
    deleteTemplate: 'রুপান্তর মুছতে নিশ্চিত করবেন',
    copyTemplateRenderUrl: 'টেমপ্লেট লিঙ্ক কপি করুন',
    noPermission: 'টেমপ্লেট লিঙ্ক কপি করার অনুমতি নেই, টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    moreOperation: 'আরও কাজ করুন',
    importTemplate: 'টেমপ্লেট আমদানি করুন',
    importTemplateLink: 'টেমপ্লেট লিঙ্ক কপি করুন, টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    importTemplateLinkPlaceholder: 'টেমপ্লেট লিঙ্ক কপি করুন, টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    noDeleteTemplate: 'টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tip1: 'টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tip2: 'টেমপ্লেট মুছার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tip3: 'টেমপ্লেট লিঙ্ক কপি করার পর পুনরুদ্ধার করা যাবে না, মুছতে নিশ্চিত করবেন?',
    tip4: 'ইমপোর্ট করা টেমপ্লেট লিংক সনাক্ত করা যায়নি, অনুগ্রহ করে আবার ডাউনলোড করে ইমপোর্ট করুন।'
    },
  fileManagerPage: {
    folderClassifyByTextureColorThickSize: 'উপকরণ, রঙ, পুরুত্ব ও বড় বোর্ড সাইজ অনুযায়ী আলাদা ফোল্ডারে শ্রেণীবিন্যাস (লেবেলিং ফাইল সহ)',
    notOpeFolderPermission: 'এই ডিরেক্টরিতে অপারেশনের অনুমতি নেই',
    notFindFolder: 'বর্তমান ক্লায়েন্টে এই ডিরেক্টরি সনাক্ত করা যাচ্ছে না',
    productLineUniversal: 'সব প্রোডাকশন লাইনের জন্য ইউনিভার্সাল',
    effectCondition: 'এই সেটিং পরিবর্তন পুনরায় লেআউটের পরেই কার্যকর হবে',
    addPath: 'পাথ যোগ করুন',
    downloadPositionChangeByType: 'জেনারেট ফাইলের ডাউনলোড অবস্থান {type} এ পরিবর্তন করা হয়েছে',
    isDeleteFolder: 'ব্যবহৃত ফাইল স্টোরেজ অবস্থান মুছতে নিশ্চিত করবেন?',
    netWorkIsNotSafe: 'আপনার নেটওয়ার্ক পরিবেশ নিরাপদ মনে হচ্ছে না, এই ফিচার চালু করা যাচ্ছে না, আমাদের ফিডব্যাক দিতে পারেন',
    NotSupportBrowse: 'আপনার ব্রাউজার এই ফিচার সাপোর্ট করে না, সর্বশেষ Edge ব্রাউজার ডাউনলোড করে ব্যবহার করুন',
    notSupportDisk: 'সিস্টেম-লেভেল ডিরেক্টরি যেমন [ডেস্কটপ] [C ড্রাইভ] নির্বাচন করা যাবে না',
    useFolderDownload: 'প্রোডাকশন ফাইল আনজিপ ফরম্যাটে ডাউনলোড হয়',
    downloadPosition: 'ডাউনলোড ফাইল অবস্থান',
    changeUseFolder: 'পরিবর্তন করুন',
    folderNameSetting: 'ফোল্ডার সেটিংস',
    mainFolder: 'প্রাইমারি ফোল্ডার',
    exportNameSetting: 'অর্ডার নম্বর দিয়ে এক্সপোর্ট প্রসেসড ফাইল নেমিং',
    fileMax: 'ফাইলের নাম সর্বোচ্চ',
    char: 'অক্ষর',
    overTip: 'অতিরিক্ত অংশ দেখানো হবে না (লেবেল গ্রাফিক্স জিপ ও json ফাইল প্রাইমারি ফোল্ডার নেমিং অনুসরণ করবে)',
    example: 'উদাহরণ',
    engravingFolder: 'এনগ্রেভিং মেশিন ফোল্ডার',
    electronicSawFolder: 'ইলেকট্রনিক স saw ফোল্ডার',
    labellingFolder: 'লেবেলিং মেশিন ফোল্ডার',
    sideHoleDrillFolder: 'সাইড হোল ড্রিলিং মেশিন ফোল্ডার',
    fiveDrillFolder: 'পাঁচ-পাশ ড্রিলিং মেশিন ফোল্ডার',
    sixDrillFolder: 'ছয়-পাশ ড্রিলিং মেশিন ফোল্ডার',
    PTPFolder: 'PTP ফোল্ডার',
    labellingTagFolder: 'লেবেলিং ইমেজ ফোল্ডার',
    surplusFolder: 'উদ্বৃত্ত ফাইল বড় বোর্ড সেটিংস',
    surplusBigPlankSetting: 'স্পেয়ার ম্যাটেরিয়াল বড় বোর্ড কাটিং ফাইল/লেবেল ছবি/লেবেলিং ফাইল আলাদা রাখা হয়',
    surplusBigPlankSettingTip: 'চালু করার পর উদ্বৃত্ত NC ফাইল, লেবেল ছবি ও লেবেলিং ফাইল আলাদা ফোল্ডারে রাখা হবে',
    folderMergeSetting: 'ফোল্ডার মার্জিং সেটিংস',
    folderMerge: 'ফোল্ডার মার্জিং',
    mergeName: 'মার্জড নাম',
    subMergeFolder: 'উপকরণ, রঙ ও পুরুত্ব অনুযায়ী সাবফোল্ডারে মার্জ করুন',
    subFolderName: 'সাবফোল্ডার নাম',
    splitChar: 'সেপারেটর',
    splitTip: '( / : ? < > | . " * ইত্যাদি অক্ষর সাপোর্ট করা হয় না)',
    folderAutoAdd: 'ফোল্ডার কাউন্ট অটো ইনক্রিমেন্ট স্টার্ট ভ্যালু',
    resetTip: '(প্রতিদিন মধ্যরাতে স্টার্ট ভ্যালুতে রিসেট হয়)',
    emptyErrTip: 'তথ্য খালি রাখা যাবে না',
    repeatErrTip: 'ফাইলের নাম ডুপ্লিকেট',
    mergeDataTip: 'বোর্ড উপকরণ রঙ পুরুত্ব দৈর্ঘ্য প্রস্থ বা ফাইল নম্বর বৃদ্ধি বা বোর্ড উপকরণ রঙ পুরুত্ব থাকতে হবে',
    engravingFileSetting: 'ক্যারভিং মেশিন ফাইল সেটিংস',
    engravingSplitZF: 'এনগ্রেভিং মেশিনের সামনে/পিছনের ফাইল আলাদা ফোল্ডারে রাখুন',
    engravingSplitZFTip: '১২৩ অটোমেটিক লেবেলিং মেশিনের জন্য উপযুক্ত',
    engravingSplitWorkstation: 'এনগ্রেভিং মেশিনের কাজস্থান অনুযায়ী ফোল্ডার',
    engravingSplitWorkstationTip: 'এনগ্রেভিং মেশিন এবং সাউইং এনগ্রেভিং মেশিনের জন্য উপযুক্ত',
    holeFileSetting: 'পাঞ্চ ফাইল সেটিংস',
    holeFileSingle: 'পাঞ্চিং ফাইল ভিন্ন অর্ডার অনুযায়ী ফোল্ডারে আলাদা রাখা হয়'
    },
  moreSettings: {
    generalSetting: 'সাধারণ সেটিং',
    outSyncTip: 'ক্লাউড টাইপসেটিং অরিজিনাল ডেটা ক্যাবিনেটের সাথে সিঙ্ক না থাকলে প্রম্পট পপআপ তৈরি হয়',
    secondarySwitchShow: 'এনগ্রেভিং মেশিন সেটিংয়ে সুইচ কন্ট্রোলের সেকেন্ডারি কন্টেন্ট সুইচ বন্ধের পরও দেখায়',
    isFrameDoorTip: 'ফ্রেম ডোর প্রক্রিয়াকরণ সময় প্রম্পট পপআপ তৈরি হয়',
    exPaibanTip: 'ইরেগুলার স্ক্র্যাপ/ইরেগুলার নেস্টিং টাইপোগ্রাফি ব্যবহার করলে প্রম্পট পপআপ তৈরি হয়',
    isDesMaterialNoCutTip: 'নির্দিষ্ট ছোট বোর্ড উপকরণ কাটা হয় না এমন প্লেটে, এনগ্রেভিং মেশিনে অ্যাসাইন করা হোল/স্লট/শেপ থাকলে প্রম্পট পপআপ তৈরি হবে',
    surpTagThresholdTextHalf1: 'যখন উদ্বৃত্ত উপকরণের (কাটিং নয়) ক্ষেত্রফল এর চেয়ে কম',
    surpTagThresholdTextHalf2: 'উদ্বৃত্ত উপকরণ লেবেল তৈরি করবেন না',
    innerShapeToolMatch: 'ক্যারভিং মেশিন ভিতরের অনিয়মিত শেপের জন্য উপযুক্ত টুল অটোমেটিক সিলেক্ট করে',
    innerShapeToolMatchTip: '(ক্যারভিং মেশিন কাটিং টুল ব্যাসের চেয়ে ছোট ভিতরের অনিয়মিত শেপ প্রসেস করলে সাইজ এরর প্রসেস করা যায় না, এই ফাংশন চালু করে সমাধান করা যাবে)',
    innerShapeToolMatchTip2: 'নোট: চালু করার পর ক্যারভিং মেশিন সবচেয়ে ছোট স্লট কাটার ব্যবহার করবে, সবচেয়ে ছোট স্লট কাটারের টুল লেন্থ ও ম্যাক্স সিঙ্গেল প্রসেসিং ডেপথ সাবধানে সেট করুন, শুধুমাত্র ক্লাউড সেটিংসে ভ্যালিড',
    surNotLayout: 'উদ্বৃত্ত বড় বোর্ড নির্দিষ্ট বোর্ড কম্পোনেন্ট না সাজিয়ে সংজ্ঞায়িত করুন',
    surNotLayoutTip: 'চালু করার পর ১.উদ্বৃত্ত বড় বোর্ডে নিচের নামযুক্ত ছোট বোর্ড সাজানো যাবে না ২.টাইপসেটিংয়ের সময় এই টাইপসেটিংয়ে এই ফাংশন কার্যকর কিনা বেছে নিতে পারবেন',
    addPlank: 'বোর্ডের নাম যোগ করুন',
    addPlankTip: 'কমপক্ষে একটি ছোট বোর্ডের নাম যোগ করুন',
    thisInput: 'এখানে লিখুন',
    surNotLayoutMat: 'উদ্বৃত্ত নির্দিষ্ট ছোট বোর্ডে সাজানো হয় না',
    subTagSetting: 'ছোট প্যানেলের সাব লেবেল সেটিং',
    subTagDataSource: 'সাব লেবেল তৈরির কার্যকর ডেটা সোর্স সেট করুন',
    subTagDataSourceTip: 'চালু করার পর সাব লেবেল তৈরি নিয়ন্ত্রণকারী ডেটা সোর্স যোগ করা যায়। সাব লেবেলে সেই ডেটা সোর্স থাকলে এবং মান থাকলে সাব লেবেল তৈরি হবে।',
    addSubTagDataSource: 'ডেটা সোর্স যোগ করুন',
    addSubTagDataSourceTip: 'ডুপ্লিকেট ডেটা সোর্স যোগ করা যাবে না',
    addSubTagDataSourceTip1: 'অন্তত একটি ডেটা সোর্স যোগ করুন',
    addSubTagDataSourceTip2: 'ডেটা সোর্স খালি রাখা যাবে না, অনুগ্রহ করে নির্বাচন করুন',
    reuseMatchingPlankName: 'নাম অনুযায়ী পুনঃব্যবহার মিলানো',
    reuseMatchingPlankNameTip1: 'এই বৈশিষ্ট্যটি নিষ্ক্রিয় থাকলে, লেআউট পুনঃব্যবহার একই উপাদান, রঙ, পুরুত্ব, মাত্রা, টেক্সচার এবং উচ্চ-গ্লস বৈশিষ্ট্য সহ প্যানেল মিলায়',
    reuseMatchingPlankNameTip2: 'এই বৈশিষ্ট্যটি সক্রিয় করলে, উপরিউক্ত মিলানোর শর্তগুলি ছাড়াও, প্লেটের নাম মিলানোও যোগ করা হবে'
    },
  lineManager: {
    add: 'প্রোডাকশন লাইন যোগ করুন',
    engraving: 'কাটিং ইকুইপমেন্ট',
    holeSlotEquip: 'H&S ইকুইপমেন্ট',
    workSetting: 'প্রসেসিং সেটিংস',
    noUse: 'সক্ষম নেই',
    warningTip: '*নোট: নিচের ফাংশন সেট করার পর ক্যাবিনেট ক্লায়েন্ট ডিভাইস ডকিং পেজে সেভ করবেন না, প্যারামিটার রিসেট এড়াতে!',
    engravingSetting: 'কাটিং মেশিন সেটিংস',
    workWay: 'প্রসেসিং মেথড',
    cutedSpecial: 'প্রসেসিংয়ের জন্য বিশেষ হোল ও স্লট:',
    noWork: 'এই অপশন পাঁচ/ছয়-পাশ ড্রিলিংয়ের ডিফল্ট টেমপ্লেটে প্রযোজ্য নয়',
    onlyCut: 'শুধুমাত্র কাটিং',
    onlyFrontHoleSlot: 'শুধুমাত্র বোর্ডের সামনের হোল ও স্লট প্রসেস করুন',
    onlyHoleSlot: 'শুধুমাত্র বোর্ডের সামনে ও পিছনের হোল ও স্লট প্রসেস করুন',
    sideHoleSetting: 'সাইড হোল মেশিন সেটিংস',
    cutHoleSlot: 'প্রসেসড হোল ও স্লট',
    minSize: 'ছোট বাহুর মাত্রা',
    maxSize: 'লম্বা বাহুর মাত্রা',
    minSize2: 'mm বোর্ডের সব',
    minSize3: 'ও অ্যালিয়েন পার্ট',
    onlyFrontHoleSlotTip: 'লেআউট পেজে শুধুমাত্র সামনের দিকে হোল স্লট আছে এমন বোর্ড',
    onlyFrontHoleSlotTip2: 'সাইড হোল ও স্লট অন্তর্ভুক্ত নয়',
    holeAndSlot: 'হোল ও স্লট',
    empty: 'খালি',
    singleHole: 'সিঙ্গেল হোল',
    singleSlot: 'সিঙ্গেল স্লট',
    diameterRange: 'হোল ডায়ামিটার রেঞ্জ',
    hDeepRange: 'হোল ডেপথ রেঞ্জ',
    widthRange: 'স্লট প্রস্থ রেঞ্জ',
    sDeepRange: 'স্লট ডেপথ রেঞ্জ',
    to: 'প্রতি',
    specialHS: 'বিশেষ হোল, স্লট ও শেপ',
    allowRoll: 'কাটিং মেশিন বোর্ড উলটিয়ে বিশেষ হোল ও স্লট প্রসেস করার অনুমতি দিন',
    engravingPath: 'কাটিং মেশিনে বোর্ডের বিশেষ পার্ট প্রসেস করুন',
    curve_range: 'বিশেষ শেপ পার্টের লম্বা বাহু এর চেয়ে বড়',
    curve_range2: 'বোর্ডের সব বিশেষ শেপ পার্ট',
    curveArea: 'অনিয়মিত শেপের ক্ষেত্রফল',
    drillSetting: 'পাঁচ/ছয়-পাশ ড্রিলিং সেটিংস',
    engravingCuted: 'কাটিং মেশিনে প্রসেসড হোল ও স্লট পাঁচ/ছয়-পাশ ড্রিলে',
    engravingCutedSpecial: 'বোর্ডের সব বিশেষ শেপ পার্ট কাটিং মেশিনে প্রসেসড হোল ও স্লট পাঁচ/ছয়-পাশ ড্রিলে',
    genCuttingPath: 'কাটিং ডেটা জেনারেট করুন',
    otherCuted: 'অন্য ইকুইপমেন্টে প্রসেসড হোল ও স্লট পাঁচ/ছয়-পাশ ড্রিলে',
    noGen: 'জেনারেট করবেন না',
    genCut: 'জেনারেট ও প্রসেস করুন',
    genNoCut: 'জেনারেট করুন কিন্তু প্রসেস করবেন না',
    cutTip: 'নোট: এই অপশন শুধুমাত্র কাস্টম পাঁচ/ছয়-পাশ ড্রিলিং ফাইলে প্রযোজ্য',
    maxShortSize: 'সর্বোচ্চ ছোট বাহুর দৈর্ঘ্য',
    maxLongSize: 'সর্বোচ্চ লম্বা বাহুর সাইজ',
    normalSlot: 'নিয়মিত স্লট',
    specialSlot: 'বিশেষ স্লট',
    combinSetting: 'কম্বাইন্ড ইকুইপমেন্ট সেটিংস',
    allowShortSize: 'ছোট বাহুর দৈর্ঘ্য অনুমতি দিন',
    equipment1: 'ইকুইপমেন্ট ১',
    equipment2: 'ইকুইপমেন্ট ২',
    noSameTip: 'নোট: দুটি ইকুইপমেন্ট একই হতে পারবে না',
    workRange: 'ইকুইপমেন্ট ১-এর প্রসেসিং রেঞ্জ',
    rangeWarning: 'নোট: শুধুমাত্র ইকুইপমেন্ট ১-এর প্রসেসিং রেঞ্জ সেট করা যাবে। নন-ইকুইপমেন্ট ১ রেঞ্জ সব ইকুইপমেন্ট ২-তে প্রসেস হবে। সাবধানে এগিয়ে যান!',
    deleteWarning: 'এই প্রোডাকশন লাইন মুছার পর পুনরুদ্ধার করা যাবে না (এই লাইনের সব সেটিং মুছে যাবে)। এই প্রোডাকশন লাইন মুছতে নিশ্চিত করবেন?',
    top: 'শীর্ষ',
    inputCheck: '{msg}-এর ন্যূনতম মান সর্বোচ্চ মানের চেয়ে বড় হতে পারবে না',
    lockTip: 'প্রোডাকশন লাইন লক করা আছে, অপারেশন নিষিদ্ধ!',
    reNameTip: 'ডিফল্ট প্রোডাকশন লাইনের নাম পরিবর্তন করা যাবে না',
    permissonTip: 'আপনার আইডেন্টিটি মেয়াদ উত্তীর্ণ। ক্যাবিনেট থেকে এই পেজ আবার খুলুন!',
    permissonErr: 'আপনার এই অনুমতি নেই। অ্যাকাউন্ট সংস্করণ আপগ্রেড করুন!',
    permissionOneMacErr: 'আপনার বর্তমানে ইন্টিগ্রেটেড মেশিনের জন্য {idx}টি প্রোডাকশন লাইন অ্যাক্সেস আছে। আর যোগ করতে চাইলে সেলসপারসনের সাথে যোগাযোগ করুন!',
    permissionSawErr: 'কাটিং মেশিন ব্যবহারের অনুমতি নেই, সেলসের সাথে যোগাযোগ করে ফুল-অ্যালুমিনিয়াম কাটিং সাপ্লিমেন্ট প্যাক কিনে ব্যবহার করুন',
    getAuthError: 'ডিভাইস অনুমতি পেতে ব্যর্থ!',
    sawAddNumber: 'আপনার উপলব্ধ ই-স saw প্রোডাকশন লাইন শেষ। সীমা বাড়াতে চাইলে সেলসের সাথে যোগাযোগ করুন!',
    newLine: 'নতুন প্রোডাকশন লাইন {idx}',
    deleteCheck: 'সব মুছতে পারবেন না',
    deving: 'ডেভেলপমেন্ট চলছে',
    combinTip: 'নিচের কম্বাইন্ড ইকুইপমেন্ট সেট আপ করতে ক্লিক করুন',
    noUseEquip: 'প্রসেসিং ইকুইপমেন্ট সক্ষম নেই',
    equipmentSelectTip: 'কম্বাইন্ড ইকুইপমেন্টে কাটিং মেশিন নির্বাচন করলে কাটিং ইকুইপমেন্ট ইলেকট্রনিক স saw নির্বাচন করতে পারবে না',
    lineLoading: 'ডেটা লোড হচ্ছে',
    strenchType: 'স্ট্রেইটনার স্লট টাইপ',
    aioProcessTip: 'আপনি অল-ইন-ওয়ান ডিভাইস সক্ষম করেছেন, প্রসেসিং মোড ডিফল্টে বোর্ডের দুদিকের হোল ও স্লট প্রসেস করে',
    aioProcessTip2: 'অল-ইন-ওয়ান সক্ষম করার পর ক্যারভিং মেশিন সেকশনে বিশেষ হোল ও স্লট প্রসেস হবে',
    aioProcessTip3: 'নোট: এই ফাংশন XY অক্ষ সোয়াপ সক্ষম ক্যারভিং মেশিনের সাথে সামঞ্জস্যপূর্ণ নয়। সাবধানে ব্যবহার করুন',
    specialHoleTip: 'নোট: উপরের বিশেষ হোল স্লট প্রসেসিং ব্যবহার করলে থ্রু-হোল ড্রিলিং ও থ্রু-স্লট পেনিট্রেশন একবারে ড্রিল থ্রু সেট করুন',
    specialHoleTip2: 'নোট: উপরের বিশেষ হোল স্লট প্রসেসিং ব্যবহার করলে ক্যারভিং মেশিনের থ্রু-হোল ও থ্রু-স্লট একবারে ড্রিল থ্রু সেট করুন',
    fiveSixNotTake: 'এই অপশন পাঁচ/ছয়-পাশ ড্রিলিংয়ের ডিফল্ট টেমপ্লেটে প্রযোজ্য নয়',
    onlyFrontSide: 'শুধুমাত্র সামনের দিক প্রসেস করুন',
    onlyBackSide: 'শুধুমাত্র পিছনের দিক প্রসেস করুন',
    less: 'এর চেয়ে কম',
    equal: 'সমান',
    greater: 'এর চেয়ে বড়',
    or: 'অথবা',
    and: 'এবং',
    bothFrontBack: 'সামনে ও পিছনে উভয় দিক প্রসেস করুন',
    shareDataErrTip: 'এই ডেটা {operatorPhone} দ্বারা অ্যাপ্লাই করা, IP: {actionIp}',
    restoreParams: 'প্যারামিটার পুনরুদ্ধার করুন',
    loadMore: 'আরো লোড করুন',
    currentCombinationEquipment: 'বর্তমানে নির্বাচিত কম্বাইন্ড ইকুইপমেন্ট কাটিং ইকুইপমেন্টকে গ্লাস কাটিং মেশিনে সুইচ করতে দেয় না',
    selectEquipmentType: 'ইকুইপমেন্ট টাইপ নির্বাচন করুন',
    ruleRemark: 'রুল রিমার্ক',
    remarkPlaceholder: 'এটি একটি নোট তথ্য, এই রুল কোন প্রযুক্তি প্রসেস করে তা নোট করতে পারেন, ভুলে যাওয়া এড়ান, লাইন সেভ করার পর প্রোডাকশন লাইনে কার্যকর হবে',
    onlyNoSideHoleSlotSmallPlank: 'শুধুমাত্র পার্শ্ব ছিদ্র/স্লটবিহীন ছোট বোর্ড'
    },
  cuttingDock: {
    title: 'কাটিং মেশিন ডকিং',
    autoStockCode: 'অটোমেটিক লোডিং ও আনলোডিং কোড',
    stationStart: 'স্টেশন স্টার্ট',
    stationStartCode1: 'স্টেশন ১ স্টার্ট কোড',
    stationStartCode1Placeholder: 'স্টেশন ১ স্টার্ট কোড লিখুন',
    stationStartCode2: 'স্টেশন ২ স্টার্ট কোড',
    stationStartCode2Placeholder: 'স্টেশন ২ স্টার্ট কোড লিখুন',
    stationEnd: 'স্টেশন এন্ড',
    stationEndCode1: 'স্টেশন ১ এন্ড কোড',
    stationEndCode1Placeholder: 'স্টেশন ১ এন্ড কোড লিখুন',
    stationEndCode2: 'স্টেশন ২ এন্ড কোড',
    stationEndCode2Placeholder: 'স্টেশন ২ এন্ড কোড লিখুন',
    frontBackStart: 'সামনে ও পিছনে স্টার্ট',
    frontBackEnd: 'সামনে ও পিছনে এন্ড',
    frontStartCode: 'ফ্রন্ট স্টার্ট কোড',
    frontStartCodePlaceholder: 'ফ্রন্ট স্টার্ট কোড লিখুন',
    frontEndCode: 'ফ্রন্ট এন্ড কোড',
    frontEndCodePlaceholder: 'ফ্রন্ট এন্ড কোড লিখুন',
    backStartCode: 'ব্যাক স্টার্ট কোড',
    backStartCodePlaceholder: 'ব্যাক স্টার্ট কোড লিখুন',
    backEndCode: 'ব্যাক এন্ড কোড',
    backEndCodePlaceholder: 'ব্যাক এন্ড কোড লিখুন',
    plankStart: 'প্ল্যাঙ্ক টার্ন স্টার্ট',
    plankEnd: 'প্ল্যাঙ্ক টার্ন এন্ড',
    plankRollCode1: 'স্টেশন ১ টার্ন কোড',
    plankRollCode1Placeholder: 'স্টেশন ১ টার্ন কোড লিখুন',
    plankRollCode2: 'স্টেশন ২ টার্ন কোড',
    plankRollCode2Placeholder: 'স্টেশন ২ টার্ন কোড লিখুন',
    autoBaitingCode: 'অটো ফিডিং কোড',
    autoBaitingCode1: 'স্টেশন ১ ফিডিং কোড',
    autoBaitingCode1Placeholder: 'স্টেশন ১ ফিডিং কোড লিখুন',
    autoBaitingCode2: 'স্টেশন ২ ফিডিং কোড',
    autoBaitingCode2Placeholder: 'স্টেশন ২ ফিডিং কোড লিখুন',
    thickMarkPermission: 'আপনার বর্তমানে বড় প্ল্যাক পুরুত্ব চিহ্নের অনুমতি নেই, ব্যবহারের আগে বিক্রয়ের সাথে যোগাযোগ করে কিনুন',
    thickMark: 'বড় প্লাক প্রস্থ চিহ্নিত করুন',
    preStartEquipment: 'প্রি-স্টার্ট ইকুইপমেন্ট',
    firstKnifePreCode: 'ফার্স্ট নাইফ প্রি-স্টার্ট কোড অ্যাডভান্স',
    secondKnifePreCode: 'সেকেন্ড ও পরবর্তী নাইফ প্রি-স্টার্ট কোড অ্যাডভান্স',
    rowInsert: 'রো ইনসার্ট',
    pumpPause: 'ভ্যাকুয়াম পাম্প পজ',
    pumpPauseTip: 'নোট: সিমপ্লেক্স ইকুইপমেন্টের জন্য স্টেশন ১ ও ২ উভয়েই একই অটোমেটিক ফিডিং কোড ও ডাবল-সাইডেড মেশিনিং ফ্রন্ট নোট কোড পূরণ করতে হবে',
    pumpPause2Tip: 'নোট: সিমপ্লেক্স ইকুইপমেন্টের জন্য স্টেশন ১ ও ২ উভয়েই একই ভ্যাকুয়াম পাম্প পজ কোড পূরণ করতে হবে',
    pumpPauseCode1: 'স্টেশন ১ ভ্যাকুয়াম পাম্প পজ কোড',
    pumpPauseCode1Placeholder: 'স্টেশন ১-এর ভ্যাকুয়াম পাম্প পজ কোড লিখুন',
    pumpPauseCode2: 'স্টেশন ২ ভ্যাকুয়াম পাম্প পজ কোড',
    pumpPauseCode2Placeholder: 'স্টেশন ২-এর ভ্যাকুয়াম পাম্প পজ কোড লিখুন',
    annotationCode1: 'স্টেশন ১ ডাবল-সাইডেড প্রসেসিং (ফ্রন্ট) অ্যানোটেশন কোড',
    annotationCode1Tip: 'অটোমেটিক লোডিং (ফ্রন্ট) এর জন্য ভিন্ন কমান্ড আছে এমন ইকুইপমেন্টের জন্য উপযুক্ত',
    annotationCode1Placeholder: 'স্টেশন ১ ডাবল-সাইডেড প্রসেসিং (ফ্রন্ট) অ্যানোটেশন কোড লিখুন',
    annotationCode2: 'স্টেশন ২ ডাবল-সাইডেড প্রসেসিং (ফ্রন্ট) অ্যানোটেশন কোড',
    annotationCode2Placeholder: 'স্টেশন ২ ডাবল-সাইডেড প্রসেসিং (ফ্রন্ট) অ্যানোটেশন কোড লিখুন',
    upSpeedTip: 'কমন এজ অ্যাকসেলারেশন স্পিড লিখুন',
    cutThickTip: 'কমন এজ কাটিং বেধ লিখুন',
    sizeErrTip: 'লেবেলিং মেশিনে এক্সপোর্ট লেআউটের সঠিক সাইজ সেট করুন!',
    offEdgeKnifeDiameter: 'ট্রিমিং নাইফ ডায়ামিটার লিখুন',
    slowDownSpeedTip: 'কাটিং কর্নার ডিসেলারেশন ইনপুট প্যারামিটার ত্রুটি',
    permissionErr: 'এটি ফ্রি সংস্করণ, সেভ করার অনুমতি নেই',
    labellingTempErr: 'লেবেলিং মেশিন টেমপ্লেট নির্বাচন করুন',
    autoRollInputTip: 'অটোমেটিক লেবেল রোটেশন চালু করতে বৈধ মান লিখতে হবে',
    offlineTempFormat: 'বর্তমান লেবেলিং মেশিন ফাইল ফরম্যাট বন্ধ, নিশ্চিত করুন',
    autoStockCode1: 'স্টেশন ১ অটোমেটিক ফিডিং কোড',
    autoStockCode1PlaceHolder: 'স্টেশন ১ অটোমেটিক ফিডিং কোড লিখুন',
    autoStockCode2PlaceHolder: 'স্টেশন ২ অটোমেটিক ফিডিং কোড লিখুন',
    autoStockCode2: 'স্টেশন ২ অটোমেটিক ফিডিং কোড',
    pauseCode: 'পজ কোড',
    pauseCodePlaceHolder: 'পজ কোড লিখুন',
    cuttingToolMaxDepthTip: 'নাইফ লাইব্রেরিতে {errKey} নাইফের একবারের সর্বোচ্চ মেশিনিং গভীরতা কাটিং টুলের দৈর্ঘ্যের চেয়ে বড় হতে পারবে না',
    cuttingParams: {
      title: 'কাটিং প্যারামিটার',
      stationWidth: 'কাটিং প্যারামিটার',
      stationWidthTip: 'উদ্বৃত্ত বড় প্যানেল ব্যবহার করার সময়, প্রস্থ দিকে শুধুমাত্র নির্ধারিত আকারের সীমার মধ্যে ছোট প্যানেল সাজানো যায়',
      holeSlotMainSide: 'হোল ও স্লট কনসেন্ট্রেটেড ফেস',
      holeMainSide: 'হোল কনসেন্ট্রেটেড ফেস',
      slotMainSide: 'স্লট কনসেন্ট্রেটেড ফেস',
      workPriority: '(ফাংশনাল প্রায়োরিটি: পাঞ্চিং হোল ও স্লটের ফেস ছোট বোর্ডের আনপাঞ্চড হোল স্লট অনুসরণ করে > স্লট ডাইভারশনে সেট বিশেষ স্লট বড় প্যানেলের সামনে প্রায়োরিটি > স্লট কনসেন্ট্রেটেড ফেস > হোল কনসেন্ট্রেটেড ফেস)',
      holeSlotSet: 'পাঞ্চিং স্লট প্রসেসিং সেটিংস',
      hingeRollWork: 'স্ট্রেইটনার ও হিঞ্জ কাপ হোল বড় বোর্ডের উল্টো পাশে প্রসেস করা হয়',
      followWork: 'পাঞ্চিং হোল ও স্লটের ফেস ছোট বোর্ডের আনপাঞ্চড হোল স্লট অনুসরণ করে',
      autoMatchSide: 'সামনে ও পিছনের হোল ও স্লট আনুপাতিকভাবে বরাদ্দ করুন',
      backHSRate: 'উল্টো পাশের হোল ও স্লটের অনুপাত',
      matchTip: '(এই সেটিং হাই-গ্লস বোর্ড, অ্যাবনরমাল লেআউট প্ল্যান খুলে হিসাবের ক্ষেত্রে, বা প্যাটার্ন ম্যাচিংয়ের ক্ষেত্রে কার্যকর হবে না)',
      specIalHoleAndSlotSurface: 'বিশেষ স্লট ও হোলের মেশিনিং সারফেস কাস্টম সংজ্ঞা',
      specialRuleTip: 'এই ফিল্ড খালি রাখা যাবে না।',
      specialSlotsHoles: 'হোল ও স্লট টাইপ',
      holeType: 'হোল টাইপ',
      specialRules: 'রুল',
      normalHole: 'কনভেনশনাল হোল',
      normalSlot: 'কনভেনশনাল স্লট',
      holeDiam: 'হোল ডায়ামিটার',
      slotLongSide: 'স্লট লং সাইড',
      slotShortSide: 'স্লট শর্ট সাইড',
      FixedmachSurface: 'ফিক্সড মেশিনিং সারফেস',
      deleteRuleTip: 'এই রুল মুছবেন?',
      blankFront: 'বড় বোর্ডের সামনের দিক',
      blankBack: 'বড় বোর্ডের পিছনের দিক',
      addRules: 'রুল যোগ করুন',
      addRulesTip: 'একই ছোট বোর্ড একাধিক রুল মিললে সর্বপ্রথম সিরিয়ালের রুল কার্যকর হয়, যেকোনো সারি টেনে রুল অর্ডার বদলাতে পারেন',
      highGlossSetting: 'হাই-গ্লস বোর্ড সেটিংস',
      heighGlossFront: 'লেআউটের সময় ছোট বোর্ডের হাই-গ্লস ফেস বড় বোর্ডে সাজানো হয়',
      highGlossPlankNoRotate: 'হাই-গ্লস বোর্ড না ঘুরা',
      highGlossAutoRoll: 'শুধুমাত্র পিছনের হোল ও স্লট আছে এমন বড় বোর্ড অটো ফ্লিপ',
      highGlossAutoRollTip: "<span class='color-o-4'>(সক্ষম করার পর শুধুমাত্র পিছনের হোল স্লটের বড় বোর্ড লেআউটে অটো ফ্লিপ হবে, সিঙ্গেল-সাইডেড বোর্ড। কাস্টম ফাইলের নাম ডেটার সাথে ব্যবহার করুন)</span>",
      customHighGlossReverse: 'হাই-গ্লস সারফেস ফ্লিপ করে বোর্ড রাখুন',
      sideSlotPut: 'এজের কাছাকাছি স্লট প্লেস করুন',
      optimize: 'ফাংশনাল অপ্টিমাইজেশন চলছে',
      sysDefault: 'সিস্টেম ডিফল্ট',
      plankInSide: 'বড় বোর্ডের ভিতরের দিক',
      plankOutSide: 'বড় বোর্ডের বাইরের দিক',
      specialNotWork: 'এই ফিচার অ্যাবনরমাল শেপড বোর্ড পিসে প্রযোজ্য নয়',
      commonSide: 'কমন এজ কাটিং',
      commonSetting: 'কমন এজ সেটিং',
      plankThickRange: 'বোর্ড পিসের বেধ এর চেয়ে কম বা সমান',
      useCommonSide: 'কখন কমন এজ কাটিং ব্যবহার করবেন',
      zeroTip: 'লেআউট গ্যাপ হাতে ০ করতে হবে, ইতিমধ্যে কাটা এজ পর্যন্ত প্রসেস করলে টুল লিফট করে এজ স্কিপ করুন, এই ফিচার চালু হলে অবলিক ডাউন-কাটিং সাপোর্ট করা হবে না।',
      useTip: 'এই ফিচার চালু করার পর অবলিক ডাউন-কাটিং সাপোর্ট করা হবে না। নোট করুন!',
      commonSpeed: 'কমন এজ অ্যাকসেলারেশন',
      highSpeed: 'হাই-স্পিড মিলিং স্পিড',
      min: 'মিনিট',
      notWorkTip: 'বোর্ড প্রসেসিং কমন এজ কাটিং শর্ত পূরণ করলে কমন এজ অ্যাকসেলারেশন কার্যকর হবে না',
      changeStartPoint: 'ডাবল-স্টেশন স্টার্টিং পয়েন্ট সুইচিং',
      changeStartPointTip: 'ডাবল-স্টেশন স্টার্ট পয়েন্ট সুইচ চালু করার পর XY অক্ষ সোয়াপ ফাংশনের সাথে সামঞ্জস্যপূর্ণ নয়। সাবধানে ব্যবহার করুন।',
      flatOffset: 'মেশিন প্লেন অফসেট',
      xRowChange: 'X-অক্ষ কোঅর্ডিনেট রেফারেন্স সোয়াপ',
      bigplankPointChange: 'বড় বোর্ডের পিছনের রেফারেন্স কোঅর্ডিনেট সোয়াপ করুন',
      reverseXRowChange: 'X-অক্ষ কোঅর্ডিনেট সোয়াপ করুন',
      changebigplankPointTips: 'এই ফিচার চালু করার পর এটি XY অক্ষ সোয়াপ ও ডুয়াল স্টেশন স্টার্ট পয়েন্ট সুইচ ফাংশনের সাথে সামঞ্জস্যপূর্ণ নয়। সাবধানে ব্যবহার করুন।',
      reverseYRowChange: 'Y-অক্ষ কোঅর্ডিনেট সোয়াপ করুন',
      plankMirrorTip: 'কাটিং মেশিনে প্রসেস করা বোর্ড পিস মিরর করার সময় এই ফিচার ব্যবহার করুন',
      notSameSize: 'ডাবল-স্টেশন টেবিল ভিন্ন সাইজ',
      maxSize1: 'স্টেশন ১ সর্বোচ্চ সাইজ',
      notSameSizeTip: 'ডাবল-স্টেশন টেবিল ভিন্ন সাইজ চালু করার পর ডাবল-স্টেশন ফাইল মার্জ ফাংশনের সাথে সামঞ্জস্যপূর্ণ নয়। সাবধানে ব্যবহার করুন।',
      maxSize2: 'স্টেশন ২ সর্বোচ্চ সাইজ',
      autoSelectTip: 'ডাবল-স্টেশন মেশিনের দুটি টেবিলের সাইজ ভিন্ন হলে এই ফিচার ব্যবহার করলে বড় বোর্ড প্রসেসের জন্য সংশ্লিষ্ট স্টেশন অটো সিলেক্ট হবে।',
      bigFlatLimit: 'বড় স্টেশন শুধুমাত্র সেই বড় বোর্ড প্রসেস করে যা ছোট স্টেশন প্রসেস করতে পারে না:',
      surplusSetting: 'স্ক্র্যাপ সেটিংস',
      surplusPosition: 'স্ক্র্যাপ প্লেসমেন্ট পজিশন',
      cutHoleWay: 'কাটিং ও ড্রিলিং পদ্ধতি',
      knifeFlat: 'নাইফ রেফারেন্স প্লেন',
      flat: 'টেবিল সারফেস',
      plankFlat: 'লার্জ বোর্ড সারফেস',
      freeHeightZ: 'আইডলে Z হাইট',
      relativeHeight: 'বড় বোর্ডের উপরের সারফেসের সাপেক্ষে উচ্চতা',
      cutDeepZ: 'কাটিং ডেপথ Z অক্ষ',
      cutDeepH: 'থ্রু-হোল ড্রিলিং পদ্ধতি',
      setDisableDoubleSidedThroughHole: 'ডাবল-সাইডেড থ্রু হোল ড্রিলিং নিষ্ক্রিয় সেট করুন',
      addHolesToRulesDisableDoubleSided: 'নিচের নিয়মে সংশ্লিষ্ট থ্রু-হোল (সম্পূর্ণ ভেদ করা গর্ত) যোগ করার পর, দুইবার উল্টিয়ে ড্রিল থ্রু কার্যকর হবে না',
      onceThrough: 'একবারে ড্রিল থ্রু করুন',
      rollThrough: 'দুইবার উল্টিয়ে ড্রিল থ্রু করুন',
      cutDeepS: 'থ্রু-স্লট ড্রিলিং পদ্ধতি',
      plankCutDirection: 'ছোট বোর্ডের কাটিং দিক',
      clockDirSwitch: 'কাস্টম মিলিং হোল/স্লট ও ইন্টারনাল প্রোফাইল কাটিং দিক',
      millHoleSlotDir: 'মিলিং হোল/স্লট দিক',
      millInternalCurveDir: 'ইন্টারনাল প্রোফাইল কাটিং দিক',
      sDirection: 'ঘড়ির কাঁটার দিক',
      nDirection: 'ঘড়ির কাঁটার বিপরীত',
      curveReplenish: 'আর্ক শেপ বোর্ড কাটার জন্য আর্ক ইন্টারপোলেশন ইনস্ট্রাকশন',
      curveReplenishTip: 'আর্ক শেপ পিস কাটার সময় স sawটুথ দেখা দিলে এই ফাংশন ব্যবহার করুন',
      noGen: 'G17/G18/G19 প্লেন ইনস্ট্রাকশন জেনারেট করবেন না',
      arcInstruction: 'আর্ক মেশিনিং কমান্ড প্রিফিক্স',
      example: 'উদাহরণ',
      arcExample: 'G17G03 X100 Y100',
      curveCutTip: 'আর্ক কাটিং I ও J দ্বারা প্রকাশিত',
      coverRate: 'মিলিং স্লটের ওভারল্যাপ রেট:',
      roughTip: 'মিলিংয়ের সময় স্লটের ভিতরে বুর থাকলে এই ফাংশন ব্যবহার করুন',
      clearCurve: 'যে স্লট সম্পূর্ণ মিল থ্রু নয় সেগুলোর অটো রাউন্ডিং:',
      curveUseTip: 'স্লট মিলিংয়ের সময় রাউন্ডিং দরকার হলে এই ফাংশন সিলেক্ট করুন। নোট: এই ফাংশন কানেক্টরে প্রযোজ্য নয়।',
      slotCutWay: 'স্লট মিলিং টুলপাথ',
      outToIn: 'বাইরে থেকে ভিতরে মিল স্লট',
      inToOut: 'ভিতরে থেকে বাইরে মিল স্লট',
      zShapProcess: 'থ্রু গ্রুভে জিগজ্যাগ আপ-ডাউন Z শেপ মিলিং',
      zShapProcessTip: 'শুধুমাত্র সামনে-পিছনে পুল থ্রু স্লট মিলিংয়ের জন্য প্রযোজ্য, টুল পাথ ওভারল্যাপ রেট ডিফল্ট টুল রেডিয়াস',
      zSlotCuttingOverlapRate: 'Z-শেপ স্লট কাটিং ওভারল্যাপ রেট',
      zSlotCuttingOverlapRateTip: 'বর্তমান ওভারল্যাপ রেটে প্রসেসিং স্পিড কমে যেতে পারে, মেশিন চালু করার পর আবার চেষ্টা করুন।',
      slotWorkLimit: '(শুধুমাত্র স্লট মিলিংয়ের লেয়ার সংখ্যা > ১ হলে কার্যকর)',
      minKnifeChange: 'প্রসেসিং কম কাটিং ক্যানভার',
      preventBreakage: 'প্রান্ত স্লট বিভাজক ভাঙন প্রতিরোধ',
      preventBreakageTip: 'এই সেটিং কেবল নেস্টিংয়ের সময় সামনের দিকের স্লটগুলিতে প্রযোজ্য, এবং "বিশেষ স্লট ও হোলের মেশিনিং সারফেস কাস্টম সংজ্ঞা" ফাংশনের সাথে ব্যবহার করা যায়',
      preventBreakageTip1: 'স্লট প্যানেলের কিনারার খুব কাছে হলে কাটার সময় সেই স্থানের বিভাজক বার (অবশিষ্ট সংযোগ অংশ) চাপের ঘনত্বের কারণে সহজে ভেঙে যাওয়ার সমস্যা সমাধান করতে পারে',
      preventBreakageDistance: 'প্যানেল প্রান্ত থেকে দূরত্ব',
      preventBreakageLength: 'প্রান্তবর্তী অংশের দৈর্ঘ্য',
      preventBreakageSlot: 'স্লট',
      preventBreakageCutDeep: 'প্রথম কাটের গভীরতা',
      workSpeedOp: 'প্রসেসিং স্পিড অপ্টিমাইজেশন',
      obliqueCut: 'কাটার সময় অবলিক ডাউনওয়ার্ড কাটিং',
      obliqueCutTip: 'কাটিং স্পিড অপ্টিমাইজেশন',
      obliqueThickLabel: 'কাস্টম অবলিক কাটিং কার্যকর প্লেট বেধ',
      obliqueThick: 'অবলিক কাটিং স্পিড অপ্টিমাইজেশন',
      backObliqueThick: 'অবলিক কাটিং স্পিড অপ্টিমাইজেশন',
      effectiveThickness: 'কাটিং স্পিড অপ্টিমাইজেশন',
      effectiveThicknessTip: 'কাটিং স্পিড অপ্টিমাইজেশন হতে পারে না, প্রবেশ করুন!',
      effectiveThicknessDuplicateTip: 'কার্যকর পুরুত্ব ডুপ্লিকেট হতে পারে না, সংশোধন করুন',
      obliqueCutData: 'তির্যক নিম্নমুখী কাটিং দূরত্ব',
      backOblique: 'পিছনের দিক ট্রিমিংয়ের জন্য অবলিক ডাউনওয়ার্ড কাটিং',
      obliqueSpeed: 'অবলিক কাটিং স্পিড',
      obliqueSpeedTip: 'অবলিক কাটিং স্পিড',
      arcSpeed: 'কার্ভ প্রসেসিং স্পিড',
      cuttingPreDistance: 'কাটার আগে অ্যাডভান্স দূরত্ব',
      backKnife: 'কাটিং শেষের আগে ডিসেলারেশন',
      openKnifeSpeed: 'কাটিং এন্ডের জন্য স্পিড',
      retractionCompensation: 'রিট্র্যাকশন কমপেনসেশন',
      retractionCompensationTip: 'সর্বোচ্চ মান ২০',
      cutCornerSlow: 'কাটিং কর্নারে ডিসেলারেশন',
      addRow: 'সারি যোগ করুন',
      bettwenDistance: 'কর্নারের আগে ও পরের দূরত্ব',
      cuttingSpeed: 'কাটিং স্পিড',
      stepCutting: 'লেয়ার্ড কাটিং',
      splitSlot: 'স্লট দুই ধাপে কাটুন',
      splitPlank: 'ছোট বোর্ড দুইবার কাটুন',
      splitPlank2: 'ছোট বোর্ড দুইবার কাটুন',
      minSafeThick: 'বেধ এর চেয়ে বড়',
      splitPlankTip: '(অনিয়মিত বোর্ডে এই ফিচার প্রযোজ্য নয়)',
      splitPlankTip2: '(অসমর্থ: কাটিং কাটিং প্রতিফল)',
      cutPlankMethod: 'ছোট বোর্ড দুইবার কাটুন',
      cutPlankMethodTip: 'চার দিক দুইবার কাটুন',
      cutPlankMethodTip2: 'শেষ বাহু একবার কাটুন এবং দুইবার কাটুন',
      specialShapCut: 'বিশেষ শেপ দুইবার কাটুন',
      specialShapCutTip: '(সক্ষম করার পর সব অনিয়মিত বোর্ড দুইবার কাটা হবে)',
      bridgeRetention: 'ব্রিজ রিটেনশন পয়েন্ট পদ্ধতি',
      bridgeRetentionTip: '(দ্রষ্টব্য: 1. এই ফাংশনটি সাময়িকভাবে বাইরের অনিয়মিত বোর্ড সমর্থন করে না। 2. অবলিক ডাউনওয়ার্ড কাটিং সমর্থন করে না। 3. সংযোগকারী ব্রিজ তৈরির জন্য পার্টের ন্যূনতম আকার 30mm।)',
      bridgeRetentionDesc: 'বোর্ডের ভিতরে প্রচুর ফাঁকা এলাকা থাকায় কাটিং পথে পর্যাপ্ত সাপোর্ট না থাকলে বোর্ড কাঁপা বা সরে যাওয়ার সমস্যা সমাধানে সাহায্য করে।',
      bridgePunchArea: 'ছিদ্রকৃত অংশ মোট ক্ষেত্রফলের বেশি',
      bridgeSize: 'ব্রিজের আকার',
      bridgeGenMethod: 'জেনারেট পদ্ধতি',
      bridgeAddTip: 'সর্বোচ্চ ১০টি ডেটা যোগ করুন',
      bridgeCount: 'ব্রিজের সংখ্যা',
      bridgePlankLength: 'বোর্ডের দৈর্ঘ্য (L)',
      maxWH: 'দৈর্ঘ্য বা প্রস্থ এর চেয়ে কম',
      areaLimit: 'ও ক্ষেত্রফল এর চেয়ে কম',
      secondDeep: 'দ্বিতীয় কাটিং গভীরতা',
      splitPlankThickSetting: 'সাইজিং লেয়ার্ড কাটিং সেটিংস',
      saveCustomSpeedTip: 'প্রসেসিং স্পিড খালি থাকতে পারবে না',
      saveLayeredCuttingTip: 'তিন লেয়ার কাটের সমষ্টি প্লেটের বেধের সমান হতে হবে',
      saveLayeredRepeatTip: 'একই ম্যাটেরিয়ালের হাইলাইট অ্যাট্রিবিউট বেধের জন্য ভিন্ন লেয়ার ডেটা সেট না করার পরামর্শ। অতিরিক্ত ডেটা মুছুন!',
      splitPlankThick: 'ভিন্ন বোর্ড বেধের জন্য লেয়ার্ড কাটিং',
      movePlankSetting: 'অ্যান্টি-স্লিপ বোর্ড সেটিংস',
      newCutSequence: 'নতুন কাটিং অ্যালগরিদম',
      newCutSequenceText: 'ডিফল্টে বড় স্ল্যাবের কেন্দ্রে ভ্যাকুয়াম সাকশন সবচেয়ে শক্তিশালী, এই অঞ্চলের ছোট স্ল্যাব শেষে কাটা হয়',
      positionTip: 'সংশ্লিষ্ট অঞ্চলে ক্লিক করে সিলেক্ট করুন',
      suctionPosition: 'ভ্যাকুয়াম স্ট্রং সাকশন পজিশন',
      strongArea: 'স্ট্রং সাকশন এরিয়া',
      minSuctionPlank: 'সর্বনিম্ন সাকশন বোর্ড',
      safeWidth: 'প্রস্থ',
      safeHeight: 'দৈর্ঘ্য',
      safeTip: 'বোর্ড নিরাপদে ধরে রাখতে না পারলে আগে কাটা হবে',
      scattered_layout: 'ছোট বোর্ড স্ক্যাটার লেআউট',
      lastCutPointEnable: 'বড় বোর্ডে শেষ কাটা ছোট বোর্ডের কাটিং পয়েন্ট কাস্টমাইজ',
      lastCutPointEnableTip: 'সক্রিয় করলে, প্রতিটি বড় বোর্ডের শেষ কাটা ছোট বোর্ডের কাটিং পয়েন্ট সেট করা পয়েন্ট অবস্থান অনুযায়ী তৈরি হবে',
      lastCutPoint: 'কাটিং পয়েন্ট অবস্থান',
      lastCutPointTip: 'সক্রিয় করলে, প্রতিটি বড় বোর্ডের শেষ কাটা ছোট বোর্ড এই কাটিং পয়েন্ট ব্যবহার করবে',
      leftTop: 'উপরে-বাম',
      rightTop: 'উপরে-ডান',
      leftBottom: 'নিচে-বাম',
      rightBottom: 'নিচে-ডান',
      specifyTheMaterial: 'ম্যাটেরিয়াল নির্দিষ্ট করুন',
      shapeSecondCutenable: 'প্রোফাইলড প্লেটের সেকেন্ডারি কাটিং',
      addMaterial: 'ম্যাটেরিয়াল যোগ করুন',
      plankMaterial: 'প্যানেল ম্যাটেরিয়াল',
      specifyTheMaterialTip: 'সক্ষম করার পর টেবিলের ম্যাটেরিয়াল শর্ত পূরণকারী প্যানেলেই সেকেন্ডারি কাটিং কার্যকর হবে',
      dispersePaibanTipOne: 'সক্ষম করার পর প্রতিটি বড় বোর্ডে সর্বনিম্ন সাকশন সাইজ পূরণকারী অন্তত একটি প্যানেল সাজানো হবে',
      dispersePaibanTipTwo: 'নোট: ব্যবহারের পর বড় বোর্ডের পরিমাণ বাড়তে পারে',
      totalThickLimit: 'তিন লেয়ার কাটের সমষ্টি বোর্ড পিসের বেধের সমান হতে হবে',
      offsetFollowStep: 'ট্রিমিংও লেয়ার্ড কাটিং অনুসরণ করে',
      longPlankTip1: '১. এই ফিচার চালু/বন্ধ করার পর ইতিহাসে সংরক্ষিত লেআউট রেকর্ড NC ডাউনলোডের সময় পুনরায় লেআউট করা প্রয়োজন।',
      longPlankTip2: '২. এই ফিচার সক্ষম করার পর [কাটিং মেশিন ডকিং - ভ্যাকুয়াম পাম্প পজ]-এ ভ্যাকুয়াম পাম্প পজ কোড সেট করতে হবে, নাহলে লং বোর্ড কাটার বেন্ড সমস্যা সমাধান হবে না।',
      longPlankTip3: '৩. নিচে সক্রিয় ফিল্টার শর্তগুলো স্তর অনুযায়ী যাচাই হয়; কেবল যেসব বোর্ড পূর্ববর্তী স্তরের ফিল্টার শর্ত পূরণ করে, সেগুলোই পরবর্তী স্তরের ফিল্টার শর্তে প্রবেশ করে মূল্যায়ন করা যায়।',
      secondCutting: 'সেকেন্ডারি কাটিং অবজেক্ট',
      normalPlank: 'নিয়মিত বোর্ড',
      normalPlankTip: 'নিয়মিত বোর্ড: ক্যাবিনেট বডিতে ক্রস ও ভার্টিক্যাল পার্টিশন ইত্যাদি নন-ক্যাবিনেট দরজা বোর্ড এবং কাটিং লিস্টে সরাসরি যোগ করা বোর্ড',
      designatedTarget: 'নির্দিষ্ট অবজেক্ট',
      filterLevel1Label: 'প্রথম স্তর ফিল্টার',
      filterLevel1Category: 'বোর্ড ধরন',
      filterLevel2Label: 'দ্বিতীয় স্তর ফিল্টার',
      filterLevel2Category: 'আকার সীমা',
      filterLevel3Label: 'তৃতীয় স্তর ফিল্টার',
      filterLevel3Category: 'অন্যান্য',
      specifiedBoardForceEnable: 'আকার/অন্যান্য ফিল্টার উপেক্ষা করে জোর করে চালু',
      curveMaterialFilterTip: '("অসম প্যানেল" চেক করার পর উপাদান ফিল্টারের আগে অসম প্যানেল হতে হবে)',
      cuttingSettings: 'কাটিং সেটিং',
      plankSizeLimitSuffix: ' বোর্ড',
      specifiedBoard: 'বোর্ড নাম কাটিং নির্দিষ্ট করুন',
      specifiedBoardTip: 'চালু করার পর বোর্ড নামে নিচে যোগ করা বোর্ড নাম থাকলে সেকেন্ডারি কাটিং কার্যকর হবে',
      addPlankName: 'বোর্ড নাম যোগ করুন',
      plankNameEmpty: 'বোর্ড নাম খালি থাকতে পারবে না, লিখুন',
      plankNameRequired: 'অন্তত একটি বোর্ড নাম যোগ করুন',
      plankLongLimit: 'লং সাইড অতিক্রম করলে',
      plankShortLimit: 'শর্ট সাইড অতিক্রম করলে',
      cuttingSplit: 'দুই ধাপে কাটুন',
      longExpand: 'প্রথম কাটিং অ্যালাওয়্যান্স: লং সাইড অ্যালাওয়্যান্স',
      firstExpand: 'প্রথম কাটিং অ্যালাওয়্যান্স',
      longExpandTip: 'লং এজ অ্যালাওয়্যান্স',
      longLimit: 'লং এজ অতিক্রম করলে',
      cuttingSplitTip: 'লং বোর্ড দুই পাসে কাটার শর্ত',
      shortExpand: 'শর্ট সাইড অ্যালাওয়্যান্স',
      expandTip: 'লং/শর্ট সাইড ডাইমেনশন প্রতিটি x mm বাড়ান। অনিয়মিত লং বোর্ডের জন্য উভয় পাশে লং সাইড অ্যালাওয়্যান্স প্রযোজ্য।',
      pumpOffWay: 'ভ্যাকুয়াম শাটডাউন পদ্ধতি',
      afterOnePlank: 'একটি লং বোর্ড কাটার পর',
      afterAllPlank: 'সম্পূর্ণ বড় বোর্ড কাটার পর',
      numberFixed: 'দশমিক স্থান সংরক্ষণের সংখ্যা',
      bufferCode: 'কাট শুরুতে বোর্ড সারফেসের বাফার কমান্ড',
      layoutGap: 'লেআউট গ্যাপ সেটিং',
      layoutGapTip: 'নোট: লেআউট গ্যাপ ০ সেট করলে লেআউট ওভারল্যাপ হতে পারে',
      wasteCutting: 'অটোমেটিক waste ট্রাঙ্কেশন',
      zkPointCustomize: 'Z-নকল স্ল্যান্ট হোল মেশিনিং রোটেশন রেফারেন্স পয়েন্ট কাস্টমাইজেশন',
      sawSetting: 'স saw কাটিং সেটিংস',
      cuttingLimit: 'ট্রাঙ্কেট সাইজ এর চেয়ে বড়',
      waste: 'বর্জ্য',
      wasteSizeLimit: 'সর্বনিম্ন সাইজ ১০০mm এর চেয়ে কম হতে পারবে না',
      topLeft: 'বাম ও উপরের দিক',
      topLeftD: 'বাম উপরের কোণ',
      bottomLeft: 'বাম ও নিচের দিক',
      bottomLeftD: 'বাম নিচের কোণ',
      topRight: 'ডান ও উপরের দিক',
      topRightD: 'ডান উপরের কোণ',
      bottomRight: 'ডান ও নিচের দিক',
      bottomRightD: 'ডান নিচের কোণ',
      firstTime: 'প্রথমবার',
      secondTime: 'দ্বিতীয়বার',
      thirdTime: 'তৃতীয়বার',
      startCutting: 'কাটিং স্টার্টেড',
      thickRange: 'বেধ ≥',
      longCut: 'লং বোর্ড প্রসেসিং',
      edgeSetting: 'এজ ট্রিমিং সেটিংস',
      cuttingOrder: 'কাটিং অর্ডার:',
      cuttingOrderTip: 'এই পদ্ধতিতে বোর্ড রান করার ঝুঁকি আছে, সাবধানে ব্যবহার করুন',
      plankFirst: 'ছোট বোর্ড আগে কাটুন',
      wasteFirst: 'বর্জ্য আগে কাটুন',
      offTip: 'বন্ধ থাকলে কাটিং প্যারামিটারের ট্রিমিং সেটিং অনুসরণ করবে',
      edgeCutDirection: 'ট্রিমিং দিক',
      lGapTip: 'L-আকৃতির সারপ্লাস বড় প্লেটের গ্যাপ প্লেসমেন্ট পজিশন পজিশনিং সিলিন্ডারের তির্যক দিকে অটো অ্যাডজাস্ট, হাই গ্লস সারপ্লাস বড় প্লেট ছাড়া, xy অক্ষ ইন্টারচেঞ্জ ফাংশনের সাথে সামঞ্জস্যপূর্ণ নয়',
      cylinderDir: 'পজিশনিং সিলিন্ডার দিক',
      onlyLong: 'শুধুমাত্র লং এজ ট্রিম করুন',
      backCutOrder: 'পিছনের দিক ট্রিমিং অর্ডার',
      backFirst: 'পিছনের দিক আগে ট্রিম করুন',
      backSecond: 'হোল ও স্লট প্রসেসিংয়ের পর পিছনের দিক ট্রিম করুন',
      frontReCut: 'ফ্রন্ট সাইড আবার ট্রিম করুন',
      frontReCutTip: 'পজিশনিং সিলিন্ডার এজ মসৃণ করতে ও দাগ এড়াতে',
      useNewCut: 'নতুন ট্রিমিং রুল সক্ষম করুন',
      newCutTip: 'ডাবল-সাইডেড প্রসেসিং বড় প্যানেলের সামনের দিকে একটি অতিরিক্ত ট্রিমিং ডাইমেনশন দরকার হলে এই ফাংশন ব্যবহার করুন',
      fixedTip: 'নোট: দশমিক স্থান ০ বা ১ রাখলে লেআউটে ওভারল্যাপ হতে পারে',
      cuttingSlow: 'কাটিং পাতার পৃষ্ঠতল ভোলাম',
      holeSlow: 'পাতার পৃষ্ঠতল ভোলাম',
      slotSlow: 'কাটিং ও ড্রিলিং পদ্ধতি',
      slowCode: 'ঐচ্ছিক কমান্ড ব্যবহার',
      code: 'কমান্ড',
      bufferOffset: 'পাতার পৃষ্ঠতল ভোলাম উচ্চতা অফসেট',
      zkRotatePoint: 'ঘূর্ণন রেফারেন্স বিন্দু',
      zkRotateDir: 'ঘূর্ণন কোণ বৃদ্ধি দিক',
      restSizeLimit: 'অবশিষ্ট আকারের চেয়ে কম',
      useSaw: 'করাত ব্লেড ব্যবহার করুন',
      unGenSawPath: 'অনুদৈর্ঘ্য করাত ব্লেড কাটিং পথ তৈরি করবেন না',
      suitMachine: 'সম্পূর্ণ অ্যালুমিনিয়াম ওয়েল্ডিং প্লেট প্রক্রিয়াকরণের জন্য উপযুক্ত',
      plankBack: 'বড় তক্তার পিছনের দিক',
      plankLeft: 'বড় তক্তার বাম দিক',
      plankRight: 'বড় তক্তার ডান দিক',
      plankFront: 'বড় তক্তার সামনের দিক',
      frontSide: 'সামনের দিক',
      backSide: 'পিছনের দিক',
      rightSide: 'ডান দিক',
      leftSide: 'বাম দিক',
      singleMachineLimit: 'একপাক্ষিক প্রক্রিয়াকৃত প্যানেলের সামনে প্রান্ত ট্রিমিং পথ তৈরি করুন এবং প্রথমে প্রান্ত ট্রিম করুন',
      singleMachineLimitTip: 'একীভূত মেশিন বা করাত ব্লেড কাটিংয়ের জন্য এই ফাংশন প্রযোজ্য নয়',
      setBatchPositionWaring: 'পরামর্শ: কাটিং পয়েন্ট মোডের দ্রুত পরিবর্তন বাতিল করতে ডান দিকের মোডিফাই কাটিং পয়েন্ট বাটন আনচেক করুন',
      setBatchPosition: 'কাটিং পয়েন্ট ব্যাচ পরিবর্তন করুন',
      setBatchPositionAs: 'কাটিং দিক পরিবর্তন করুন:',
      activeBatchPosition: '{activePartCount}টি ছোট বোর্ড নির্বাচন করা হয়েছে',
      specialFrontSide: 'স্লট ডাইভার্শনে সেট করা বিশেষ স্লটগুলি বড় প্যানেলের সামনের দিকে অগ্রাধিকার পায়',
      rollCountTip: 'খোদাই মেশিন দ্বারা প্রকৃত প্রক্রিয়াকরণের উপর ভিত্তি করে ফ্লিপ বোর্ড গণনা করুন',
      specialFrontSideTip: 'স্লট ডাইভার্শনে বড় বোর্ডের সামনের দিকে বিশেষ স্লট অগ্রাধিকার বা স্লট ডাইভার্শন সক্ষম করার পর খোদাই মেশিনে প্রকৃত পিছনের স্লট প্রক্রিয়াকরণের উপর ভিত্তি করে ফ্লিপ কাউন্ট গণনা করার ফাংশন সক্ষম করার কারণে বর্তমান উৎপাদন লাইন স্যুইচিং সমর্থন করে না',
      doubleTrim: 'দ্বিপাক্ষিক প্যানেল ট্রিমিং',
      trim: 'ট্রিমিং',
      trimTwoSide: 'উভয় পাশ মেরামত করুন',
      trimFourSide: 'চার দিক ঠিক করুন',
      rightInmShow: 'ডানদিকের চিত্রে দেখানো হয়েছে',
      currentTrimDir: 'বর্তমানে নির্বাচিত ট্রিমিং দিকের জন্য',
      cylinderTip: 'সিলিন্ডার অবস্থান নির্ধারণ করতে',
      onlyShort: 'শুধুমাত্র ছোট প্রান্ত মেরামত করুন',
      singleTrim: 'একক প্যানেল ট্রিমিং পথ তৈরি',
      hierarchyCutTwice: 'স্তরযুক্ত সূচীকরণ সহ স্লট মিলিং এবং স্লট কাটিং',
      knifeDia: 'ছুরির ব্যাস এর চেয়ে কম বা সমান',
      slotDeep: 'এবং স্লট গভীরতা এর চেয়ে বড় বা সমান',
      cutTwiceSlot: 'স্লটের স্তরযুক্ত কাটিং করার সময়',
      twiceSlotDeep: 'দ্বিতীয় স্তরের কাটিং গভীরতা',
      cutTwiceCondition: 'কাটিং শর্ত',
      zkPointCustomizeTip: 'XY অক্ষ সোয়াপ সক্রিয় করলে প্রক্রিয়াকরণের দিক এবং রেফারেন্স পয়েন্ট বিপরীত হবে',
      zkPointCustomizeTip1: 'XY অক্ষ ইন্টারচেঞ্জ সক্ষম ডিভাইসগুলির জন্য এই ফাংশন কাজ করে না',
      isCustom: 'কাস্টমাইজেশন সক্ষম করুন',
      useCutCon: 'করাত কাটার শর্ত ব্যবহার করা',
      singleSetPlankSizeSpeed: 'নির্দিষ্ট তক্তার আকারের জন্য প্রক্রিয়াকরণ গতি সেট করুন',
      singleSetPlankSizeSpeedTip: '(1. ছোট তক্তা নিচের আকার সেটিংস পূরণ করলে নির্দিষ্ট গতিতে প্রক্রিয়া করা হবে। 2. একসাথে একাধিক নিয়ম পূরণ করলে আগের সিকোয়েন্স নম্বরের নিয়ম কার্যকর। 3. করাত ব্লেড কাটিংয়ের জন্য এই ফিচার প্রযোজ্য নয়।)',
      addSpeedRules: 'নিয়ম যোগ করুন',
      speedRules: 'নিয়ম',
      shortSideSize: 'সংক্ষিপ্ত পাশের আকার',
      lessThanEqual: 'এর চেয়ে কম বা সমান',
      and: 'এবং',
      longSideSize: 'দীর্ঘ পাশের আকার',
      processingSpeed: 'প্রক্রিয়াকরণ গতি',
      trimLenCompensation: 'ট্রিমিং দৈর্ঘ্য ক্ষতিপূরণ:',
      trimGenerateAPath: 'ট্রিমিং মান 0 পথ তৈরি করে না:',
      cuttingMethod: 'কাটিং পদ্ধতি',
      horizontalCutting: 'অনুভূমিক কাটিং',
      verticalCutting: 'উল্লম্ব কাটিং',
      openKnifeDistance: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন'
      },
    labelingSettings: {
      title: 'লেবেল সেটিংস',
      output: 'স্বয়ংক্রিয় লেবেলিং ফাইল আউটপুট',
      specification: 'লেবেল ফাইল ফরম্যাট',
      codeFrontGenerate: 'লেবেলিং কোডের আগে স্বয়ংক্রিয়ভাবে ফিডিং কোড তৈরি করুন',
      templateOffline: 'ব্যবহৃত টেমপ্লেট অফলাইন!',
      rollLabelling: 'ফ্লিপ লেবেলিং সেটিংস',
      flipSetting: {
        title: 'ফ্লিপ সেটিংস',
        engravingFlipProcess: 'খোদাই মেশিন ফ্লিপ প্রক্রিয়াকরণ লেবেলিং মোড সক্ষম করুন',
        flipTip: 'খোদাই মেশিনের প্রক্রিয়াকরণের জন্য ফ্লিপ প্রয়োজন হলে এই ফাংশন সক্ষম করুন'
        },
      rotateSetting: {
        title: 'লেবেল রোটেশন সেটিংস',
        rotateTip: 'চাহিদা অনুযায়ী রোটেশন শর্ত চালু করুন; একসাথে চালু করলে নির্বাচিত সেট মান অগ্রাধিকার পায়',
        horizontal: 'বোর্ডের প্রস্থ',
        vertical: 'বোর্ডের উচ্চতা',
        either: 'বোর্ড প্রস্থ অথবা উচ্চতা'
        },
      countertopSetting: {
        title: 'ওয়ার্কবেঞ্চ সেটিংস',
        startPoint: 'ওয়ার্কস্টেশন স্টার্টিং পয়েন্ট:',
        upLeft: 'বাম উপরে',
        upRight: 'ডান উপরে',
        downLeft: 'বাম নিচে',
        downRight: 'ডান নিচে',
        baseExchange: 'কোঅর্ডিনেট বেস এক্সচেঞ্জ:',
        exchangeX: 'X-অক্ষ এক্সচেঞ্জ',
        exchangeY: 'Y-অক্ষ এক্সচেঞ্জ'
        },
      offset: 'লেবেল কোঅর্ডিনেট অফসেট',
      offsetTip: 'সাধারণত লেবেলিং কোঅর্ডিনেট ছোট বোর্ডের কেন্দ্রে থাকে, কিছু ডিভাইসে সামঞ্জস্য প্রয়োজন',
      label_rotate_offset: 'রোটেশনের পর লেবেল অফসেট',
      label_rotate_offset_tip: 'লেবেল রোটেশনের আগে ও পরে অফসেট পজিশন যথেষ্ট ভিন্ন হলে অ্যাডজাস্ট করুন',
      label_rotate_offset_err_tip: 'লেবেল রোটেশন কোঅর্ডিনেট অফসেট চালু করার পর X এবং Y অক্ষ কোঅর্ডিনেট অফসেট আবশ্যক',
      imgSetting: {
        title: 'লেবেল ইমেজ সেটিংস',
        suffix: 'লেবেল ইমেজ সাফিক্স:',
        code: 'ইমেজ কোডিং পদ্ধতি:',
        codeTip: 'PNG, JPEG লেআউট ইমেজের কোডিং ফরম্যাট একসাথে পরিবর্তন করবে এবং এমবেডেড ক্লাউড লেআউট এই ফিচার সাপোর্ট করে না',
        imgRatio: 'লেবেল ইমেজ রেজোলিউশন:',
        slowDown: 'লেবেল ইমেজ এক্সপোর্টের দক্ষতা কমিয়ে দেবে',
        color: 'ট্রু কালার',
        bit: 'কালো এবং সাদা',
        resolution: 'লেবেল ইমেজ রেজোলিউশন',
        resolutionPlaceholder: 'রেজোলিউশন',
        labelPool: 'ডেটা লেবেল পুল',
        showKey: 'ডিসপ্লে ফিল্ড',
        dragTip: 'লেবেল পুলের মধ্যে লেবেল ড্র্যাগ এবং ড্রপ করতে পারেন',
        labelImgName: 'লেবেল ইমেজ নাম',
        labelImgNameErrTip: 'লেবেল ইমেজের নাম খালি থাকতে পারবে না',
        labelTip1: 'কাস্টমাইজ করার সময় [বোর্ড বারকোড] বা [লেবেল সিকোয়েন্স নম্বর] যেকোনো একটি ব্যবহার করতে হবে, নাহলে ইমেজ ওভারলে সমস্যা হতে পারে',
        labelTip3: '【লেবেল সিকোয়েন্স নম্বর】 হল কাটিয়ার তালিকার উপর থেকে নীচে একটি কাটিয়ার সিকোয়েন্স নম্বর, এবং লেবেলিং পেজে যোগ করা কাটিয়ার কোনো এই ডাটা নেই',
        labelTip2: '3. লেবেলিং মেশিন সিস্টেম টেমপ্লেটে এই ফিচার প্রযোজ্য নয়',
        delimiter: 'ডিলিমিটার:',
        inputTip: '/ : ? < > | . ” * ইত্যাদি অক্ষর ইনপুট সাপোর্ট করে না',
        numStart: 'লেবেল সিকোয়েন্স নম্বরের জন্য স্টার্টিং মান',
        example: 'কাস্টম লেবেল ইমেজ নাম (উদাহরণ)',
        stockNumOffset: 'বড় বোর্ড সিরিয়াল নম্বরের ক্ষতিপূরণ অঙ্ক পর্যন্ত',
        divideFolders: 'বড় বোর্ডের উপর ভিত্তি করে লেবেল ইমেজ বিভিন্ন ফোল্ডারে ভাগ করুন',
        foldersTip1: 'নোট: 1. এই ফিচারটি ম্যাটেরিয়াল কাটিং মেশিন ফাইল মার্জ ফিচারের সাথে একসাথে ব্যবহার করা যাবে না',
        foldersTip2: '2. এমবেডেড ক্লাউড লেআউটের জন্য এই ফিচার এখনও কার্যকর নয়',
        stickIntoFolders: 'লেবেলিং ফাইলগুলি সংশ্লিষ্ট বড় বোর্ডের লেবেল ইমেজ ফোল্ডারে সন্নিবেশ করুন:',
        stickTip1: 'নোট: 1. এই ফিচারটি NC ডাউনলোডের সাথে লেবেল এক্সপোর্ট ফিচারের সাথে একত্রে ব্যবহার করতে হবে',
        stickTip2: '2. ব্যবহৃত লেবেলিং টেমপ্লেটে ফাইল জেনারেশন রুলে "সিঙ্গেল ফাইল জেনারেট করুন" সিলেক্ট করলে এই ফিচার কার্যকর হবে',
        stickTip3: '3. এমবেডেড ক্লাউড লেআউটের জন্য এই ফিচার এখনও কার্যকর নয়'
        },
      pdfSetting: {
        title: 'লেবেল PDF সেটিংস',
        pdfLabelName: 'PDF ফাইল নাম',
        example: 'কাস্টম PDF ফাইল নাম (উদাহরণ)',
        address: 'প্রকল্প ঠিকানা',
        orderNo: 'ক্রমবাক্য নং',
        firstFolder: 'প্রথম স্তর ফোল্ডার',
        customerName: 'গ্রাহক নাম'
        },
      paibanImgSetting: {
        title: 'লেআউট ইমেজ সেটিংস',
        tip: 'কাস্টম লেআউট ডায়াগ্রাম এক্সপোর্ট চালু করা হয়েছে। নিচের ফিক্সড টেমপ্লেট এক্সপোর্ট করা যাবে না। এক্সপোর্ট করতে লেআউট পেজের আরো সেটিংসে কাস্টম লেআউট ডায়াগ্রাম এক্সপোর্ট বন্ধ করুন',
        reparation: 'লেআউট ইমেজ সিকোয়েন্সের স্বয়ংক্রিয় ক্ষতিপূরণ',
        figure: 'অবস্থান',
        inputTip: '১-৯৯ এর মধ্যে একটি সংখ্যা লিখুন',
        paibanImg: {
          export: 'লেআউট ইমেজ এক্সপোর্ট করুন',
          prefix: 'লেআউট ইমেজ নাম প্রিফিক্স',
          size: 'লেআউট ইমেজ সাইজ',
          format: 'লেআউট ইমেজ ফরম্যাট',
          directional: 'লেআউট দিক',
          vertical: 'উল্লম্ব',
          horizontal: 'অনুভূমিক'
          }
        },
      autolabel: 'স্বয়ংক্রিয় লেবেলিং অর্ডার সেটিং',
      customTemp: 'শুধুমাত্র কাস্টম টেমপ্লেটের জন্য কার্যকর',
      cuttingLabelOder: 'কাটিং অর্ডার অনুযায়ী লেবেলিং',
      labelToUp: 'লেআউটের উপর ভিত্তি করে নিচ থেকে উপরে লেবেলিং',
      labelToDown: 'লেআউটের উপর ভিত্তি করে উপরে থেকে নিচে লেবেলিং',
      labelDodge: 'স্বয়ংক্রিয় লেবেল এভয়েডেন্স',
      nolabelForsurplus: 'অবশিষ্ট ম্যাটেরিয়াল প্লেটের জন্য লেবেলিং ফাইল তৈরি হয় না',
      settingValue: 'সেটিং মান নির্বাচন করুন',
      enabelTip: 'সক্ষম করলে ছোট বোর্ড নিচের সেটিং মান পূরণ করলে লেবেল ঘুরবে',
      fixedHori: 'লেবেলের অনুভূমিক প্রান্ত ছোট বোর্ডের ফিক্সড প্রান্তের সমান্তরাল নির্বাচন করুন',
      fixedHoriTip: 'শুধুমাত্র টেক্সচারবিহীন ছোট বোর্ডের জন্য। সক্ষম করলে লেবেলিংয়ের সময় লেবেলের অনুভূমিক প্রান্ত ছোট বোর্ডের ফিক্সড প্রান্তের সাথে সারিবদ্ধভাবে ঘুরবে',
      tagHori: 'লেবেল অনুভূমিক প্রান্ত',
      effectiveTarget: 'কার্যকারিতার লক্ষ্য',
      allPlank: 'সমস্ত তক্তা',
      notcarePlank: 'শুধুমাত্র টেক্সচারবিহীন তক্তা'
      },
    drillSettings: {
      title: 'ড্রিলিং মেশিন সেটিংস',
      enable: 'ড্রিলিং প্যাকেজ সক্ষম করুন',
      toolTable: {
        use: 'সক্ষম করুন',
        number2: 'স্টেশন ২ ড্রিল নম্বর',
        number: 'ড্রিলিং মেশিন নম্বর',
        diameter: 'ড্রিল বিট ব্যাস',
        xOffset: 'X অফসেট',
        yOffset: 'Y অফসেট',
        moveZF: 'Z-অক্ষ র্যাপিড মুভ স্পিড',
        feedRate: 'Z-অক্ষ মেশিনিং স্পিড',
        moveF: 'XY-অক্ষ র্যাপিড মুভ স্পিড',
        benchmarkDrill: 'বেঞ্চমার্ক ড্রিল',
        addKnife: 'টুল যোগ করুন',
        deleteKnife: 'টুল মুছুন'
        },
      prefix: 'ড্রিলিং মেশিন প্রিফিক্স',
      suffix: 'ড্রিলিং মেশিন সাফিক্স',
      startCode: 'ড্রিলিং মেশিন স্টার্ট কোড',
      endCode: 'ড্রিলিং মেশিন এন্ড কোড',
      combineKnife: 'কম্বাইন্ড ড্রিলিং মেশিন কাট',
      combineTable: {
        prefix: 'ড্রিলিং মেশিন নম্বর প্রিফিক্স',
        suffix: 'ড্রিলিং মেশিন নম্বর সাফিক্স',
        mainHole: 'মেইন হোল',
        extraHole: 'এক্সট্রা হোল',
        notes: 'কম্বাইন্ড নোট',
        firstUseNotes: 'প্রথম ব্যবহার নোট',
        addExtraHole: 'এক্সট্রা হোল যোগ করুন',
        deleteExtraHole: 'এক্সট্রা হোল মুছুন',
        example: 'উদাহরণ'
        },
      tagPool: {
        drillRowNumber: 'ড্রিল সারি নম্বর'
        },
      processSetting: {
        title: 'প্রক্রিয়াকরণ সেটিংস',
        mode: 'ড্রিলিং মেশিন প্রক্রিয়াকরণ মোড',
        processTip: 'এই মোড সিলেক্ট করলে এই ফিচার কার্যকর হবে না',
        recentHole: 'কাছের গর্ত ড্রিল করুন (দ্রুত টুল পরিবর্তন)',
        groupHole: 'ক্যাটাগরি অনুযায়ী ড্রিল করুন (এক ক্যাটাগরি সম্পূর্ণ করার পর টুল পরিবর্তন)',
        drill_benchmark: 'টুল সেটিং বেঞ্চমার্কের সংমিশ্রণ',
        drill_benchmark_Tip: '（মন দিন：এই পদ্ধতি সিলেক্ট করার পর ড্রিল কম্বিনেশন টুল সেটিং ফাংশন কার্যকর হবে না）',
        mainHole: 'মেইন হোল',
        secondaryHole: 'সেকেন্ডারি হোল (টেইল হোল)'
        },
      changeBenchDrillTip: 'এই সিলেকশন করার আগে ড্রিলিং মেশিন নম্বর লিখুন'
      },
    NCExportSettings: {
      jumpSkipTip2: 'বড় বোর্ড রঙ, বেধ ও ম্যাটেরিয়াল অনুযায়ী বিভিন্ন ফোল্ডারে ভাগ করুন (লেবেলিং ফাইল সহ), একই সাইজের বড় বোর্ডের কাটিং ম্যাটেরিয়াল ফাইল একই ফোল্ডারে রাখুন',
      title: 'NC এক্সপোর্ট সেটিংস',
      tab1: 'নেস্টিং মেশিন ফাইল নাম সেটিংস',
      tab2: 'নেস্টিং মেশিন ফাইল নাম মার্জিং',
      tab3: 'নেস্টিং মেশিন ফাইল কমেন্ট',
      tab4: 'নেস্টিং মেশিন ফাইল টাইপ',
      tab5: 'নেস্টিং মেশিন ফাইল ফোল্ডার',
      tab6: 'প্রক্রিয়াকরণ নির্দেশনা সেটিংস',
      tab7: 'ফাইল ফরম্যাট সেটিংস',
      fileNameSettings: {
        twoStationAutoSort: 'দ্বৈত স্টেশনের জন্য স্বয়ংক্রিয় সর্টিং',
        reparation: 'প্যানেল সিরিয়াল নম্বরের অঙ্ক সংখ্যা ক্ষতিপূরণ',
        figure: 'অবস্থান',
        labelerBegin: 'লেবেল মেশিন প্রিফিক্স',
        machineCenter: 'মেশিনিং সেন্টার প্রিফিক্স',
        front: 'সামনের দিক:',
        back: 'পিছনের দিক:',
        customizeName: 'কাস্টম ফাইল নাম (ফরম্যাট):',
        example: 'কাস্টম ফাইল নাম (উদাহরণ):',
        emptyTip: 'সামনে ও পিছনের ফাইল আইডেন্টিফায়ার একসাথে খালি থাকতে পারবে না',
        labelPool: 'ডেটা লেবেল পুল',
        dragTip: 'ট্যাগ পুলের ট্যাগগুলি ড্র্যাগ বা ক্লিক করে ইনপুট বক্সে কপি করতে পারেন'
        },
      fileMerge: {
        engravingMerge: 'নেস্টিং মেশিন ফাইল মার্জিং',
        zfMerge: 'সামনে ও পিছনের দিক মার্জিং',
        singleMerge: 'সিঙ্গেল স্টেশন মার্জিং',
        doubleMerge: 'ডুয়াল স্টেশন মার্জিং',
        fEndCode: 'পিছনের দিক এন্ড কোড',
        zBeginCode: 'সামনের দিক স্টার্ট কোড',
        displayfbInfo: 'ফাইল নামে সামনে ও পিছনের দিকের তথ্য প্রদর্শন করুন',
        fBeginCode: 'পিছনের দিক স্টার্ট কোড',
        zEndCode: 'সামনের দিক এন্ড কোড'
        },
      marginalNotes: {
        addPlankInfo: 'কাটিং ফাইলের শুরুতে বর্তমান বড় বোর্ডের অংশের তথ্য যোগ করুন:',
        plankInfo: 'বড় বোর্ডের তথ্য:',
        addStationCodeFirst: 'নেস্টিং ফাইলের শুরুতে স্টেশন কোড যোগ করুন:',
        addStationCodeSecond: 'কাটিং ফাইলে টুল বদলানোর আগে ওয়ার্কস্টেশন কোড যোগ করুন:'
        },
      fileType: {
        zAddtion: 'Z স্থানাঙ্কের পরিপূরক:',
        addSemicolon: 'প্রতিটি NC লাইনের শেষে সেমিকোলন যোগ করুন:',
        semicolonTip: 'এই বক্স চেক করলে শিং হ্যান্ডেলের প্রক্রিয়াকরণ ফাইলেও প্রভাব পড়বে',
        fileName: 'ফাইল নাম',
        defaultName: 'ডিফল্ট ফাইল নাম',
        dedicatedName: 'জিংহুই সরঞ্জামের জন্য ডেডিকেটেড ফাইল নাম',
        xhNotes: 'জিংহুই E2-9 নোট',
        format: 'আউটপুট খোদাই মেশিনের ফাইল ফরম্যাট',
        example: 'ফাইলের নমুনা: NC ফাইল',
        stillGenerate: 'পিছনের দিক প্রক্রিয়া না করলেও পিছনের এন্ড কোডযুক্ত পিছনের NC ফাইল তৈরি করুন',
        generateTip: 'এই ফিচারটি ফাইল মার্জ (merge) ফাংশনের সাথে একসাথে ব্যবহার করা যাবে না',
        fileNameErrTip: 'ফাইলের নামের মধ্যে নিম্নলিখিত কোনো অক্ষর থাকতে পারবে না: / : * ? "'
        },
      categorize: 'বড় বোর্ডের রং, উপাদান এবং পুরুত্ব অনুযায়ী বিভিন্ন ফোল্ডারে ভাগ করুন (লেবেল করা ফাইলগুলো একসাথে):',
      simplifyG: 'প্রসেসিং G-কমান্ডের সংক্ষিপ্ত রূপ',
      ZToW: 'Z-অক্ষ থেকে W-অক্ষে কোড পরিবর্তন করুন',
      knives: 'সারি-ড্রিলের টুল',
      lineBreakSetting: 'লাইন ব্রেক ফরম্যাট সেটিংস',
      codeFormatSetting: 'ফাইল এনকোডিং ফরম্যাট সেটিংস',
      utf8bom: 'BOM সহ UTF-8',
      oneCodeSetting: 'প্যানেল বারকোড সেটিংস',
      simplifyOneCode: 'সরলীকৃত ফরম্যাট লেবেল বারকোড তৈরি করুন',
      codeLocation: 'কোড লোকেশন সেটিংস',
      generateLocation: 'পিছনের দিকের এন্ড কোডের আগে স্টেশন এন্ড কোড তৈরি করুন',
      emergencySetting: 'ইমারজেন্সি সেটিংস',
      show: 'ইমারজেন্সি সেটিংস দেখান',
      emergencyCode: 'ইমারজেন্সি কোড',
      params: 'প্যারামিটার',
      emergencyTip: 'আফটার-সেলস কর্মীদের সহযোগিতায় কিছু নিচ ফিচার সাময়িকভাবে বাস্তবায়ন করা যেতে পারে',
      holeSetting: 'হোল পাঞ্চিং ফাইল সেটিংস',
      holeFileCategorize: 'বিভিন্ন অর্ডার অনুযায়ী হোল পাঞ্চিং ফাইল আলাদা ফোল্ডারে রাখা হয়',
      holeTip: 'এমবেডেড ক্যাবিনেট ক্লায়েন্টের ক্লাউড টাইপসেটিংয়ে প্রযোজ্য নয়',
      specialCodeErr: 'বিশেষ অক্ষর সাপোর্ট করা হয় না!',
      copySuccess: 'কপি সফল!',
      copyErr: 'কপি ব্যর্থ, ট্যাগ ড্র্যাগ করে দেখুন!',
      lengthLimit: 'শুধুমাত্র ১৫টি অক্ষর ইনপুট সাপোর্ট!',
      plankInfo: 'বোর্ড তথ্য',
      otherInfo: 'অন্যান্য তথ্য',
      uniqueBarCode: 'প্লেটের জন্য ইউনিক বারকোড',
      uniqueBarCodeForPack: 'প্লেটের ইউনিক বারকোড (শুধুমাত্র প্যাকেজিংয়ের জন্য)',
      machineOrder: 'কাটিং ফাইল নাম থেকে প্রক্রিয়াকরণ সিকোয়েন্স নম্বর তৈরি করুন',
      folderSetting: 'একই সাইজের বোর্ডের কাটিং ফাইল একই ফোল্ডারে রাখুন',
      labelImageINCFolder: 'লেবেলযুক্ত ইমেজ ও লেবেল ফাইল NC ফোল্ডারে রাখুন',
      custom: 'কাস্টম',
      folderSettingTip: 'নোট: এমবেডেড লেআউট এখনও এই ফিচার সাপোর্ট করে না',
      settingMoveTip: 'আসল "{func}" ফাংশন "{module}" পেজে সরানো হয়েছে!',
      fileManagerFunction: 'বিভিন্ন অর্ডার অনুযায়ী ড্রিলিং ফাইল আলাদা ফোল্ডারে রাখুন',
      gotoSetting: 'সেটিংসে যান',
      singleFileTitle: 'সিঙ্গেল ফাইল প্রক্রিয়াকরণ সেটিংস',
      slectSingleProcess: 'একক আউটপুট প্রক্রিয়া নির্বাচন করুন',
      slectSingleProcessTip: 'পেইড সেকেন্ডারি প্রসেসিং প্রক্রিয়া রয়েছে, মুছে ফেলে আবার সংরক্ষণ করুন',
      setSingleRegularSize: 'একক আউটপুটের জন্য সাধারণ গর্ত ও স্লটের আকার সেট করুন',
      holeRange: 'গর্তের কার্যকর পরিসর',
      slotRange: 'স্লটের কার্যকর পরিসর',
      holeRangeTip: 'গর্তের কার্যকর পরিসর খালি রাখা যাবে না, অনুগ্রহ করে পূরণ করুন!',
      slotRangeTip: 'স্লটের কার্যকর পরিসর খালি রাখা যাবে না, অনুগ্রহ করে পূরণ করুন!',
      yhzc: 'চাপ-বাঁকানো অংশের সরল স্লট',
      xbgy: 'বেভেল Haitang কোণ ও বেভেল হ্যান্ডেল',
      nbyx: 'অভ্যন্তরীণ অনিয়মিত আকৃতি',
      secondaryProcessingMerge: 'সেকেন্ডারি প্রসেসিং ফাইল একত্রীকরণ',
      secondaryProcessingMergeName: 'একত্রিত ফাইলের নাম',
      secondaryProcessingMergeTip: 'চালু থাকলে, রপ্তানিকৃত প্যানেলে একাধিক সেকেন্ডারি প্রক্রিয়া থাকলে একই প্রসেসিং ফাইলে একত্রিত হবে',
      singleFileSetting: 'বেভেল এজ, চেরি ব্লসম কর্নার ও স্ল্যান্টেড হ্যান্ডেল সহ সিঙ্গেল ফাইল প্রক্রিয়াকরণ আউটপুট করুন',
      straightArcSlot: 'আর্ক-বেন্ট অংশে স্ট্রেইট স্লট সহ সিঙ্গেল ফাইল প্রক্রিয়াকরণ আউটপুট করুন'
      },
    aioMachineSetting: {
      openFunction: 'ডকিংয়ের জন্য নিচের ফাংশনগুলো সক্ষম করতে হবে',
      openCarving: 'খোদাই মেশিন সক্ষম করুন',
      xyReverseFunction: 'XY অক্ষ সোয়াপ ফাংশন',
      carvingStartSet: 'খোদাই মেশিনের স্টার্ট পজিশন সেট করুন',
      rightTop: 'ডান উপরে',
      carvingEdgeSet: 'খোদাই মেশিনের সামনের এজ ট্রিমিং মান অ্যাডজাস্ট করুন',
      finalEdgeSame: 'চূড়ান্ত ট্রিমিং মানের মতোই',
      beginCode: 'প্রোগ্রাম স্টার্ট কোড',
      endCode: 'প্রোগ্রাম এন্ড কোড',
      drillHole: 'ড্রিল হোল',
      pullTrough: 'স্লট টানুন',
      showDataTemp: 'ডেটা নমুনা দেখান',
      dataTemp: 'ডেটা নমুনা',
      title: 'অল-ইন-ওয়ান মেশিন সেটিংস',
      outputFile: 'অল-ইন-ওয়ান মেশিন প্রসেসিং ফাইল আউটপুট',
      outputFileTips: 'অল-ইন-ওয়ান মেশিন চালু করলে XY ইন্টারচেঞ্জ, ফাইল মার্জ ও অনিয়মিত ছিদ্র না ভেদের সাথে সামঞ্জস্যপূর্ণ নয়, সতর্কভাবে ব্যবহার করুন',
      fileType: 'ফাইল ফরম্যাট',
      select: 'অনুগ্রহ করে নির্বাচন করুন',
      diameter: 'ট্রিমিং টুলের ব্যাস',
      jidongTip: 'ইস্ট-জাপান ইন্টিগ্রেটেড মেশিন ব্যবহারে এনগ্রেভিং স্টেশনের সূচনাবিন্দু উপরের ডান কোণে সেট করুন এবং সক্রিয় করুন',
      skill: 'ফাংশন',
      clampHandLength: 'গ্রিপার দৈর্ঘ্য(L)',
      clampHandWidth: 'গ্রিপার প্রস্থ(W)',
      clampHandMargin1: 'ক্ল্যাম্প হ্যান্ড ১ মার্জিন(H1)',
      clampHandMargin2: 'ক্ল্যাম্প হ্যান্ড ২ মার্জিন(H2)',
      duchClampHand: 'গর্ত খাঁজ ক্ল্যাম্প হ্যান্ড অবস্থান এড়ায়',
      clampHandDirection: 'হ্যান্ড দিক',
      left: 'বাম',
      right: 'ডান',
      top: 'উপরে',
      bottom: 'নিচে'
      },
    oneDragTwo: {
      title: 'এক টু টু এনগ্রেভিং মেশিন',
      outputMachineFile: 'এক টু টু এনগ্রেভিং মেশিন প্রসেসিং ফাইল আউটপুট',
      outputMachineFileTips: 'এক টু টু এনগ্রেভিং মেশিন চালু করলে কাটিং মেশিনের ফাইল মার্জ সামঞ্জস্যপূর্ণ নয়, সতর্কভাবে ব্যবহার করুন',
      fileType: 'ফাইল ফরম্যাট',
      select: 'অনুগ্রহ করে নির্বাচন করুন',
      machineStart: 'ওয়ার্কস্টেশনের সূচনাবিন্দু',
      positionClose: 'বন্ধ করার সময় কাটিং প্যারামিটারে ওয়ার্কস্টেশনের সূচনাবিন্দু সেটিং অনুসরণ করবে',
      engravingPlus: 'র্যাপিড এনগ্রেভিং মেশিন'
      },
    sawEngraving: {
      title: 'কাট ও এনগ্রেভিং মেশিন',
      preLayNav: 'কাট ও এনগ্রেভিং মেশিন সেটিংস',
      preLayKnifeInput: 'কাটিং ব্লেডের ক্রস কাটিং ব্লেড ব্যাস',
      enableSaw: 'কাট ও এনগ্রেভিং মেশিন সক্ষম করুন',
      sawAioTip: 'আপনার ওয়েল্ডিং প্লেট AIO আউটপুটের অনুমতি নেই, সক্রিয় করতে বিক্রয় বিভাগের সাথে যোগাযোগ করুন',
      cutSet: 'ওয়েল্ডিং প্লেট কাটিং সেটিংস',
      weldingPlank: 'ওয়েল্ডিং প্লেট',
      doorFrame: 'ওয়েল্ডিং প্লেট',
      doorFrameTip1: 'কাটিং ব্লেডের ব্যবহার',
      doorFrameTip2: '2.কাটিং ব্লেডের ব্যবহার 3.কাটিং ব্লেডের ব্যবহার',
      sawUsing: 'কাটিং ব্লেডের ব্যবহার',
      trim: 'ট্রিমিং',
      cutBlank: 'কাটিং ও ব্ল্যাঙ্কিং',
      backTrimOblique: 'পিছনের প্রান্ত ট্রিমিং',
      holeSlotOblique: 'পিছনের প্রান্ত ট্রিমিং',
      plankThicknessUnit: 'প্লেটের পুরুত্ব স্ট্যাকিং',
      sawUseCond: 'কাটিং ব্লেড ব্যবহারের শর্ত',
      exportPartData: 'ছোট বোর্ড ডেটা ফাইল আউটপুট (ban, mpr, xml ইত্যাদি)',
      sawAioTip2: 'নন-ফ্লিপিং ডেটা কাটিং অল-ইন-ওয়ান মেশিনে প্রযোজ্য',
      hasUsing: 'উপলব্ধ পথ থাকলে ব্যবহার করুন',
      onlyUse: 'প্রয়োজনে ব্যবহার করুন',
      cutMethod: 'কাটিং পদ্ধতি',
      oneKnifePull: 'এক কোপে বড় বোর্ড কাটা',
      onlyOneKnifePull: 'প্রয়োজনে এক কোপে সরাসরি টানুন',
      enableSawThick: 'কাটিং ব্লেড বেধ লেআউট সক্ষম করুন',
      edgedDir: 'সিল করা বড় বোর্ডের প্রান্ত যা আর কাটা হবে না',
      sameWidthPart: 'প্রতিটি বড় বোর্ডে একই প্রস্থের ছোট বোর্ডই রাখুন',
      emptyPath: 'ছোট প্লেট কাটার সময় খালি পাথ তৈরি হয় না',
      sawUsePlank: 'ওয়েল্ডিং প্লেটে কাটিং ব্লেড দিয়ে কাটা',
      paibanGap: 'ওয়েল্ডিং প্লেট লেআউট ফাঁক',
      minSurplusWidthDiff: 'ন্যূনতম স্ক্র্যাপ ম্যাচিং প্রস্থের পার্থক্য',
      minSurplusWidthDiffTip: 'ছোট বোর্ড ও অবশিষ্ট উপকরণের প্রস্থের পার্থক্য এই মানের চেয়ে কম হলে তবেই ছোট বোর্ড অবশিষ্টে রাখা হবে',
      sawReplaceEnable: 'ছোট বোর্ড ও অবশিষ্ট উপকরণের প্রস্থের পার্থক্য এই মানের চেয়ে কম হলে তবেই ছোট বোর্ড অবশিষ্টে রাখা হবে',
      minSawLength: 'ছোট বোর্ড ও অবশিষ্ট উপকরণের প্রস্থের পার্থক্য এই মানের চেয়ে কম হলে তবেই ছোট বোর্ড অবশিষ্টে রাখা হবে',
      keepDistance: 'ছোট বোর্ড ও অবশিষ্ট উপকরণের প্রস্থের পার্থক্য এই মানের চেয়ে কম হলে তবেই ছোট বোর্ড অবশিষ্টে রাখা হবে',
      keepDistanceTip: 'দ্রষ্টব্য: সন্নিহিত বোর্ডকে কাটাতে বাকি থাকা স্থান রাখতে হবে',
      sortByLength: 'প্ল্যাঙ্ক দৈর্ঘ্য অনুযায়ী সাজান',
      sortByLengthTip: 'কাটিং দিক নিচ থেকে ওপরে; প্রস্থ দিয়ে আগে, তারপর দৈর্ঘ্য দিয়ে সাজান',
      plankAtTop: 'ছোট বোর্ড উপরে',
      plankAtBottom: 'ছোট বোর্ড নিচে',
      useSawTipOne: 'সক্রিয় করার পর কেবল ক্যাবিনেটে ওয়েল্ডিং প্লেট বৈশিষ্ট্যের ছোট প্লেটই কাটিং ব্লেডে প্রসেস হবে, নন-ওয়েল্ডিং প্লেট সোজা চাকুতে কাটা হবে',
      useSawTipTwo: '"কাস্টম লার্জ বোর্ড লেআউট সিকোয়েন্স" চালু করলে স্ট্যান্ডার্ড বড় বোর্ড লেআউটে ব্যবহার হবে না; মিশ্র লেআউট চাইলে স্পেশাল লার্জ বোর্ডে ওয়েল্ড ও হানিকম্ব বোর্ডের ডেটা যোগ করুন',
      useSaiTipThree: 'এই ফাংশন চালু করার পর নেস্টিং সলিউশনে sawing লেআউট ব্যবহার করতে হবে',
      surplusStoreAndLabeling: 'কাটার পর অবশিষ্ট উপকরণ সংরক্ষণ ও লেবেল প্রিন্ট করা যাবে',
      surplusMinLength: 'অবশিষ্ট উপকরণের ন্যূনতম ব্যবহারযোগ্য দৈর্ঘ্য',
      surplusMinSize: 'অবশিষ্ট উপকরণের ন্যূনতম ব্যবহারযোগ্য আকার',
      crossCutOnlyMinSurplusSize: 'অবশিষ্ট উপকরণ ন্যূনতম ব্যবহারযোগ্য আকার পূরণ করলেই কেবল ক্রস-কাট পথ তৈরি হবে',
      surplusStoreAndLabelingTip: '১、বড় বোর্ডের ওপর বা নিচে নীল অবশিষ্ট অঞ্চল তৈরি হবে, স্বাভাবিক সংরক্ষণ ও লেবেল প্রিন্ট করা যাবে',
      surplusStoreAndLabelingTip2: '২、ওয়েল্ডিং প্লেটে "অবশিষ্ট উপকরণ স্বয়ংক্রিয় কাটিং" কার্যকর হবে না）',
      surplusStoreAndLabelingTip3: '（সক্রিয় করার পর',
      backCutSurplus: 'উল্টো দিক থেকে অবশিষ্ট উপকরণ কেটে নিন',
      cutSurplusTip: 'সক্রিয় করার পর রিভার্স সাইড ট্রিমিং অর্ডার "রিভার্স সাইড স্লট মেশিনিং এর পর ট্রিম" এ সেট করুন',
      top: 'উপরে',
      bottom: 'নিচে',
      left: 'বাম',
      right: 'ডান',
      dockTip: 'বাট ওয়েল্ডিং প্লেট প্রসেসিংয়ের জন্য আয়তক্ষেত্র প্লেটের চার দিক সিলিং ও ট্রিমিংয়ের মত, এবং একক সারি লেআউটে ম্যানুয়াল অপারেশন প্রয়োজন',
      sawToLayoutTip: 'সক্রিয় করার পর লেআউটে ছোট বোর্ডের মাঝে কেবল কাটিং ব্লেড বেধের সমান কাটিং গ্যাপ রাখা হবে',
      sawToLayoutTip2: 'স sawing লেআউট ফাংশন বর্তমানে ব্ল্যাঙ্কিং কাটার নির্দিষ্ট করা সমর্থন করে না',
      tempPaiabanTip: 'কাটিং ব্লেড কাটিং চালু করার পর লেআউটে সরাসরি অনিয়মিত প্লেট যোগ করা সমর্থিত নয়; যোগ করতে চাইলে কাটিং লিস্টে গিয়ে যোগ ও লেআউট করুন',
      generateCutSurplusPath: 'প্রথমে অবশিষ্ট উপকরণ কেটে ফেলার ক্রসকাট পাথ তৈরি করুন',
      curSurplusPathTip: 'সক্রিয় করার পর রিভার্স ট্রিমিং অর্ডার "রিভার্স হোল/স্লট মেশিনিং এর পর ট্রিম" এ সেট করুন'
      },
    robotArmDocking: {
      autoLine: 'স্বয়ংক্রিয় লাইন ডকিং',
      autoLineTip: 'স্বয়ংক্রিয় লাইন সংযোগ ব্যবহারের অনুমতি নেই বা স্বয়ংক্রিয় লাইন সংযোগের সংখ্যা যা আপনি খুলতে পারেন নাই',
      title: 'রোবট আর্ম ডকিং',
      enable: 'রোবট আর্ম ডকিং সক্ষম করুন',
      enableTip: 'সক্রিয় করার পর প্রোডাকশন ফাইল আউটপুট করার সময় রোবট আর্ম ডকিং ফাইল আউটপুট হবে'
      },
    laserCuttingMachine: {
      title: 'লেজার কাটিং অল-ইন-ওয়ান মেশিন',
      enable: 'লেজার কাটিং অল-ইন-ওয়ান মেশিন সক্ষম করুন',
      backSafeHeight: 'পিছনের দিক অলস থাকলে Z উচ্চতা(H)',
      laserDistance: 'সামনে/পিছনে কাটার সময় লেজার ছুরি ও বোর্ড পৃষ্ঠের মধ্যে দূরত্ব',
      coordinateAxis: 'কোঅর্ডিনেট অক্ষ',
      xAxis: 'X',
      yAxis: 'Y',
      zAxis: 'Z',
      cuttingSettings: 'কাটিং সেটিংস',
      backKnifeStore: 'পিছনের ছুরি স্টোর',
      noSupportOriginalMaterialKnife: '"অরিজিনাল ম্যাটেরিয়াল কাটিং নাইফ সিলেকশন" ফাংশন বর্তমানে সমর্থিত নয়',
      laserKnifeTip: 'কাটিং ওপেন: ভেতরের যে শেপগুলো ছিদ্র করা হয়নি সেগুলো প্রসেস করার জন্য',
      laserKnifeTip2: 'লেজার ছুরি: ছিদ্র করা হোল/স্লট, ভেতরের শেপ, বাইরের কনট্যুর কাটিং প্রসেসিং',
      laserKnifeTip3: 'নোট: পিছনের Z অক্ষ ডিফল্টে টেবিল পৃষ্ঠ থেকে দূরত্বের সাথে সঙ্গতিপূর্ণ রিলেটিভ কোঅর্ডিনেট ব্যবহার করে',
      laserKnifeTip4: 'ছুরির সংখ্যা ১ এর কম হতে পারবে না',
      laserKnifeTip5: 'কাটিং ওপেন ছুরি মুছে ফেলা যাবে না',
      laserKnifeTip6: 'কাটিং ওপেনের জন্য কোনো ছুরি নির্বাচিত নেই সনাক্ত করা হয়েছে, অনুগ্রহ করে অন্তত একটি ছুরি নির্বাচন করুন',
      laserKnifeTip7: 'লেজার ছুরি ভেতরের যে শেপগুলো কাটা হয়নি সেগুলো প্রসেস করতে পারে না, "কাটিং ওপেন" অপশন স্বয়ংক্রিয়ভাবে আনচেক করা হয়েছে',
      laserKnifeTip8: 'ছুরি স্টোরে "কাটিং ওপেন" অপশন সহ ছুরি নির্বাচন করুন, অন্যথায় ভেতরের যে শেপগুলো কাটা হয়নি সেগুলো প্রসেস করা যাবে না',
      laserKnifeTip9: 'কাটিং ওপেন ছুরি স্টোরের লেজার ছুরির ব্যাস ইন্টিগ্রেটেড লেজার মেশিনের লেজার ছুরির ব্যাসের সাথে সামঞ্জস্যপূর্ণ নয়, অনুগ্রহ করে পরীক্ষা করুন',
      laserKnifeTip10: 'কাটিং ওপেন ছুরি স্টোরের কাটিং ওপেন ছুরির ব্যাস ইন্টিগ্রেটেড লেজার মেশিনের কাটিং ওপেন ছুরির ব্যাসের সাথে সামঞ্জস্যপূর্ণ নয়, অনুগ্রহ করে পরীক্ষা করুন',
      laserKnifeTip11: 'সরঞ্জাম ডকিং প্যারামিটার পরিবর্তন করা হয়েছে, অনুগ্রহ করে পুনরায় লেআউট করুন',
      noLaserPermission: 'ইন্টিগ্রেটেড লেজার মেশিন ব্যবহারের অনুমতি নেই, ব্যবহারের আগে সেলসের সাথে যোগাযোগ করে লেজার মেশিন ব্যবহারের অনুমতি কিনুন',
      laserOpenCode: 'লেজার খোলন কোড',
      laserCloseCode: 'লেজার বন্ধ কোড',
      laserToolSettings: 'লেজার টুল সেটিংস'
      },
    firstSave: 'ব্যবহারকারী প্রথমবার ক্লাউড টাইপসেটিং ব্যবহার করছেন সনাক্ত করা হয়েছে, সেটিংস সংরক্ষণের পর ফাইলে ট্রিমিং দিক যুক্তিসঙ্গত কিনা খেয়াল করুন যাতে অপ্রয়োজনীয় ক্ষতি এড়ানো যায়',
    knives: {
      xOffset1: 'X কোঅর্ডিনেট অফসেট',
      yOffset1: 'Y কোঅর্ডিনেট অফসেট',
      zOffset1: 'Z কোঅর্ডিনেট অফসেট',
      insert: 'একটি সারি সন্নিবেশ করুন',
      delete: 'সারিটি মুছুন',
      tip: '（নোট: টুল লাইব্রেরি তথ্য পরিবর্তন বা সেটিংস সামঞ্জস্য করার পর ক্যাবিনেট লেআউট প্রোডিউসিং ব্যবহারকারীদের সর্বশেষ পরিবর্তন প্রয়োগ করতে ক্যাবিনেট ক্লায়েন্ট রিস্টার্ট করতে হবে）',
      number: 'নম্বর',
      name: 'নাম',
      diameter: 'ব্লেড ব্যাসΦ',
      sawDiameter: 'কাটিং ব্লেড বেধΦ',
      cutting: 'কাটিং ম্যাটেরিয়াল',
      use: 'উদ্দেশ্য',
      moveZF: 'Z অক্ষ দ্রুত চলাচলের গতি',
      axis_offset: 'অক্ষ অফসেট সেটিং',
      arc_radius: 'আর্ক রেডিয়াস সেটিং',
      cutZF: 'Z অক্ষ প্রসেসিং গতি',
      moveF: 'XY অক্ষ দ্রুত চলাচলের গতি',
      cutF: 'XY অক্ষ প্রসেসিং গতি',
      startCode: 'টুল চেঞ্জের জন্য স্টার্ট কোড',
      stopCode: 'টুল চেঞ্জ এন্ড কোড',
      startCode2: 'টুল চেঞ্জ শুরু করার জন্য কোড',
      stopCode2: 'টুল চেঞ্জ এন্ড কোড',
      knifeLength: 'ছুরির দৈর্ঘ্য',
      maximum_single_depth: 'একবারে প্রসেসিংয়ের সর্বোচ্চ গভীরতা',
      specialShapeKnifeTip: 'কেবল ভেতরের অনিয়মিত শেপের জন্য প্রযোজ্য',
      preStartCode: 'প্রি-স্টার্ট কোড',
      punchHoles: 'পাঞ্চ হোল',
      pullSlots: 'Pull Slot',
      millHoles: 'মিলিং হোল',
      millSlots: 'মিলিং স্লট',
      sawBlade: 'করাতের ব্লেড',
      doubleSaw: 'দুই স্টেশনের ভিন্ন টুল চেঞ্জ স্টার্ট কোড সক্রিয় করুন',
      singleStation: 'সিঙ্গেল স্টেশন',
      doubleStation: 'দুই স্টেশন',
      sawBladeTip: 'এই ফিচারটি ১-টু-২ এনগ্রেভিং মেশিন এবং অল-ইন-ওয়ান মেশিনে কাজ করে না',
      serialNum: 'ক্রমিক নম্বর',
      sawWidth: 'ছুরির প্রস্থ',
      sawType: 'কাটিং ব্লেড টাইপ',
      cutDirection: 'কাটিং দিক',
      moveSpeed: 'খালি গতি',
      cutSpeed: 'প্রসেসিং গতি',
      endCode: 'টুল চেঞ্জের জন্য এন্ড কোড',
      sawDownCode: 'নামানোর কোড',
      sawUpCode: 'টুল-অফ কোড',
      abscissa: 'অ্যাবসিসার উপসর্গ',
      ordinate: 'অর্ডিনেটের উপসর্গ',
      sawHor: 'ক্রস-কাটিং কাটিং ব্লেড',
      sawVer: 'ভার্টিক্যাল কাটিং ব্লেড',
      towardsZero: '০ পয়েন্ট কোঅর্ডিনেটের দিকে কাটুন',
      awayFromZero: '০ কোঅর্ডিনেট থেকে দূরে কাটুন',
      diameterDesc: 'ছুরির ব্যাস Φ',
      xOffset: 'হরাইজন্টাল কোঅর্ডিনেট অফসেট',
      yOffset: 'ভার্টিক্যাল কোঅর্ডিনেট অফসেট',
      zOffset: 'এলিভেশন কোঅর্ডিনেট অফসেট',
      offsetX: 'অফসেট X',
      offsetY: 'অফসেট Y',
      offsetZ: 'অফসেট Z',
      offsetNo: 'অফসেট নম্বর',
      knifeWidth: 'ছুরির প্রস্থ',
      drill: 'নামানো',
      cut: 'প্রসেসিং',
      speed: 'গতি',
      type: 'টাইপ',
      millHoleSlot: 'মিলিং হোল/স্লট',
      rapidFeedSpeed: 'র্যাপিড ফিড স্পিড',
      typeOption1: 'বিট',
      typeOption2: 'মিলিং কাটার',
      typeOption3: 'স্টাইলিং ছুরি',
      typeTip: 'টুল টাইপ সেট করার পর হোল স্লট মেশিনিংয়ের জন্য সংশ্লিষ্ট টাইপের টুলের সাথে মিলবে'
      },
    other: {
      title: 'অন্যান্য',
      tip: 'সিঙ্গেল স্টেশন সরঞ্জামের জন্য স্টেশন ১ ও স্টেশন ২ উভয়েই একই অটো ফিডিং কোড দেওয়া আবশ্যক'
      }
    },
  sideHoleMachine: {
    moreSetting: 'আরও সেটিংস',
    sideStartCode: 'প্রান্ত প্রসেসিং ফেস চেঞ্জ কোড জেনারেট করে',
    useArcCode: 'আর্ক ইন্টারপোলেশন নির্দেশ দিয়ে আর্ক কাটুন',
    coordSwitch: 'কোঅর্ডিনেট রেফারেন্স সোয়াপ',
    updownCoordSwitch: 'লিফটিং কোঅর্ডিনেট রেফারেন্স সোয়াপ',
    xCoordSwitch: 'হরাইজন্টাল কোঅর্ডিনেট রেফারেন্স সোয়াপ',
    yCoordSwitch: 'ভার্টিক্যাল কোঅর্ডিনেট রেফারেন্স সোয়াপ',
    knifes: {
      number: 'নম্বর',
      diameter: 'ব্লেডের প্রস্থ',
      type: 'টাইপ',
      moveSpeed: 'র্যাপিড ফিড স্পিড',
      doSpeed: 'মেশিনিং স্পিড',
      startCode: 'টুল চেঞ্জ স্টার্ট কোড',
      endCode: 'টুল চেঞ্জ এন্ড কোড'
      },
    ymSetting: 'Yimu কানেকশন সেটিংস',
    flanking: 'সাইড প্রসেসিং',
    frontProcess: 'ফ্রন্ট প্রসেসিং',
    oldSetting: 'পুরোনো সংস্করণের সেটিংস',
    equipParamsSetting: 'ইকুইপমেন্ট প্যারামিটার সেটিংস',
    holeSetting: 'হোল সেটিংস',
    raminoSetting: 'Ramino কানেকশন সেটিংস',
    mortiseTenonSetting: 'মর্টিস-টেনন কানেকশন সেটিংস',
    straight: 'স্ট্রেইট টাইপ',
    eccentric: 'একসেন্ট্রিক টাইপ',
    pbSize: 'উপর/নিচ ব্রেকিং বোর্ডের সাইজ',
    slotOverlapRate: 'মিলিং স্লট ওভারল্যাপ রেট',
    breakingBoardDirection: 'উপর/নিচ ব্রেকিং বোর্ডের দিক',
    coordinateValue: 'কোঅর্ডিনেট ভ্যালু',
    codeFormat: 'ফাইল এনকোডিং ফরম্যাট',
    suffixSetting: 'ফাইল সাফিক্স সেটিংস',
    insertRow: 'সারি যোগ করুন',
    deleteRow: 'সারি মুছুন',
    equipmentParams: {
      equipPauseCode: 'ইকুইপমেন্ট পজ কোড',
      wiggleCode: 'দোলন কোড',
      equipStartCode: 'যন্ত্র চালু করার কোড:',
      flipPauseCode: 'ফ্লিপের জন্য পজ কোড',
      equipEndCode: 'যন্ত্র শেষ করার কোড:',
      equipStartCodePlaceholder: 'ডিভাইস স্টার্ট কোড লিখুন',
      retractingCode: 'টুল রিট্র্যাকশন কমান্ড কোড',
      retractingCodePlaceholder: 'টুল রিট্র্যাকশন কমান্ড কোড লিখুন',
      flipPauseCodePlaceholder: 'ফ্লিপ পজ কোড লিখুন',
      equipEndCodeTip: 'ইকুইপমেন্ট এন্ড কোড লিখুন',
      sideChangeSetting: 'সাইড ফেস চেঞ্জ সেটিং',
      workTip: 'ডিফল্টভাবে বাম পাশে ① থেকে শুরু করে ঘড়ির কাঁটার বিপরীত দিকে প্রসেস করা হয়',
      frontTurnCode: 'উপরের শুরু কোড:',
      frontTurnEndCode: 'উপরের শেষ কোড',
      frontTurnCodePlaceholder: 'উপরের শুরু কোড লিখুন',
      frontTurnEndCodePlaceholder: 'উপরের শেষ কোড লিখুন',
      leftTurnCode: 'বাম পাশের শুরু কোড:',
      leftTurnEndCode: 'বাম পাশের শেষ কোড:',
      leftTurnCodePlaceholder: 'বাম পাশের শুরু কোড লিখুন',
      leftTurnEndCodePlaceholder: 'বাম পাশের শেষ কোড লিখুন',
      downTurnCode: 'নিচের শুরু কোড:',
      downTurnEndCode: 'নিচের শেষ কোড:',
      downTurnCodePlaceholder: 'নিচের শুরু কোড লিখুন',
      downTurnEndCodePlaceholder: 'নিচের শেষ কোড লিখুন',
      rightTurnCode: 'ডান পাশের শুরু কোড:',
      rightTurnEndCode: 'ডান পাশের শেষ কোড:',
      rightTurnCodePlaceholder: 'ডান পাশের শুরু কোড লিখুন',
      rightTurnEndCodePlaceholder: 'ডান পাশের শেষ কোড লিখুন',
      topFlipCode: 'ফ্লিপ কোড - উপর',
      downFlipCode: 'ফ্লিপ কোড - নিচ',
      leftFlipCode: 'ফ্লিপ কোড - বাম',
      rightFlipCode: 'ফ্লিপ কোড - ডান',
      cylinderOutCode: 'সিলিন্ডার আউট কোড',
      cylinderbackCode: 'সিলিন্ডার রিট্র্যাক্ট কোড',
      cylinderbackDirective: 'সিলিন্ডার রিট্র্যাক্ট কমান্ড',
      moveDirective: 'মুভ নির্দেশ',
      moveAxisCode: 'মুভ অ্যাক্সিস',
      pushAxisCode: 'সিলিন্ডার পুশ অ্যাক্সিস',
      swingAxisCode: 'সুইং অ্যাক্সিস',
      moveCode: 'মুভ কোড',
      punchCode: 'মেশিনিং কোড',
      free: 'খালি চলাচল',
      punchPart: 'মেশিনিং অংশ',
      cutFaceCode: 'প্রসেসিং প্লেন কোড',
      horVerCutFace: 'হরাইজন্টাল ও ভার্টিক্যাল প্লেন',
      horCutFace: 'হরাইজন্টাল লিফটিং প্লেন',
      verCutFace: 'ভার্টিক্যাল লিফটিং প্লেন',
      specifySmallBoardMaterialNoCut: 'নির্দিষ্ট ছোট বোর্ড মেটেরিয়াল কাটবে না',
      specifySmallBoardMaterialNoCutTip: 'মেটেরিয়ালে সংশ্লিষ্ট কীওয়ার্ড থাকা বোর্ডগুলোতে শুধু ৫/৬-ফেস ড্রিল দিয়ে মেশিনিং করা হোল/স্লট ফাইল তৈরি হবে, কাটিং হবে না',
      addMaterialKeyword: 'মেটেরিয়াল কীওয়ার্ড যোগ করুন',
      keyword: 'কীওয়ার্ড'
      },
    tagPool: 'ডেটা ট্যাগ পুল',
    dragTip: 'ট্যাগ পুলের ট্যাগগুলো ড্র্যাগ করা যাবে',
    knives: 'মেশিনিং টুলস:',
    directives: 'মেশিনিং নির্দেশ:',
    slot: 'স্ট্রেইট স্লট মেশিনিং',
    cirWork: 'আর্ক মেশিনিং',
    cirInter: 'সার্কুলার ইন্টারপোলেশন',
    cirOption1: 'ঘড়ির কাঁটার দিকে: G03 বিপরীত দিকে: G02',
    cirOption2: 'ঘড়ির কাঁটার দিকে: G02 বিপরীত দিকে: G03',
    coordinate: {
      xPointSymbol: 'X কোঅর্ডিনেট:',
      yPointSymbol: 'Y কোঅর্ডিনেট:',
      zPointSymbol: 'Z কোঅর্ডিনেট:',
      upright: 'ধনাত্মক মান',
      negative: 'ঋণাত্মক মান'
      },
    encodeFormat: {
      format: 'ফাইল এনকোডিং ফরম্যাট:',
      wrap: 'লাইন ব্রেক ফরম্যাট সেটিং:',
      formatOption1: 'UTF-8 ফরম্যাট',
      formatOption2: 'ANSI ফরম্যাট'
      },
    suffix: 'ফাইল সাফিক্স সেটিং:',
    enableFP: 'ফ্রন্ট প্রসেসিং চালু করুন',
    slotSetting: 'স্লট সেটিং',
    slotMillSetting: 'স্লট টানা/মিলিং হোল-স্লট সেটিং',
    millSlot: 'মিলিং হোল ও গ্রুভ সাপোর্ট করে',
    millingSlotOverlapRate: 'মিলিং স্লট ওভারল্যাপ রেট',
    millingHoleSlotOverlapRate: 'মিলিং হোল/স্লট ওভারল্যাপ রেট',
    takeUpDirective: 'টুল রিট্র্যাকশন কমান্ড',
    workSeparately: 'ফ্রন্ট/ব্যাক থ্রু স্লট দুই ভাগে প্রসেস করুন',
    secondSlotLong: 'দ্বিতীয় অংশের স্লট দৈর্ঘ্য',
    enableOld: 'পুরোনো সাইড হোল মেশিন সেটিং চালু করুন',
    default: 'ডিফল্ট সেটিং',
    customizable1: 'কাস্টম ১',
    customizable2: 'কাস্টম ২',
    customizable3: 'কাস্টম ৩',
    customizable4: 'কাস্টম ৪',
    knifeSetting: 'টুল সেটিং',
    soltTip: '(মিলিং হোল/স্লটসহ)',
    specialSetting: 'বিশেষ সেটিং',
    ramino: 'Ramino',
    sun: 'মর্টিস-টেনন',
    please: 'শিগগিরই আসছে',
    designatedKnives: 'নির্দিষ্ট টুল',
    designated: 'নির্দিষ্ট',
    workOrder: 'মেশিনিং কমান্ড',
    other: 'অন্যান্য',
    nameSetting: 'সাফিক্স নাম সেটিং',
    repeatErr: 'নম্বর ডুপ্লিকেট, দয়া করে পুনরায় সেট করুন'
    },
  electronicSaw: {
    importMaterial: 'ম্যাটেরিয়াল লিস্ট ইমপোর্ট করুন',
    formSetting: 'ইলেকট্রনিক স’ ফর্ম সেটিং',
    fileFormat: 'কাটিং লিস্ট আউটপুট ফাইল ফরম্যাট:',
    isSmallFile: 'ছোট বোর্ড ইমেজ ফাইল এক্সপোর্ট করুন:',
    fileGroupRule: 'ইলেকট্রনিক স’ ফাইল রঙ/মেটেরিয়াল/বোর্ডের পুরুত্ব অনুযায়ী আলাদা টেবিলে ভাগ করুন:',
    roomsByCategory: 'ইলেকট্রনিক স’ ফাইল রুম অনুযায়ী আলাদা টেবিলে ভাগ করুন:',
    delimiter: 'ডিলিমিটার:',
    fileName: 'কাটিং লিস্ট ফাইল নাম:',
    fineNameTip: 'কাটিং লিস্ট ফাইল নাম খালি হতে পারে না!',
    fileNamePlaceholder: 'কাস্টম কাটিং লিস্ট',
    outputFileEncoding: 'আউটপুট লিস্ট এনকোডিং ফরম্যাট:',
    utf8: 'BOMসহ UTF-8',
    cellTab: 'সেল ট্যাব(	) তৈরি করুন:',
    texture: 'টেক্সচার প্রদর্শন:',
    special: 'বিশেষ আকৃতি (ইরেগুলার) প্রদর্শন:',
    notSpecial: 'বিশেষ আকৃতি নয়',
    genSimpleLabelBarcode: 'সহজ ফরম্যাট লেবেল বারকোড তৈরি করুন',
    uniqueBarCode: 'বোর্ডের বারকোড ইউনিক',
    uniqueBarCodeTip: 'এটি চালু করলে “সহজ ফরম্যাট লেবেল বারকোড তৈরি” ফিচারটি কাজ করবে না',
    roboticArmDocking: 'রোবটিক আর্ম ডকিং',
    customeForm: 'কাস্টম ফর্ম',
    tagPool: 'ডেটা ট্যাগ পুল',
    tagPoolTips: 'ট্যাগ পুলের ট্যাগগুলো ড্র্যাগ করুন বা ক্লিক করে কপি করুন',
    displayHead: 'টেবিল হেডার দেখাবেন না',
    addTableHead: 'টেবিল হেডার যোগ করুন',
    deleteTableHead: 'টেবিল হেডার মুছুন',
    generateExample: 'আউটপুট ফর্ম নমুনা তৈরি করুন',
    importExample: 'ফর্ম নমুনা ইমপোর্ট করুন',
    importExampleTip: 'ইমপোর্ট করা ফর্ম নমুনা শুধুমাত্র ইলেকট্রনিক স’ কাস্টমাইজ করার জন্য রেফারেন্স',
    importExampleErrTip: 'এখনো ম্যাটেরিয়াল লিস্ট ইমপোর্ট করা হয়নি, আগে ম্যাটেরিয়াল লিস্ট ইমপোর্ট করুন',
    outputExample: 'আউটপুট ফর্ম নমুনা',
    outputExampleTip: 'কাস্টম ফর্মের আউটপুট নমুনা',
    outputExampleErrTip: 'আউটপুট ফর্ম নমুনা এখনো তৈরি হয়নি, আগে তৈরি করুন',
    defaultTableHead: 'ডিফল্ট টেবিল হেডার',
    deleteHeadErrTip: 'মুছার মতো কোনো টেবিল হেডার নেই!',
    genNonString: 'নন-টেক্সট ডাটা টাইপ তৈরি করুন',
    genNonStringTip: 'তৈরি করা টেবিল ডাটা ইলেকট্রনিক স’ চিনতে না পারলে এটি চালু করে দেখুন',
    revertWidth: 'আড়াআড়ি দানাযুক্ত বোর্ডের দৈর্ঘ্য/প্রস্থ সোয়াপ'
    },
  lockModal: {
    passwordInput: 'পাসওয়ার্ড লিখুন',
    lockPassword: 'আনলক পাসওয়ার্ড',
    lockPasswordInput: 'আনলক পাসওয়ার্ড লিখুন',
    passwordInputPlaceholder: '৪ সংখ্যার পাসওয়ার্ড লিখুন',
    editPassword: 'পাসওয়ার্ড পরিবর্তন করুন',
    confirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
    setLockPwd: 'আনলক পাসওয়ার্ড সেট করুন',
    pwdFormatErr: 'পাসওয়ার্ড ফরম্যাট ভুল',
    sendMessageTo: 'SMS যাচাই কোড পাঠানো হবে',
    captchaPlaceholder: 'যাচাই কোড লিখুন',
    sendCaptcha: 'যাচাই কোড পাঠান',
    sendSeccess: 'SMS পাঠানো সফল',
    sendFail: 'SMS পাঠানো ব্যর্থ, পরে আবার চেষ্টা করুন',
    updateSeccess: 'পাসওয়ার্ড সেট করা সফল',
    editSuccess: 'পাসওয়ার্ড পরিবর্তন সফল',
    lockSeccess: 'আনলক সফল',
    lock: 'আনলক',
    lockSeccessTip: 'লক সফল',
    inputErrLimit: 'বর্তমান ভুলের সংখ্যা সীমায় পৌঁছেছে, আনলক পাসওয়ার্ড পুনরায় সেট করুন!'
    },
  dock56Drill: {
    equipType: 'ডিভাইস টাইপ',
    equipment: 'ডিভাইস',
    fiveDock: '৫-পাশ ড্রিল',
    sixDock: '৬-পাশ ড্রিল',
    fileType: 'জেনারেট হওয়া ফাইল টাইপ',
    templateOffline: 'ব্যবহৃত টেমপ্লেটটি বন্ধ/অফলাইনে নেওয়া হয়েছে!',
    showExample: 'ডাটা নমুনা দেখান',
    conNoticeTip: 'ডকিং নোটস:',
    conNoticeTip1: '1) "XY অক্ষ সোয়াপ" চালু থাকলে ৫/৬-পাশ ড্রিলের বিশেষ টেমপ্লেট ব্যবহার করতে হবে',
    conNoticeTip2: '2) ৫/৬-পাশ ড্রিলে বোর্ডের বিশেষ আকৃতি দেখাতে/মেশিনিং করতে টেমপ্লেটে বিশেষ আকৃতির ডাটা কনফিগার করতে হবে',
    conNoticeTip3: '3) ৫/৬-পাশ ড্রিল প্রথমবার ব্যবহার বা টেমপ্লেট বদলানোর পর <span style="color:#f00">ক্যাবিনেট টেস্ট প্রোডাকশন</span> করুন, ঠিক আছে নিশ্চিত হলে পরে নিয়মিত প্রোডাকশন করুন',
    conNoticeTip4: '4) টেস্ট প্রোডাকশনে সামনের/পিছনের হোল-স্লটের সাইজ, গভীরতা, কোন ফেসে আছে এবং অবস্থান ঠিক কিনা ভালোভাবে পরীক্ষা করুন, <span style="color:#f00">ক্যাবিনেট মিররিং</span> সমস্যা এড়ান',
    example: 'ডাটা নমুনা',
    commonSetting: 'কমন প্যারামিটার সেটিংস',
    throughHoleSetting: 'থ্রু-হোল দুই পাশে ভাগ করে ড্রিল',
    throughSlotSetting: 'থ্রু-স্লট দুই পাশে ভাগ করে ড্রিল/কাট',
    nonHolesNotFiles: 'রেক্ট্যাঙ্গুলার বোর্ডে হোল/স্লট না থাকলে ফাইল আউটপুট হবে না:',
    frontFileIdentifier: 'ফ্রন্ট ফাইল আইডেন্টিফায়ার:',
    oppositeFileIdentifier: 'ব্যাক ফাইল আইডেন্টিফায়ার:',
    oppositeFileIdentifierTips: 'জেনারেট হবে: মূল ১৩-সংখ্যার পার্ট কোড + আইডেন্টিফায়ার ক্যারেক্টার',
    arcDescription: 'আর্ক বর্ণনার পদ্ধতি',
    linePoints: 'লাইন সেগমেন্ট ফর্মেশন বর্ণনা',
    arcCommand: 'আর্ক কমান্ড বর্ণনা',
    slotWidthSplit: 'চওড়া স্লটকে একাধিক সরু স্লটে ভাগ করে প্রসেস করুন:',
    slotSplitWidth: 'ভাগ করার পরে একক স্লটের প্রস্থ:',
    mm: 'নোট: স্প্লিট টার্গেট হলো সাধারণ রেক্ট্যাঙ্গুলার স্লট',
    isNotMergeSlot: 'একই প্রস্থ/গভীরতার পাশের স্লটগুলো মার্জ করে থ্রু করুন:',
    slotPunchTip: 'এই ফিচারটি শুধু কাস্টম টেমপ্লেট ব্যবহার করা ব্যাকবোর্ড স্লট ও ড্রয়ার বটম স্লটে প্রযোজ্য',
    sizeRange: 'পাশের সাইজ ≤',
    enableWorningTip: 'এই ফিচারটি “ফ্রন্ট এজ প্লেসমেন্ট ডিরেকশন”-এর সাথে একসাথে চালু করা যাবে না',
    longDirection: 'বোর্ডের দীর্ঘ পাশ প্লেসমেন্ট দিক',
    horizontal: 'অনুভূমিক',
    vertical: 'উল্লম্ব',
    slotDirection: '৫/৬-পাশ ড্রিল স্লট বা বিশেষ আকৃতি প্লেসমেন্ট দিক',
    default: 'সিস্টেম ডিফল্ট',
    frontLeft: 'ফ্রন্ট ও বাম',
    frontRight: 'ফ্রন্ট ও ডান',
    backLeft: 'ব্যাক ও বাম',
    backRight: 'ব্যাক ও ডান',
    frontDirection: 'ফ্রন্ট এজ প্লেসমেন্ট দিক',
    enableTip: 'নোট: শুধু ক্লাউড লেআউটে কার্যকর',
    fixedOn: 'স্থির থাকবে:',
    front: 'সামনে',
    back: 'পিছনে',
    left: 'বাম',
    right: 'ডান',
    coordinateValue: 'কোঅর্ডিনেট ভ্যালুর দশমিক ঘর সংখ্যা:',
    decimalPlaces: 'দশমিক ঘর',
    slotLengthCompensation: 'স্লট দৈর্ঘ্য কম্পেনসেশন',
    curveholesLengthCompensation: 'ইনার স্পেশাল শেপ ক্লিয়ার কর্নার',
    slotCompensationEqualZero: 'দূরত্ব ০ হলে স্লট এজ কম্পেনসেশন',
    slotCompensationNotEqualZero: 'দূরত্ব ০ নয় হলে স্লট এজ কম্পেনসেশন',
    slotCompensationTip: 'গোলো কর্নার ঠিকমতো না কাটলে বা দৈর্ঘ্য কম হলে এই ফিচার ব্যবহার করুন',
    curveholesCompensationEqualZero: 'দূরত্ব ০ হলে ইনার স্পেশাল এজ কম্পেনসেশন',
    curveholesCompensationTip: 'প্রস্তাবিত ইনপুট: ইনার স্পেশাল শেপ কাটার টুলের রেডিয়াস',
    curveholesCompensationTip2: 'বোর্ড কনট্যুরের বাইরের রেক্ট্যাঙ্গুলার এজ অনুযায়ী ইনার স্পেশাল শেপ কাটার সময় ছোট গোল কর্নার ঠিকমতো না কাটলে এই ফিচার ব্যবহার করুন',
    specialParameter: 'বিশেষ প্যারামিটার সেটিংস',
    output5FDrillSlotKnifeCode: 'XML2 মিলিং স্লট টুল নম্বর',
    output5FDrillShapeKnifeCode: 'XML2 মিলিং শেপ টুল নম্বর',
    plankTexture: 'XML2 বোর্ড টেক্সচার',
    offset: 'XML2 মিলিং শেপ টুল কম্পেনসেশন',
    mprConHoleDir: '৫/৬-ফেস ড্রিল MPR ফাইলের সাইড হোল Z কোঅর্ডিনেট রেফারেন্স প্লেন',
    plankTop: 'বোর্ডের উপরের পৃষ্ঠ',
    plankBottom: 'বোর্ডের নিচের পৃষ্ঠ',
    codeInfo: 'ban ফরম্যাট ফাইলে Code তথ্য থাকবে:',
    bomFile: 'bom ফরম্যাট ফাইল আউটপুট করুন:',
    plankHeight: 'বোর্ড উচ্চতার বর্ণনা:',
    plankNum: 'বোর্ড নম্বরের বর্ণনা:',
    backZpoint: 'ব্যাক স্লট Z কোঅর্ডিনেট:',
    plankThick: 'বোর্ডের পুরুত্ব',
    slotDeep: 'স্লট গভীরতা',
    outputMprFile: 'ফাইল টাইপ',
    oldMPR: 'পুরোনো MPR',
    newMPR: 'নতুন MPR',
    mprFileZside: '৫/৬-ফেস ড্রিল MPR ফাইলে সাইড হোলের Z-অ্যাক্সিস রেফারেন্স প্লেন',
    fileTypeOffline: 'বর্তমান নির্বাচিত ৫/৬-ফেস ড্রিল ফাইল টাইপটি অফলাইন হয়েছে, দয়া করে নিশ্চিত করুন!',
    permissionErr: 'পরিচয় তথ্য হারিয়ে গেছে, দয়া করে Guigui থেকে এই পৃষ্ঠাটি আবার খুলুন!',
    banFileSetting: 'ban ফরম্যাট ফাইল সেটিংস',
    banFileCodeInfo: 'ban ফরম্যাট ফাইলে Code তথ্য অন্তর্ভুক্ত থাকে:',
    huahuaLine: 'Huahua অটোমেটিক লাইন',
    huahuaLineTip: '(লেবেল রাখার মান স্থানীয় স্ট্যান্ডার্ড সাথে অসমর্থ)',
    huahuaPartFlag: {
      longSide: 'দীর্ঘ পাশ <',
      shortSide: 'অথবা ছোট পাশ <',
      partFlag: 'এর বোর্ডগুলোর জন্য ছোট বোর্ড আইডি তৈরি করুন',
      tip: '（লেবেলে দেখাতে “বোর্ড আইডি-ছোট বোর্ড মার্ক” ডেটা যোগ করতে হবে, Huahua অটোমেটিক লাইন ফাইলে সংশ্লিষ্ট ডেটা স্বয়ংক্রিয়ভাবে যোগ হবে）'
      },
    plankPutWay: 'বোর্ড রাখার পদ্ধতি',
    plankPutWayTip: 'যদি বর্তমান উন্নতি লাইন সক্রিয় করা হয়, তবে বোর্ড রাখার পদ্ধতি সেটিং সমর্থিত নয়',
    autoHandle: 'ক্ল্যাম্প স্বয়ংক্রিয় এভয়েড',
    manualHandle: 'ম্যানুয়াল এভয়েড সেটিং',
    fixedFront: 'ফ্রন্ট এজ ব্যান্ডিং ফিক্সড',
    plankNamePlacement: 'বোর্ড নাম অনুযায়ী স্থাপন',
    plankNamePlacementTip1: '1. সেট করার পর, বোর্ড নামে নির্ধারিত ফিল্ড থাকলে সংশ্লিষ্ট বোর্ড প্রান্ত সেটিং অনুযায়ী ডিভাইসের নির্দিষ্ট পাশে স্থির হবে',
    plankNamePlacementTip2: '2. এই সেটিংয়ের অগ্রাধিকার উপরের বোর্ড রাখার পদ্ধতি সেটিংয়ের চেয়ে বেশি',
    plankNamePlacementTip3: '3. এই ফাংশন শুধুমাত্র ক্লাউড লেআউটে কার্যকর; বর্তমান প্রোডাকশন লাইনে Huahua অটোমেটিক লাইন চালু থাকলে আলাদা বোর্ড স্থাপন সেটিং সমর্থিত নয়',
    addRow: 'সারি যোগ করুন',
    plankNameTip: 'বোর্ডের নাম লিখুন',
    plankSide: 'বোর্ড প্রান্ত',
    deviceSide: 'ডিভাইসে স্থির',
    weldingPlatePlacementEnable: 'ওয়েডিং বোর্ড ফ্রন্ট সফট ক্ল্যাম্প',
    onlyBluen: 'শুধুমাত্র ক্লাউড লেআউটে কার্যকর',
    fixedEdge: 'ফ্রন্ট এজ ব্যান্ডিং ফিক্সড',
    fixedEdgeRule: 'নিয়ম: বোর্ড প্রসেসিং ক্ষেত্রে বিকল্প নির্বাচন করা',
    fixedEdgeRuleItem1: 'দীর্ঘ পাশ ক্ল্যাম্পের কাছাকাছি',
    fixedEdgeRuleItem2: 'ফ্রন্ট এজ ব্যান্ডিং ফিক্সড',
    fixedEdgeRuleItem3: 'ফ্রন্ট এজ ব্যান্ডিং ফিক্সড',
    fixedEdgeRuleItem4: 'প্রাথমিক ক্রম',
    satisfiedCondition: 'প্রাথমিক ক্রম',
    handDirection: 'ক্ল্যাম্পের অবস্থানের দিক',
    handleMachineTip: 'ঘোরানোর মাধ্যমে হোল/স্লট ও স্পেশাল শেপ স্বয়ংক্রিয়ভাবে ক্ল্যাম্প থাকা পাশ এড়িয়ে চলে, ফলে বোর্ড প্রসেসিং সহজ হয়',
    handleWidth: 'ক্ল্যাম্পের প্রস্থ',
    handleLength: 'ক্ল্যাম্পের দৈর্ঘ্য',
    handleMaxWidth: 'সর্বোচ্চ প্রসেসযোগ্য প্রস্থ',
    usefulRange: 'কার্যকর পরিসর',
    plankLongSide: 'বোর্ডের দীর্ঘ পাশ',
    usefulRangeTip: 'বোর্ডের দীর্ঘ পাশ প্লেসমেন্ট চালু থাকলে এবং দীর্ঘ পাশ এই কার্যকর পরিসরের মধ্যে থাকলে স্লট ও স্পেশাল শেপের অবস্থানকে আগে নির্ধারণ করা হবে',
    moveTip: 'ফ্রন্ট/ব্যাক ফাইল আইডেন্টিফায়ারের ফিচারটি এখানে স্থানান্তর করা হয়েছে',
    millingOuter: 'বাইরের স্পেশাল শেপ মিলিং',
    millingInner: 'ভেতরের স্পেশাল শেপ মিলিং',
    drilling: 'হোল মেশিনিং',
    slotting: 'স্লট মেশিনিং',
    knivesTip1: '1) স্পেশাল শেপ মিলিং টুল সেট করার পর কাটিং পাথ টুলের রেডিয়াস অনুযায়ী কম্পেনসেট করবে',
    knivesTip2: '2) স্পেশাল শেপ কাটিং বর্তমানে XY অক্ষ অদলবদল সমর্থনকারী এনগ্রেভিং মেশিনে সাপোর্ট করে না',
    internalCutting: 'ইনার স্পেশাল শেপ কাটিংয়ে টুল ডাউন ও টুল রিট্র্যাক্ট—দুটোই বোর্ডের ভেতরের দিকে হয়',
    externalCutting: 'আউটার স্পেশাল শেপ কাটিংয়ে টুল ডাউন ও টুল রিট্র্যাক্ট—দুটোই বোর্ডের বাইরের দিকে হয়',
    externalCuttingDirection: 'আউটার স্পেশাল শেপ কাটিংয়ে স্পেশাল শেপ থাকা পুরো এজ একসাথে কাট হবে',
    allExternalCutting: 'সব আউটার স্পেশাল শেপ',
    onlyArcExternalCutting: 'শুধু বাইরের আর্ক স্পেশাল শেপ'
    },
  doorWallCabinet: {
    tempErrTip: 'আপনি দরজা-দেয়াল-ক্যাবিনেট একীভূত মেশিনের ব্যবহৃত টেমপ্লেট যোগ করেননি, তাই প্রক্রিয়াকরণ ফাইল এক্সপোর্ট করা যাচ্ছে না। নোট: যোগ করার পর পুনরায় লেআউট করতে হবে।',
    title: 'দরজা-দেয়াল-ক্যাবিনেট একীভূত মেশিন',
    guifang: 'বর্গাকরণ',
    processingTechnology: 'প্রক্রিয়া প্রযুক্তি',
    longPlateSecondarySquaring: 'ডিফল্ট ফরম্যাট ফাইল আউটপুট করুন',
    slotOnDoorPlate: 'দরজা প্লেটের লাল',
    setting: 'দরজা-দেয়াল-ক্যাবিনেট একীভূত মেশিন সেটিং'
    },
  PTP: {
    title: 'PTP',
    outputFileFormat: 'আউটপুট ফাইল ফরম্যাট',
    outputDefaultFileFormat: 'ডিফল্ট ফরম্যাটের ফাইল আউটপুট করুন',
    outputMPRFormat: 'MPR ফরম্যাট ফাইল আউটপুট করুন',
    fileFormatSettings: 'ফাইল ফরম্যাট সেটিংস',
    wrapSettings: 'লাইন ব্রেক ফরম্যাট সেটিংস:',
    enCodeSettings: 'ফাইল এনকোডিং ফরম্যাট সেটিংস:',
    utf8bom: 'BOM সহ UTF-8',
    partCoordinate: 'ছোট বোর্ডের কোঅর্ডিনেট',
    xPointSymbol: 'অনুভূমিক (X) কোঅর্ডিনেট:',
    yPointSymbol: 'উল্লম্ব (Y) কোঅর্ডিনেট:',
    zPointSymbol: 'লিফট (Z) কোঅর্ডিনেট:',
    upRight: 'ধনাত্মক মান',
    negative: 'ঋণাত্মক মান',
    plankMirroring: 'বোর্ড মিররিং',
    plankMirrorSetting: 'বোর্ড মিররিং সেটিংস:',
    xAxis: 'X-অ্যাক্সিস মিরর',
    yAxis: 'Y-অ্যাক্সিস মিরর',
    mirrorTip: '（বোর্ড মিরর করার সময় এই ফিচারটি ব্যবহার করুন）',
    knifeTable: {
      type: 'ধরন',
      diameter: 'ব্যাস Φ',
      offsetX: 'অফসেট X',
      offsetY: 'অফসেট Y',
      offsetZ: 'অফসেট Z',
      offsetNo: 'অফসেট নম্বর',
      drillVelocity: 'ডাউন কাট গতি [F]mm/min',
      cutVelocity: 'মেশিনিং গতি [F]mm/min',
      rotationSeep: 'ঘূর্ণন গতি [S]r/min',
      insertRow: 'রো ইনসার্ট করুন',
      deleteRow: 'রো ডিলিট করুন'
      },
    labelPool: 'ডেটা লেবেল পুল',
    dragTip: 'লেবেল পুল থেকে ইনপুট বক্সে লেবেল ড্র্যাগ করুন বা ক্লিক করে কপি করুন',
    procedure: 'প্রোগ্রাম',
    beginCode: 'প্রোগ্রাম শুরুর কোড:',
    endCode: 'প্রোগ্রাম শেষের কোড:',
    zzdKnifeBeginCode: 'স্পিন্ডল টুল চেঞ্জ শুরুর কোড:',
    spindleCutter: 'স্পিন্ডল কাটার',
    zzdKnifeEndCode: 'স্পিন্ডল টুল চেঞ্জ শেষের কোড:',
    verticalDrill: 'ভার্টিক্যাল ড্রিল',
    czzBeginCode: 'ভার্টিক্যাল ড্রিল স্টার্টআপ কোড:',
    czzEndCode: 'ভার্টিক্যাল ড্রিল শাটডাউন কোড:',
    czzKnifeBeginCode: 'ভার্টিক্যাল ড্রিল টুল চেঞ্জ শুরুর কোড:',
    czzKnifeEndCode: 'ভার্টিক্যাল ড্রিল টুল চেঞ্জ শেষের কোড:',
    sidetrack: 'সাইড ড্রিল',
    czBeginCode: 'সাইড ড্রিল স্টার্টআপ কোড:',
    czEndCode: 'সাইড ড্রিল শাটডাউন কোড:',
    czKnifeBeginCode: 'সাইড ড্রিল টুল চেঞ্জ শুরুর কোড:',
    czKnifeEndCode: 'সাইড ড্রিল টুল চেঞ্জ শেষের কোড:',
    pauseCode: 'পজ কোড:',
    zSafeHeight: 'নিরাপদ দূরত্ব',
    spindleKnife: 'মেইন স্পিন্ডল কাটার ও ভার্টিক্যাল ড্রিলের Z-অ্যাক্সিস সেফটি হাইট',
    sideDrillZ: 'সাইড ড্রিল Z-অ্যাক্সিস সেফটি হাইট',
    sideDrillXY: 'সাইড ড্রিল X/Y-অ্যাক্সিস সেফটি ডিস্ট্যান্স',
    auxiliaryFunction: 'সহায়ক ফাংশন',
    xhDedicatedInfo: 'Xinghui ডিভাইসের জন্য ডেডিকেটেড তথ্য তৈরি করুন',
    xhCheckBox: 'ডেটা:',
    outputSettings: 'আউটপুট সেটিংস:',
    partExegesis: 'ফাইলে ছোট বোর্ড সাইজের নোট/কমেন্ট তৈরি করুন',
    knifeNo: 'টুল নম্বর',
    specailKnifeNo: 'স্পেশাল শেপ মেশিনিং টুল নম্বর:',
    slotKnifeNo: 'স্লট কাটিং টুল নম্বর:',
    fileNamePlaceholder: 'কাস্টম কাটিং লিস্ট',
    slotDrill: 'স্ট্রেইটেনার নাইফ'
    },
  glassEquip: {
    title: 'গ্লাস কাটিং মেশিন',
    fileType: 'প্রসেসিং ফাইল টাইপ:',
    sizeReparation: 'বোর্ড সাইজ কম্পেনসেশন:',
    cutPreSpace: 'বোর্ড কাটিংয়ের জন্য রিজার্ভড স্পেসিং:',
    divideIntoFolders: 'কাচের রঙ/মেটেরিয়াল/পুরুত্ব অনুযায়ী ফাইলগুলো আলাদা ফোল্ডারে ভাগ করুন:'
    },
  translate: {
    search: 'এন্ট্রি খুঁজতে চীনা বা অফিসিয়াল অনুবাদ লিখুন',
    en: 'ইংরেজি',
    es: 'স্প্যানিশ',
    ar: 'আরবি',
    kz: 'কাজাখ',
    vi: 'ভিয়েতনামি',
    th: 'থাই',
    id: 'ইন্দোনেশীয়',
    ug: 'উইঘুর',
    customTranslate: 'ক্লিক করে কাস্টম অনুবাদ যোগ করুন',
    customText: 'কাস্টম অনুবাদ',
    text: 'চীনা',
    targetLang: 'অফিসিয়াল অনুবাদ',
    zh_hant: 'চীনা (ট্র্যাডিশনাল)'
    },
  preLayoutSetting: {
    title: 'প্রি-লেআউট সেটিংস',
    titleTip: 'আগে লেআউট প্যারামিটার প্রিসেট করে লেআউট করুন, তারপর প্রোডাকশন লাইন নির্বাচন করুন',
    settingTip: 'প্রোডাকশন ফাইল এক্সপোর্ট করতে উৎপাদন লাইনে সেট করা প্যারামিটারগুলো নিচের প্রি-লেআউট প্যারামিটারগুলোর সাথে一致 হতে হবে, শুধুমাত্র কাটিং মেশিনে প্রযোজ্য',
    emptyKnife: 'টুল পূরণ করা হয়নি',
    noModify: 'সেটিংসে কোনো পরিবর্তন নেই, সংরক্ষণ প্রয়োজন নেই',
    reSet: 'পুনরুদ্ধার',
    gayPosition: 'ধূসর স্কোয়ার দিয়ে উদ্বৃত্ত উপকরণ রাখার অবস্থান বদলানো যায়',
    surplusPosition: 'এটি বর্তমান উদ্বৃত্ত উপকরণ রাখার অবস্থান',
    click: 'ক্লিক করুন',
    grayStart: 'ধূসর স্কোয়ার দিয়ে ওয়ার্কস্টেশনের শুরু পয়েন্ট বদলানো যায়',
    currentStart: 'এটি বর্তমান ওয়ার্কস্টেশনের শুরু পয়েন্ট',
    holeSlotSetting: 'থ্রু হোল/স্লট মেশিনিং সেটিংস',
    knifeDiameter: 'কাটিং টুলের ব্যাস',
    currentVersion: 'বর্তমান সংস্করণ',
    on: 'চালু',
    off: 'বন্ধ',
    firstShort: 'প্রথম কাট-ছোট পাশে অতিরিক্ত মার্জিন',
    firstLong: 'প্রথম কাট-দীর্ঘ পাশে অতিরিক্ত মার্জিন',
    cuttingSplitLong: 'দীর্ঘ বোর্ড দুইবার কাট-দীর্ঘ পাশ অতিক্রম',
    cuttingSplitShort: 'দীর্ঘ বোর্ড দুইবার কাট-ছোট পাশ অতিক্রম',
    plankThick: 'সাধারণ বোর্ডের পুরুত্ব ≥ ',
    singleDoorThick: 'দরজার বোর্ডের পুরুত্ব ≥ ',
    normalPlank: 'সাধারণ বোর্ড',
    confilictTip: 'সেটিংস কনফ্লিক্ট আছে: {confilictTotal}টি',
    selectLine: 'প্রোডাকশন লাইন নির্বাচন করুন',
    selectLinePlaceholder: 'দয়া করে প্রোডাকশন লাইন নির্বাচন করুন',
    lineConfilictTip: 'নির্বাচিত প্রোডাকশন লাইনটি {line} এর সাথে কনফ্লিক্ট করছে',
    preWay: 'প্রি-লেআউট পরিকল্পনা',
    paibanErrTip: 'দীর্ঘ বোর্ড প্রসেসিংয়ের 【দীর্ঘ/ছোট পাশে মার্জিন】 পরিবর্তন হলে লেআউট ব্যর্থ হতে পারে',
    paibanTip: 'এই লেআউটে বড় বোর্ডের মেটেরিয়ালের জন্য কাটিং টুল নির্দিষ্ট আছে, পুনরায় লেআউট করতে হবে',
    reLayout: 'বর্তমান প্রোডাকশন লাইন দিয়ে পুনরায় লেআউট করুন',
    fetchErr: 'প্রি-লেআউট সেটিংস আনতে ব্যর্থ হয়েছে',
    resetSuccess: 'পুনরুদ্ধার সফল',
    resetConfirm: 'আপনি কি নিশ্চিতভাবে ইতিহাসের সংস্করণে ফিরিয়ে নিতে চান?',
    prolineName: 'প্রোডাকশন লাইনের নাম',
    layoutGap: 'লেআউট গ্যাপ',
    generalThickness: 'দ্বিতীয় কাটিং অবজেক্ট-সাধারণ বোর্ডের পুরুত্ব',
    cutGeneralPlank: 'দ্বিতীয় কাটিং অবজেক্ট-সাধারণ বোর্ড',
    cutSingleDoor: 'দ্বিতীয় কাটিং অবজেক্ট-ডোর প্যানেল',
    secondary_cutting_board_list: 'নির্দিষ্ট বোর্ড নাম ও কাটিং বোর্ড পিসের নামের তালিকা',
    changeProline: 'প্রোডাকশন লাইন পরিবর্তন করুন',
    backTip: 'প্রোডাকশন লাইন নির্বাচন করতে গ্লোবাল লেআউটে ফিরে যান',
    preLayout: 'প্রি-লেআউট পরিকল্পনা অনুযায়ী লেআউট করুন',
    preWayEmpty: '(খালি) প্রি-লেআউট পরিকল্পনা',
    specialConfilictTip: 'আর্ক মিলিং বটম প্রক্রিয়া লেআউট ফলাফলে প্রভাব ফেলেছে, পুনরায় লেআউট করতে হবে'
    },
  lunbo: {
    tips: 'অপারেটিং টিপস',
    introduction: 'ফিচার পরিচিতি',
    qtDownloadText: 'সৌজন্যমূলক স্মরণ: ডাউনলোড করা ফাইল অসম্পূর্ণ হলে ক্লাউড লেআউট ওয়েবপেজে গিয়ে ডাউনলোড করুন!'
    },
  sendModal: {
    paibanImgType: 'লেআউট ইমেজ ফাইলের ধরন'
    },
  authenticationModal: {
    title: 'স্ক্যান করে অনুমোদন যাচাই',
    tip: 'অনুমোদন সফল হওয়ার আগে ডায়ালগটি বন্ধ করবেন না!',
    countdownTip: '{countdown} পরে মেয়াদ শেষ হবে',
    refreshTip: 'QR কোড রিফ্রেশ করুন',
    qrcodeTip: 'অপারেশন সম্পন্ন করতে WeChat দিয়ে QR কোড স্ক্যান করুন',
    qrcodeTip2: 'স্ক্যান করে সংরক্ষণ ব্যর্থ হলে “Guigui সাধারণ সেটিংস - ব্যবহারকারী অনুমোদন সেটিংস”-এ আপনাকে সিস্টেম পরিবর্তনের অনুমতি দিতে হবে।',
    waiting: 'স্ক্যানের জন্য অপেক্ষা করছে',
    scanning: 'স্ক্যান হয়েছে, নিশ্চিতকরণের অপেক্ষা করছে',
    success: 'যাচাই সফল হয়েছে',
    error: 'যাচাই ব্যর্থ হয়েছে',
    expired: 'QR কোডের মেয়াদ শেষ হয়ে গেছে',
    tip2: 'আপনার অ্যাকাউন্ট ডেটার নিরাপত্তার জন্য বর্তমান অপারেটরের তথ্য যাচাই করা প্রয়োজন',
    tip3: 'পরীক্ষামূলক উৎপাদনের ক্যাবিনেটটি হতে হবে, {fontStyleStart}অসমমিত ক্যাবিনেট বডি, ক্যাবিনেট মিররিং এড়াতে{fontStyleEnd} সমস্যা'
    },
  printTag: {
    dualLanguageTip: 'আপনার চীনা-ইংরেজি দ্বিভাষিক লেবেল তৈরির অনুমতি নেই, বর্তমানে শুধু প্রিভিউ সম্ভব; স্থায়ী ব্যবহারের জন্য সেলসের সঙ্গে যোগাযোগ করে চালু করুন~',
    generateDualLanguageTagTip: 'চীনা-ইংরেজি দ্বিভাষিক লেবেল তৈরি করুন',
    dualLanguageTip2: 'এই ফিচারটি পেইড। ব্যবহারের আগে চালু করতে সেলস টিমের সঙ্গে যোগাযোগ করুন~',
    effectiveDataSource: 'প্রভাবশালী ডেটা উত্স',
    partName: 'বোর্ডের নাম'
    },
  userAccessToken: {
    createTime: 'তৈরির সময়',
    lastUsedTime: 'সর্বশেষ ব্যবহারের সময়',
    expireTime: 'মেয়াদ শেষের সময়',
    status: 'স্ট্যাটাস',
    tokenNamePlaceholder: 'টোকেনের নাম লিখুন',
    expireTimeSelectPlaceholder: 'মেয়াদ শেষের সময় নির্বাচন করুন',
    securityBannerTip: 'আপনার ব্যক্তিগত অ্যাক্সেস টোকেন অন্যদের সাথে শেয়ার করবেন না বা ব্রাউজার বা অন্যান্য ক্লায়েন্ট কোডে প্রকাশ করবেন না। আপনার অ্যাকাউন্ট সুরক্ষার জন্য, প্রকাশ্যে ফাঁস হওয়া টোকেন স্বয়ংক্রিয়ভাবে নিষ্ক্রিয় করা হতে পারে।',
    expired: 'মেয়াদ শেষ',
    valid: 'বৈধ',
    remove: 'সরান',
    previewOnceWarning: 'এই টোকেন শুধুমাত্র একবার দেখানো হয়। এই গোপনীয়তা নিরাপদে সহজলভ্য জায়গায় সংরক্ষণ করুন। অন্যদের সাথে শেয়ার করবেন না বা ব্রাউজার বা অন্যান্য ক্লায়েন্ট কোডে প্রকাশ করবেন না।',
    token: 'টোকেন',
    deleteConfirm: 'আপনি কি নিশ্চিত যে এই টোকেনটি মুছে ফেলতে চান?',
    userAccessToken: 'ব্যবহারকারী অ্যাক্সেস টোকেন',
    dayUnit: 'দিন',
    custom: 'কাস্টম',
    previewModalTitle: 'নতুন ব্যক্তিগত অ্যাক্সেস টোকেন',
    addModalTitle: 'নতুন ব্যক্তিগত অ্যাক্সেস টোকেন যোগ করুন'
    },
  bujianStore: {
    inputPlaceholder: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন',
    noData: 'কোন ডেটা নেই',
    loadingErr: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন',
    bujianStore: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন',
    awaitStore: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন',
    noDrag: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন',
    outOfCanvas: 'পালান্ক বারকোড খুঁজুন সাপ্লিমেন্ট ছোট প্ল্যান্ক খুঁজুন'
    },
  alginTexture: {
    tip: 'এই কার্যকলাপটি বোর্ডের টেক্সচার অ্যালাইনমেন্ট তথ্য মুছে ফেলবে। আপনি কি চালিয়ে যেতে চান?',
    tip2: 'এই কার্যকলাপটি প্যানেলগুলির মধ্যে দূরত্ব পরিবর্তন করবে এবং প্রক্রিয়াজাত সমস্যা সৃষ্টি করবে। আপনি কি চালিয়ে যেতে চান?',
    group: 'টেক্সচার গোরুপ',
    groupTemp: 'টেক্সচার গোরুপ এক',
    textureAlignmentPlank: 'টেক্সচার অ্যালাইনমেন্ট প্যানেল সরানো যাচ্ছে না'
    },
  customizeFolder: {
    customizeFolder: 'ফোল্ডার কাস্টমাইজেশন',
    customizeFolderTip: 'নোট: ফোল্ডার কাস্টমাইজেশন সক্রিয় করার পর, আগে সেট করা ফোল্ডার বিভাজন নিয়মগুলো আর কার্যকর হবে না',
    processingFilesTitle: 'ফাইল ডেটা প্রসেসিং',
    dragToFolderTip: 'বাম ফোল্ডারে সাবফোল্ডার বা ফাইল হিসেবে টেনে নিয়ে যাওয়া যেতে পারে',
    folderNameEmpty: 'ফোল্ডারের নাম ফাঁকা রাখা যাবে না',
    folderNameExists: 'একই নামের ফোল্ডার বিদ্যমান',
    fileNotFound: 'সঠিক ফাইল প্রাপ্ত করতে ব্যর্থ',
    fileCannotBeClassified: 'এই ধরনের ফাইলটি কোনো শ্রেণীবিভাগ ফোল্ডারের নীচে রাখা যায় না',
    cannotAddAtThisPosition: 'এই অবস্থানে যোগ করা যায় না',
    fileAlreadyExists: '【{name}】এই ফোল্ডারে ইতিমধ্যে বিদ্যমান',
    confirmDeleteFolder: 'আপনি কি এই ফোল্ডারটি মুছতে চান?',
    confirmDeleteItem: 'আপনি কি 【{name}】 মুছতে চান?',
    confirmDeleteFolderWithChildren: 'এই ফোল্ডারের নীচে অন্যান্য ফোল্ডার/ফাইল আছে, আপনি কি এটি মুছতে চান?',
    deleteFile: 'ফাইল মুছুন',
    addSubFolder: 'সাবফোল্ডার যোগ করুন',
    editFolder: 'ফোল্ডার সম্পাদনা করুন',
    deleteFolder: 'ফোল্ডার মুছুন',
    rootCannotDelete: 'রুট ডিরেক্টরি মুছে ফেলা যায় না',
    newFolder: 'নতুন ফোল্ডার',
    fileUsedCanDrag: 'ব্যবহার করা হয়েছে - বারবার টেনে নিয়ে যাওয়া যেতে পারে',
    fileDraggable: 'টেনে নিতে পারে',
    addFileToFolder: '【{fileName}】কে {folderName} এ যোগ করুন',
    addFolderTitle: 'ফোল্ডার যোগ করুন',
    editFolderTitle: 'ফোল্ডার সম্পাদনা করুন',
    folderNameLabel: 'ফোল্ডারের নাম',
    folderNamePlaceholder: 'ফোল্ডারের নাম লিখুন',
    sequenceStartLabel: 'বর্ধমান ক্রম শুরুর মান',
    classifyMethodLabel: 'শ্রেণীবিভাগ পদ্ধতি',
    nameLengthLimitLabel: 'ক্যারেক্টার দৈর্ঘ্য সীমা',
    tagInsertTip: 'ফোল্ডারের নামে প্রবেশ করার জন্য ট্যাগটি ক্লিক করুন',
    classifyTagInsertTip: 'ফোল্ডারের নামে প্রবেশ করার জন্য ট্যাগটি ক্লিক করুন, ফাইলগুলো নির্দিষ্ট ট্যাগ অনুসারে শ্রেণীবিভাগ করা হবে',
    engraving_front: 'খোদাই মেশিনের সামনের ফাইল',
    engraving_opposite: 'খোদাই মেশিনের পিছনের ফাইল',
    engraving_merge: 'খোদাই মেশিনের মার্জ ফাইল',
    engraving_mill: 'দ্বিতীয় প্রক্রিয়াকরণ শিংকে গ্রুভ মিলিং',
    engraving_haitang: 'দ্বিতীয় প্রক্রিয়াকরণ বেল্ড Haitang কোণ ফাইল',
    engraving_arc_slot: 'দ্বিতীয় প্রক্রিয়াকরণ মিলিং বোতল চাপ বৃত্তাকার স্লট',
    engraving_line_slot: 'দ্বিতীয় প্রক্রিয়াকরণ কাস্টম টুল পাথ',
    engraving_straight_arc_slot: 'দ্বিতীয় প্রক্রিয়াকরণ চাপ বাঁকা অংশ স্ট্রেইট স্লট',
    engraving_frame_door: 'দ্বিতীয় প্রক্রিয়াকরণ কাচ দরজা ফাইল',
    engraving_inner_shape: 'দ্বিতীয় প্রক্রিয়াকরণ অভ্যন্তরীণ আকার',
    engraving_hole: 'দ্বিতীয় প্রক্রিয়াকরণ সাধারণ গর্ত',
    engraving_slot: 'দ্বিতীয় প্রক্রিয়াকরণ সাধারণ স্লট',
    engraving_single_file_merge: 'দ্বিতীয় প্রক্রিয়াকরণ ফাইল এম্বেড',
    electronic_saw: 'ইলেকট্রনিক করাতা ফাইল',
    glass: 'কাচ কাটার মেশিন ফাইল',
    glass_machine: 'কাচ কাটার মেশিন',
    side_machine: 'পার্শ্ব গর্ত মেশিন ফাইল',
    side_machine_xml3: 'পুরানো সংস্করণ পার্শ্ব গর্ত মেশিন XML3 ফাইল',
    side_machine_txt: 'পুরানো সংস্করণ পার্শ্ব গর্ত মেশিন TXT ফাইল',
    side_machine_nc: 'পুরানো সংস্করণ পার্শ্ব গর্ত মেশিন NC ফাইল',
    dock56F: 'পাঁচ/ছয় পার্শ্ব বোরিং ফাইল',
    ptp: 'PTP ফাইল',
    aio: 'অল-ইন-ওয়ান মেশিন ফাইল',
    aio_anc: 'বহুমুখী মেশিনের সামনের ANC ফাইল',
    labeling_1: 'লেবেলিং মেশিন ফাইল 1',
    labeling_2: 'লেবেলিং মেশিন ফাইল 2',
    labeling_3: 'লেবেলিং মেশিন ফাইল 3',
    robotic_arm: 'রোবোটিক আর্ম ফাইল',
    label_image: 'লেবেল চিত্র ফাইল',
    label_pdf: 'লেবেল PDF ফাইল',
    paiban_image: 'টাইপসেটিং চিত্র ফাইল',
    paiban_pdf: 'টাইপসেটিং চিত্র PDF ফাইল',
    engraving: 'খোদাই মেশিন',
    electronic: 'ইলেকট্রনিক করাতা',
    side_hole: 'পার্শ্ব গর্ত মেশিন',
    drilling: 'পাঁচ/ছয় পার্শ্ব বোরিং',
    labeling: 'লেবেলিং মেশিন',
    robotic: 'রোবোটিক আর্ম',
    label: 'লেবেল',
    warningTip: 'মনে রাখবেন: বক্র বন্ধনী 【{}】 এবং এর ভিতরের বিষয়বস্তু অক্ষত রাখতে হবে, নিজে থেকে মুছে ফেলবেন না বা যোগ করবেন না!',
    fileClassifyError: 'এই ফাইলটি {classifyNames} অনুসারে শ্রেণীবদ্ধ করা যায় না',
    folderClassifyByTextureColorThickSize: 'রঙ, পদার্থ, বেধ, এবং বড় বোর্ড আকার অনুসারে বিভিন্ন ফোল্ডারে শ্রেণীবদ্ধ করুন (লেবেল ফাইল একসাথে)',
    unnamed: 'অনাম',
    specialText: 'বিশেষ',
    surplusText: 'অতিরিক্ত উপাদান',
    normalText: 'স্বাভাবিক',
    plankText1: 'বোর্ড',
    resetTemplate: 'স্বাভাবিক',
    resetTemplateConfirm: 'আপনি কি টেমপ্লেটটি রিসেট করতে চান?',
    clearTemplate: 'টেমপ্লেট মুছুন',
    clearTemplateConfirm: 'আপনি কি টেমপ্লেট মুছতে চান?',
    legendFixedFolder: 'নির্দিষ্ট ফোল্ডার',
    legendClassifyFolder: 'শ্রেণীবদ্ধ ফোল্ডার',
    legendFixedTag: 'নির্দিষ্ট ডেটা',
    legendNormalTag: 'ডায়নামিক ডেটা',
    legendClassifyTag: 'শ্রেণীবদ্ধ ডায়নামিক ডেটা',
    door_wall_aio: 'দরজা-দেয়াল-ক্যাবিনেট একীভূত মেশিন',
    noPermission: 'বর্তমানে আপনার কাস্টম ফোল্ডার ব্যবহারের অনুমতি নেই। ব্যবহারের আগে এটি কিনতে সেলস টিমের সঙ্গে যোগাযোগ করুন।',
    enableCustomFolder: 'কাস্টম ফোল্ডার সক্ষম করুন',
    exporttagTip: 'ট্যাগ পিডিএফ এবং ছবি একসাথে রপ্তানি করার সময়, ডিফল্টভাবে পিডিএফ পাঠানো হয়'
    },
  paibanTask: {
    pausedTip: 'বন্ধ করা কাজ',
    deleteTip: '«{taskBatch}» কাজটি মুছে ফেলা আপনার চেষ্টা করবেন কি? মুছে ফেলার পরে পুনরুদ্ধার করা সম্ভব নয়।',
    continueTip: 'কাজ চালু করুন',
    completed: 'সমাপ্ত',
    failed: 'কাজ ব্যর্থ',
    paused: 'বন্ধ করা কাজ',
    pending: 'কাজ চালু করুন',
    running: 'কাজ চালু করুন',
    extraTip: 'প্ল্যানিং টাস্ক শুধুমাত্র গত সপ্তাহের ডেটা দেখায়। টাস্ক সম্পন্ন করার পর এটি হাতের হাতে সংরক্ষণ করুন!',
    taskStatus: 'কাজের অবস্থা',
    createTaskTip: 'প্ল্যানিং টাস্ক তৈরি করুন, প্ল্যানিং পরে যান',
    taskBatchTitle: 'টাস্ক ব্যাচ',
    relatedOrderNosTitle: 'সম্পর্কিত অর্ডার নম্বর',
    progressTitle: 'লেআউট অগ্রগতি',
    boardCountTitle: 'বোর্ড ব্যবহার গণনা করা হয়নি။',
    optimizedAreaTitle: 'অপ্টিমাইজড এলাকা গণনা করা হয়নি။',
    productionLineTitle: 'উৎপাদন লাইন',
    operationTitle: 'অপারেশন',
    optimizeRateTitle: 'বোর্ড অপ্টিমাইজেশন হার গণনা করা হয়নি။',
    optimizeRateTip: 'স্থানান্তর করা উপাদানের অপ্টিমাইজেশন হার গণনা করা হয়নি။',
    optimizeRateTip2: 'প্ল্যানিং পেজ ভিত্তিক নির্দিষ্ট অপ্টিমাইজেশন হার',
    boardCountTip: 'প্ল্যানিং পেজ ভিত্তিক নির্দিষ্ট ডেক ব্যবহার',
    optimizedAreaTip: 'প্ল্যানিং পেজ ভিত্তিক নির্দিষ্ট অপ্টিমাইজেশন এলাকা',
    paibanSettingTip: 'বর্তমান কাজের প্রোডাকশন লাইন সেটিংস পরিবর্তন করা হয়েছে। বর্তমান লেআউট ফলাফল প্রকৃত উৎপাদন রপ্তানি ফাইলের সাথে দ্বন্দ্বে থাকতে পারে। উৎপাদন পুনরায় লেআউট করার পরামর্শ দেওয়া হচ্ছে।',
    dataException: 'ডেটা অসামগ্য, দয়া করে পৃষ্ঠা রিফ্র্যাশ করুন এবং আবার চেষ্টা করুন'
    },
  paibanSetting: {
    advancedSetting: 'উন্নত সেটিংস',
    advancedFeature: 'উন্নত সেটিংস',
    surplusCutSpeedUp: 'বর্তমান কাজের প্রোডাকশন লাইন সেটিংস পরিবর্তন করা হয়েছে। বর্তমান লেআউট ফলাফল প্রকৃত উৎপাদন রপ্তানি ফাইলের সাথে দ্বন্দ্বে থাকতে পারে। উৎপাদন পুনরায় লেআউট করার পরামর্শ দেওয়া হচ্ছে।',
    surplusCutSpeedUpTip4: 'ফিচার ডেভেলপমেন্ট চলছে, দয়া করে অপেক্ষা করুন',
    surplusCutSpeedUpTip: 'অবশিষ্ট উপাদানের লেআউট ফাঁক স্বয়ংক্রিয়ভাবে 0 সেট হয়',
    surplusCutSpeedUpTip2: 'অবশিষ্ট কাটিং ইতিমধ্যে কাটা ও কিনারা পরিষ্কারের পথ স্বয়ংক্রিয়ভাবে এড়িয়ে কাটার দক্ষতা বাড়ায়',
    surplusCutSpeedUpTip3: 'করাত এনগ্রেভিং মেশিন এবং একটি ঘূর্ণন করাত এনগ্রেভিং মেশিনের জন্য উপযোগিতার জন্য',
    surplusCutSpeedUpTip5: 'করাত এনগ্রেভিং মেশিন এবং একটি ঘূর্ণন করাত এনগ্রেভিং মেশিনের জন্য উপযোগিতার জন্য',
    featureDisplay: 'বৈশিষ্ট্য প্রদর্শন',
    featureDisplayTip: 'এই পৃষ্ঠা শুধুমাত্র ফিচার এন্ট্রি প্রদর্শন নিয়ন্ত্রণ করে; ফিচারের সক্রিয় অবস্থা ও প্যারামিটার কনফিগারেশন পরিবর্তন করে না'
    },
  alignedPlan: {
    deepSearch: 'গভীর অনুসন্ধান',
    deepSearchTip: 'এক্সক্লুসিভ ফিচার: পুনরায় লেআউট করে গণনার গভীরতা বাড়িয়ে আরও ভালো ফল পান',
    deepSearchTip2: 'Deep Search আপগ্রেডের পর পুনরায় লেআউট করে গণনার গভীরতা বাড়ান। এখন ট্রায়াল করা যায়',
    deepSearchTip3: 'Deep Search আরও বোর্ড-সাশ্রয়ী পরিকল্পনা দেয়',
    deepSearchTip4: 'বর্তমানে Deep Search লেআউট অনুমতি নেই। কিনতে সেলসের সাথে যোগাযোগ করুন।',
    deepSearchTip5: 'Deep Search আপগ্রেডের পর নিবেদিত সার্ভার কম্পিউটিং পাবেন। এখন প্রিভিউ করা যায়'
    }
  }